/* 🤖 this file was generated by svg-to-ts */
import { MatIcon } from './mat-icon.model';
import { matIcon10K } from './matIcon-10k.icon';
import { matIcon10Mp } from './matIcon-10mp.icon';
import { matIcon11Mp } from './matIcon-11mp.icon';
import { matIcon12Mp } from './matIcon-12mp.icon';
import { matIcon13Mp } from './matIcon-13mp.icon';
import { matIcon14Mp } from './matIcon-14mp.icon';
import { matIcon15Mp } from './matIcon-15mp.icon';
import { matIcon16Mp } from './matIcon-16mp.icon';
import { matIcon17Mp } from './matIcon-17mp.icon';
import { matIcon18UpRating } from './matIcon-18_up_rating.icon';
import { matIcon18Mp } from './matIcon-18mp.icon';
import { matIcon19Mp } from './matIcon-19mp.icon';
import { matIcon1KPlus } from './matIcon-1k_plus.icon';
import { matIcon1K } from './matIcon-1k.icon';
import { matIcon1XMobiledata } from './matIcon-1x_mobiledata.icon';
import { matIcon20Mp } from './matIcon-20mp.icon';
import { matIcon21Mp } from './matIcon-21mp.icon';
import { matIcon22Mp } from './matIcon-22mp.icon';
import { matIcon23Mp } from './matIcon-23mp.icon';
import { matIcon24Mp } from './matIcon-24mp.icon';
import { matIcon2KPlus } from './matIcon-2k_plus.icon';
import { matIcon2K } from './matIcon-2k.icon';
import { matIcon2Mp } from './matIcon-2mp.icon';
import { matIcon30FpsSelect } from './matIcon-30fps_select.icon';
import { matIcon30Fps } from './matIcon-30fps.icon';
import { matIcon3DRotation } from './matIcon-3d_rotation.icon';
import { matIcon3GMobiledata } from './matIcon-3g_mobiledata.icon';
import { matIcon3KPlus } from './matIcon-3k_plus.icon';
import { matIcon3K } from './matIcon-3k.icon';
import { matIcon3Mp } from './matIcon-3mp.icon';
import { matIcon3P } from './matIcon-3p.icon';
import { matIcon4GMobiledata } from './matIcon-4g_mobiledata.icon';
import { matIcon4GPlusMobiledata } from './matIcon-4g_plus_mobiledata.icon';
import { matIcon4KPlus } from './matIcon-4k_plus.icon';
import { matIcon4K } from './matIcon-4k.icon';
import { matIcon4Mp } from './matIcon-4mp.icon';
import { matIcon5G } from './matIcon-5g.icon';
import { matIcon5KPlus } from './matIcon-5k_plus.icon';
import { matIcon5K } from './matIcon-5k.icon';
import { matIcon5Mp } from './matIcon-5mp.icon';
import { matIcon6FtApart } from './matIcon-6_ft_apart.icon';
import { matIcon60FpsSelect } from './matIcon-60fps_select.icon';
import { matIcon60Fps } from './matIcon-60fps.icon';
import { matIcon6KPlus } from './matIcon-6k_plus.icon';
import { matIcon6K } from './matIcon-6k.icon';
import { matIcon6Mp } from './matIcon-6mp.icon';
import { matIcon7KPlus } from './matIcon-7k_plus.icon';
import { matIcon7K } from './matIcon-7k.icon';
import { matIcon7Mp } from './matIcon-7mp.icon';
import { matIcon8KPlus } from './matIcon-8k_plus.icon';
import { matIcon8K } from './matIcon-8k.icon';
import { matIcon8Mp } from './matIcon-8mp.icon';
import { matIcon9KPlus } from './matIcon-9k_plus.icon';
import { matIcon9K } from './matIcon-9k.icon';
import { matIcon9Mp } from './matIcon-9mp.icon';
import { matIconAbc } from './matIcon-abc.icon';
import { matIconAcUnit } from './matIcon-ac_unit.icon';
import { matIconAccessAlarm } from './matIcon-access_alarm.icon';
import { matIconAccessAlarms } from './matIcon-access_alarms.icon';
import { matIconAccessTimeFilled } from './matIcon-access_time_filled.icon';
import { matIconAccessTime } from './matIcon-access_time.icon';
import { matIconAccessibilityNew } from './matIcon-accessibility_new.icon';
import { matIconAccessibility } from './matIcon-accessibility.icon';
import { matIconAccessibleForward } from './matIcon-accessible_forward.icon';
import { matIconAccessible } from './matIcon-accessible.icon';
import { matIconAccountBalanceWallet } from './matIcon-account_balance_wallet.icon';
import { matIconAccountBalance } from './matIcon-account_balance.icon';
import { matIconAccountBox } from './matIcon-account_box.icon';
import { matIconAccountCircle } from './matIcon-account_circle.icon';
import { matIconAccountTree } from './matIcon-account_tree.icon';
import { matIconAdUnits } from './matIcon-ad_units.icon';
import { matIconAdb } from './matIcon-adb.icon';
import { matIconAddAPhoto } from './matIcon-add_a_photo.icon';
import { matIconAddAlarm } from './matIcon-add_alarm.icon';
import { matIconAddAlert } from './matIcon-add_alert.icon';
import { matIconAddBox } from './matIcon-add_box.icon';
import { matIconAddBusiness } from './matIcon-add_business.icon';
import { matIconAddCard } from './matIcon-add_card.icon';
import { matIconAddChart } from './matIcon-add_chart.icon';
import { matIconAddCircleOutline } from './matIcon-add_circle_outline.icon';
import { matIconAddCircle } from './matIcon-add_circle.icon';
import { matIconAddComment } from './matIcon-add_comment.icon';
import { matIconAddHomeWork } from './matIcon-add_home_work.icon';
import { matIconAddHome } from './matIcon-add_home.icon';
import { matIconAddIcCall } from './matIcon-add_ic_call.icon';
import { matIconAddLink } from './matIcon-add_link.icon';
import { matIconAddLocationAlt } from './matIcon-add_location_alt.icon';
import { matIconAddLocation } from './matIcon-add_location.icon';
import { matIconAddModerator } from './matIcon-add_moderator.icon';
import { matIconAddPhotoAlternate } from './matIcon-add_photo_alternate.icon';
import { matIconAddReaction } from './matIcon-add_reaction.icon';
import { matIconAddRoad } from './matIcon-add_road.icon';
import { matIconAddShoppingCart } from './matIcon-add_shopping_cart.icon';
import { matIconAddTask } from './matIcon-add_task.icon';
import { matIconAddToDrive } from './matIcon-add_to_drive.icon';
import { matIconAddToHomeScreen } from './matIcon-add_to_home_screen.icon';
import { matIconAddToPhotos } from './matIcon-add_to_photos.icon';
import { matIconAddToQueue } from './matIcon-add_to_queue.icon';
import { matIconAdd } from './matIcon-add.icon';
import { matIconAddchart } from './matIcon-addchart.icon';
import { matIconAdfScanner } from './matIcon-adf_scanner.icon';
import { matIconAdjust } from './matIcon-adjust.icon';
import { matIconAdminPanelSettings } from './matIcon-admin_panel_settings.icon';
import { matIconAdsClick } from './matIcon-ads_click.icon';
import { matIconAgriculture } from './matIcon-agriculture.icon';
import { matIconAir } from './matIcon-air.icon';
import { matIconAirlineSeatFlatAngled } from './matIcon-airline_seat_flat_angled.icon';
import { matIconAirlineSeatFlat } from './matIcon-airline_seat_flat.icon';
import { matIconAirlineSeatIndividualSuite } from './matIcon-airline_seat_individual_suite.icon';
import { matIconAirlineSeatLegroomExtra } from './matIcon-airline_seat_legroom_extra.icon';
import { matIconAirlineSeatLegroomNormal } from './matIcon-airline_seat_legroom_normal.icon';
import { matIconAirlineSeatLegroomReduced } from './matIcon-airline_seat_legroom_reduced.icon';
import { matIconAirlineSeatReclineExtra } from './matIcon-airline_seat_recline_extra.icon';
import { matIconAirlineSeatReclineNormal } from './matIcon-airline_seat_recline_normal.icon';
import { matIconAirlineStops } from './matIcon-airline_stops.icon';
import { matIconAirlines } from './matIcon-airlines.icon';
import { matIconAirplaneTicket } from './matIcon-airplane_ticket.icon';
import { matIconAirplanemodeActive } from './matIcon-airplanemode_active.icon';
import { matIconAirplanemodeInactive } from './matIcon-airplanemode_inactive.icon';
import { matIconAirplay } from './matIcon-airplay.icon';
import { matIconAirportShuttle } from './matIcon-airport_shuttle.icon';
import { matIconAlarmAdd } from './matIcon-alarm_add.icon';
import { matIconAlarmOff } from './matIcon-alarm_off.icon';
import { matIconAlarmOn } from './matIcon-alarm_on.icon';
import { matIconAlarm } from './matIcon-alarm.icon';
import { matIconAlbum } from './matIcon-album.icon';
import { matIconAlignHorizontalCenter } from './matIcon-align_horizontal_center.icon';
import { matIconAlignHorizontalLeft } from './matIcon-align_horizontal_left.icon';
import { matIconAlignHorizontalRight } from './matIcon-align_horizontal_right.icon';
import { matIconAlignVerticalBottom } from './matIcon-align_vertical_bottom.icon';
import { matIconAlignVerticalCenter } from './matIcon-align_vertical_center.icon';
import { matIconAlignVerticalTop } from './matIcon-align_vertical_top.icon';
import { matIconAllInbox } from './matIcon-all_inbox.icon';
import { matIconAllInclusive } from './matIcon-all_inclusive.icon';
import { matIconAllOut } from './matIcon-all_out.icon';
import { matIconAltRoute } from './matIcon-alt_route.icon';
import { matIconAlternateEmail } from './matIcon-alternate_email.icon';
import { matIconAnalytics } from './matIcon-analytics.icon';
import { matIconAnchor } from './matIcon-anchor.icon';
import { matIconAndroid } from './matIcon-android.icon';
import { matIconAnimation } from './matIcon-animation.icon';
import { matIconAnnouncement } from './matIcon-announcement.icon';
import { matIconAod } from './matIcon-aod.icon';
import { matIconApartment } from './matIcon-apartment.icon';
import { matIconApi } from './matIcon-api.icon';
import { matIconAppBlocking } from './matIcon-app_blocking.icon';
import { matIconAppRegistration } from './matIcon-app_registration.icon';
import { matIconAppSettingsAlt } from './matIcon-app_settings_alt.icon';
import { matIconAppShortcut } from './matIcon-app_shortcut.icon';
import { matIconApproval } from './matIcon-approval.icon';
import { matIconAppsOutage } from './matIcon-apps_outage.icon';
import { matIconApps } from './matIcon-apps.icon';
import { matIconArchitecture } from './matIcon-architecture.icon';
import { matIconArchive } from './matIcon-archive.icon';
import { matIconAreaChart } from './matIcon-area_chart.icon';
import { matIconArrowBackIosNew } from './matIcon-arrow_back_ios_new.icon';
import { matIconArrowBackIos } from './matIcon-arrow_back_ios.icon';
import { matIconArrowBack } from './matIcon-arrow_back.icon';
import { matIconArrowCircleDown } from './matIcon-arrow_circle_down.icon';
import { matIconArrowCircleLeft } from './matIcon-arrow_circle_left.icon';
import { matIconArrowCircleRight } from './matIcon-arrow_circle_right.icon';
import { matIconArrowCircleUp } from './matIcon-arrow_circle_up.icon';
import { matIconArrowDownward } from './matIcon-arrow_downward.icon';
import { matIconArrowDropDownCircle } from './matIcon-arrow_drop_down_circle.icon';
import { matIconArrowDropDown } from './matIcon-arrow_drop_down.icon';
import { matIconArrowDropUp } from './matIcon-arrow_drop_up.icon';
import { matIconArrowForwardIos } from './matIcon-arrow_forward_ios.icon';
import { matIconArrowForward } from './matIcon-arrow_forward.icon';
import { matIconArrowLeft } from './matIcon-arrow_left.icon';
import { matIconArrowOutward } from './matIcon-arrow_outward.icon';
import { matIconArrowRightAlt } from './matIcon-arrow_right_alt.icon';
import { matIconArrowRight } from './matIcon-arrow_right.icon';
import { matIconArrowUpward } from './matIcon-arrow_upward.icon';
import { matIconArtTrack } from './matIcon-art_track.icon';
import { matIconArticle } from './matIcon-article.icon';
import { matIconAspectRatio } from './matIcon-aspect_ratio.icon';
import { matIconAssessment } from './matIcon-assessment.icon';
import { matIconAssignmentInd } from './matIcon-assignment_ind.icon';
import { matIconAssignmentLate } from './matIcon-assignment_late.icon';
import { matIconAssignmentReturn } from './matIcon-assignment_return.icon';
import { matIconAssignmentReturned } from './matIcon-assignment_returned.icon';
import { matIconAssignmentTurnedIn } from './matIcon-assignment_turned_in.icon';
import { matIconAssignment } from './matIcon-assignment.icon';
import { matIconAssistWalker } from './matIcon-assist_walker.icon';
import { matIconAssistantDirection } from './matIcon-assistant_direction.icon';
import { matIconAssistantPhoto } from './matIcon-assistant_photo.icon';
import { matIconAssistant } from './matIcon-assistant.icon';
import { matIconAssuredWorkload } from './matIcon-assured_workload.icon';
import { matIconAtm } from './matIcon-atm.icon';
import { matIconAttachEmail } from './matIcon-attach_email.icon';
import { matIconAttachFile } from './matIcon-attach_file.icon';
import { matIconAttachMoney } from './matIcon-attach_money.icon';
import { matIconAttachment } from './matIcon-attachment.icon';
import { matIconAttractions } from './matIcon-attractions.icon';
import { matIconAttribution } from './matIcon-attribution.icon';
import { matIconAudioFile } from './matIcon-audio_file.icon';
import { matIconAudiotrack } from './matIcon-audiotrack.icon';
import { matIconAutoAwesomeMosaic } from './matIcon-auto_awesome_mosaic.icon';
import { matIconAutoAwesomeMotion } from './matIcon-auto_awesome_motion.icon';
import { matIconAutoAwesome } from './matIcon-auto_awesome.icon';
import { matIconAutoDelete } from './matIcon-auto_delete.icon';
import { matIconAutoFixHigh } from './matIcon-auto_fix_high.icon';
import { matIconAutoFixNormal } from './matIcon-auto_fix_normal.icon';
import { matIconAutoFixOff } from './matIcon-auto_fix_off.icon';
import { matIconAutoGraph } from './matIcon-auto_graph.icon';
import { matIconAutoMode } from './matIcon-auto_mode.icon';
import { matIconAutoStories } from './matIcon-auto_stories.icon';
import { matIconAutofpsSelect } from './matIcon-autofps_select.icon';
import { matIconAutorenew } from './matIcon-autorenew.icon';
import { matIconAvTimer } from './matIcon-av_timer.icon';
import { matIconBabyChangingStation } from './matIcon-baby_changing_station.icon';
import { matIconBackHand } from './matIcon-back_hand.icon';
import { matIconBackpack } from './matIcon-backpack.icon';
import { matIconBackspace } from './matIcon-backspace.icon';
import { matIconBackupTable } from './matIcon-backup_table.icon';
import { matIconBackup } from './matIcon-backup.icon';
import { matIconBadge } from './matIcon-badge.icon';
import { matIconBakeryDining } from './matIcon-bakery_dining.icon';
import { matIconBalance } from './matIcon-balance.icon';
import { matIconBalcony } from './matIcon-balcony.icon';
import { matIconBallot } from './matIcon-ballot.icon';
import { matIconBarChart } from './matIcon-bar_chart.icon';
import { matIconBatchPrediction } from './matIcon-batch_prediction.icon';
import { matIconBathroom } from './matIcon-bathroom.icon';
import { matIconBathtub } from './matIcon-bathtub.icon';
import { matIconBattery0Bar } from './matIcon-battery_0_bar.icon';
import { matIconBattery1Bar } from './matIcon-battery_1_bar.icon';
import { matIconBattery2Bar } from './matIcon-battery_2_bar.icon';
import { matIconBattery3Bar } from './matIcon-battery_3_bar.icon';
import { matIconBattery4Bar } from './matIcon-battery_4_bar.icon';
import { matIconBattery5Bar } from './matIcon-battery_5_bar.icon';
import { matIconBattery6Bar } from './matIcon-battery_6_bar.icon';
import { matIconBatteryAlert } from './matIcon-battery_alert.icon';
import { matIconBatteryChargingFull } from './matIcon-battery_charging_full.icon';
import { matIconBatteryFull } from './matIcon-battery_full.icon';
import { matIconBatterySaver } from './matIcon-battery_saver.icon';
import { matIconBatteryStd } from './matIcon-battery_std.icon';
import { matIconBatteryUnknown } from './matIcon-battery_unknown.icon';
import { matIconBeachAccess } from './matIcon-beach_access.icon';
import { matIconBed } from './matIcon-bed.icon';
import { matIconBedroomBaby } from './matIcon-bedroom_baby.icon';
import { matIconBedroomChild } from './matIcon-bedroom_child.icon';
import { matIconBedroomParent } from './matIcon-bedroom_parent.icon';
import { matIconBedtimeOff } from './matIcon-bedtime_off.icon';
import { matIconBedtime } from './matIcon-bedtime.icon';
import { matIconBeenhere } from './matIcon-beenhere.icon';
import { matIconBento } from './matIcon-bento.icon';
import { matIconBikeScooter } from './matIcon-bike_scooter.icon';
import { matIconBiotech } from './matIcon-biotech.icon';
import { matIconBlender } from './matIcon-blender.icon';
import { matIconBlind } from './matIcon-blind.icon';
import { matIconBlindsClosed } from './matIcon-blinds_closed.icon';
import { matIconBlinds } from './matIcon-blinds.icon';
import { matIconBlock } from './matIcon-block.icon';
import { matIconBloodtype } from './matIcon-bloodtype.icon';
import { matIconBluetoothAudio } from './matIcon-bluetooth_audio.icon';
import { matIconBluetoothConnected } from './matIcon-bluetooth_connected.icon';
import { matIconBluetoothDisabled } from './matIcon-bluetooth_disabled.icon';
import { matIconBluetoothDrive } from './matIcon-bluetooth_drive.icon';
import { matIconBluetoothSearching } from './matIcon-bluetooth_searching.icon';
import { matIconBluetooth } from './matIcon-bluetooth.icon';
import { matIconBlurCircular } from './matIcon-blur_circular.icon';
import { matIconBlurLinear } from './matIcon-blur_linear.icon';
import { matIconBlurOff } from './matIcon-blur_off.icon';
import { matIconBlurOn } from './matIcon-blur_on.icon';
import { matIconBolt } from './matIcon-bolt.icon';
import { matIconBookOnline } from './matIcon-book_online.icon';
import { matIconBook } from './matIcon-book.icon';
import { matIconBookmarkAdd } from './matIcon-bookmark_add.icon';
import { matIconBookmarkAdded } from './matIcon-bookmark_added.icon';
import { matIconBookmarkBorder } from './matIcon-bookmark_border.icon';
import { matIconBookmarkRemove } from './matIcon-bookmark_remove.icon';
import { matIconBookmark } from './matIcon-bookmark.icon';
import { matIconBookmarks } from './matIcon-bookmarks.icon';
import { matIconBorderAll } from './matIcon-border_all.icon';
import { matIconBorderBottom } from './matIcon-border_bottom.icon';
import { matIconBorderClear } from './matIcon-border_clear.icon';
import { matIconBorderColor } from './matIcon-border_color.icon';
import { matIconBorderHorizontal } from './matIcon-border_horizontal.icon';
import { matIconBorderInner } from './matIcon-border_inner.icon';
import { matIconBorderLeft } from './matIcon-border_left.icon';
import { matIconBorderOuter } from './matIcon-border_outer.icon';
import { matIconBorderRight } from './matIcon-border_right.icon';
import { matIconBorderStyle } from './matIcon-border_style.icon';
import { matIconBorderTop } from './matIcon-border_top.icon';
import { matIconBorderVertical } from './matIcon-border_vertical.icon';
import { matIconBoy } from './matIcon-boy.icon';
import { matIconBrandingWatermark } from './matIcon-branding_watermark.icon';
import { matIconBreakfastDining } from './matIcon-breakfast_dining.icon';
import { matIconBrightness1 } from './matIcon-brightness_1.icon';
import { matIconBrightness2 } from './matIcon-brightness_2.icon';
import { matIconBrightness3 } from './matIcon-brightness_3.icon';
import { matIconBrightness4 } from './matIcon-brightness_4.icon';
import { matIconBrightness5 } from './matIcon-brightness_5.icon';
import { matIconBrightness6 } from './matIcon-brightness_6.icon';
import { matIconBrightness7 } from './matIcon-brightness_7.icon';
import { matIconBrightnessAuto } from './matIcon-brightness_auto.icon';
import { matIconBrightnessHigh } from './matIcon-brightness_high.icon';
import { matIconBrightnessLow } from './matIcon-brightness_low.icon';
import { matIconBrightnessMedium } from './matIcon-brightness_medium.icon';
import { matIconBroadcastOnHome } from './matIcon-broadcast_on_home.icon';
import { matIconBroadcastOnPersonal } from './matIcon-broadcast_on_personal.icon';
import { matIconBrokenImage } from './matIcon-broken_image.icon';
import { matIconBrowseGallery } from './matIcon-browse_gallery.icon';
import { matIconBrowserNotSupported } from './matIcon-browser_not_supported.icon';
import { matIconBrowserUpdated } from './matIcon-browser_updated.icon';
import { matIconBrunchDining } from './matIcon-brunch_dining.icon';
import { matIconBrush } from './matIcon-brush.icon';
import { matIconBubbleChart } from './matIcon-bubble_chart.icon';
import { matIconBugReport } from './matIcon-bug_report.icon';
import { matIconBuildCircle } from './matIcon-build_circle.icon';
import { matIconBuild } from './matIcon-build.icon';
import { matIconBungalow } from './matIcon-bungalow.icon';
import { matIconBurstMode } from './matIcon-burst_mode.icon';
import { matIconBusAlert } from './matIcon-bus_alert.icon';
import { matIconBusinessCenter } from './matIcon-business_center.icon';
import { matIconBusiness } from './matIcon-business.icon';
import { matIconCabin } from './matIcon-cabin.icon';
import { matIconCable } from './matIcon-cable.icon';
import { matIconCached } from './matIcon-cached.icon';
import { matIconCake } from './matIcon-cake.icon';
import { matIconCalculate } from './matIcon-calculate.icon';
import { matIconCalendarMonth } from './matIcon-calendar_month.icon';
import { matIconCalendarToday } from './matIcon-calendar_today.icon';
import { matIconCalendarViewDay } from './matIcon-calendar_view_day.icon';
import { matIconCalendarViewMonth } from './matIcon-calendar_view_month.icon';
import { matIconCalendarViewWeek } from './matIcon-calendar_view_week.icon';
import { matIconCallEnd } from './matIcon-call_end.icon';
import { matIconCallMade } from './matIcon-call_made.icon';
import { matIconCallMerge } from './matIcon-call_merge.icon';
import { matIconCallMissedOutgoing } from './matIcon-call_missed_outgoing.icon';
import { matIconCallMissed } from './matIcon-call_missed.icon';
import { matIconCallReceived } from './matIcon-call_received.icon';
import { matIconCallSplit } from './matIcon-call_split.icon';
import { matIconCallToAction } from './matIcon-call_to_action.icon';
import { matIconCall } from './matIcon-call.icon';
import { matIconCameraAlt } from './matIcon-camera_alt.icon';
import { matIconCameraEnhance } from './matIcon-camera_enhance.icon';
import { matIconCameraFront } from './matIcon-camera_front.icon';
import { matIconCameraIndoor } from './matIcon-camera_indoor.icon';
import { matIconCameraOutdoor } from './matIcon-camera_outdoor.icon';
import { matIconCameraRear } from './matIcon-camera_rear.icon';
import { matIconCameraRoll } from './matIcon-camera_roll.icon';
import { matIconCamera } from './matIcon-camera.icon';
import { matIconCameraswitch } from './matIcon-cameraswitch.icon';
import { matIconCampaign } from './matIcon-campaign.icon';
import { matIconCancelPresentation } from './matIcon-cancel_presentation.icon';
import { matIconCancelScheduleSend } from './matIcon-cancel_schedule_send.icon';
import { matIconCancel } from './matIcon-cancel.icon';
import { matIconCandlestickChart } from './matIcon-candlestick_chart.icon';
import { matIconCarCrash } from './matIcon-car_crash.icon';
import { matIconCarRental } from './matIcon-car_rental.icon';
import { matIconCarRepair } from './matIcon-car_repair.icon';
import { matIconCardGiftcard } from './matIcon-card_giftcard.icon';
import { matIconCardMembership } from './matIcon-card_membership.icon';
import { matIconCardTravel } from './matIcon-card_travel.icon';
import { matIconCarpenter } from './matIcon-carpenter.icon';
import { matIconCases } from './matIcon-cases.icon';
import { matIconCasino } from './matIcon-casino.icon';
import { matIconCastConnected } from './matIcon-cast_connected.icon';
import { matIconCastForEducation } from './matIcon-cast_for_education.icon';
import { matIconCast } from './matIcon-cast.icon';
import { matIconCastle } from './matIcon-castle.icon';
import { matIconCatchingPokemon } from './matIcon-catching_pokemon.icon';
import { matIconCategory } from './matIcon-category.icon';
import { matIconCelebration } from './matIcon-celebration.icon';
import { matIconCellTower } from './matIcon-cell_tower.icon';
import { matIconCellWifi } from './matIcon-cell_wifi.icon';
import { matIconCenterFocusStrong } from './matIcon-center_focus_strong.icon';
import { matIconCenterFocusWeak } from './matIcon-center_focus_weak.icon';
import { matIconChairAlt } from './matIcon-chair_alt.icon';
import { matIconChair } from './matIcon-chair.icon';
import { matIconChalet } from './matIcon-chalet.icon';
import { matIconChangeCircle } from './matIcon-change_circle.icon';
import { matIconChangeHistory } from './matIcon-change_history.icon';
import { matIconChargingStation } from './matIcon-charging_station.icon';
import { matIconChatBubbleOutline } from './matIcon-chat_bubble_outline.icon';
import { matIconChatBubble } from './matIcon-chat_bubble.icon';
import { matIconChat } from './matIcon-chat.icon';
import { matIconCheckBoxOutlineBlank } from './matIcon-check_box_outline_blank.icon';
import { matIconCheckBox } from './matIcon-check_box.icon';
import { matIconCheckCircleOutline } from './matIcon-check_circle_outline.icon';
import { matIconCheckCircle } from './matIcon-check_circle.icon';
import { matIconCheck } from './matIcon-check.icon';
import { matIconChecklistRtl } from './matIcon-checklist_rtl.icon';
import { matIconChecklist } from './matIcon-checklist.icon';
import { matIconCheckroom } from './matIcon-checkroom.icon';
import { matIconChevronLeft } from './matIcon-chevron_left.icon';
import { matIconChevronRight } from './matIcon-chevron_right.icon';
import { matIconChildCare } from './matIcon-child_care.icon';
import { matIconChildFriendly } from './matIcon-child_friendly.icon';
import { matIconChromeReaderMode } from './matIcon-chrome_reader_mode.icon';
import { matIconChurch } from './matIcon-church.icon';
import { matIconCircleNotifications } from './matIcon-circle_notifications.icon';
import { matIconCircle } from './matIcon-circle.icon';
import { matIconClass } from './matIcon-class.icon';
import { matIconCleanHands } from './matIcon-clean_hands.icon';
import { matIconCleaningServices } from './matIcon-cleaning_services.icon';
import { matIconClearAll } from './matIcon-clear_all.icon';
import { matIconClear } from './matIcon-clear.icon';
import { matIconCloseFullscreen } from './matIcon-close_fullscreen.icon';
import { matIconClose } from './matIcon-close.icon';
import { matIconClosedCaptionDisabled } from './matIcon-closed_caption_disabled.icon';
import { matIconClosedCaptionOff } from './matIcon-closed_caption_off.icon';
import { matIconClosedCaption } from './matIcon-closed_caption.icon';
import { matIconCloudCircle } from './matIcon-cloud_circle.icon';
import { matIconCloudDone } from './matIcon-cloud_done.icon';
import { matIconCloudDownload } from './matIcon-cloud_download.icon';
import { matIconCloudOff } from './matIcon-cloud_off.icon';
import { matIconCloudQueue } from './matIcon-cloud_queue.icon';
import { matIconCloudSync } from './matIcon-cloud_sync.icon';
import { matIconCloudUpload } from './matIcon-cloud_upload.icon';
import { matIconCloud } from './matIcon-cloud.icon';
import { matIconCoPresent } from './matIcon-co_present.icon';
import { matIconCo2 } from './matIcon-co2.icon';
import { matIconCodeOff } from './matIcon-code_off.icon';
import { matIconCode } from './matIcon-code.icon';
import { matIconCoffeeMaker } from './matIcon-coffee_maker.icon';
import { matIconCoffee } from './matIcon-coffee.icon';
import { matIconCollectionsBookmark } from './matIcon-collections_bookmark.icon';
import { matIconCollections } from './matIcon-collections.icon';
import { matIconColorLens } from './matIcon-color_lens.icon';
import { matIconColorize } from './matIcon-colorize.icon';
import { matIconCommentBank } from './matIcon-comment_bank.icon';
import { matIconComment } from './matIcon-comment.icon';
import { matIconCommentsDisabled } from './matIcon-comments_disabled.icon';
import { matIconCommit } from './matIcon-commit.icon';
import { matIconCommute } from './matIcon-commute.icon';
import { matIconCompareArrows } from './matIcon-compare_arrows.icon';
import { matIconCompare } from './matIcon-compare.icon';
import { matIconCompassCalibration } from './matIcon-compass_calibration.icon';
import { matIconCompost } from './matIcon-compost.icon';
import { matIconCompress } from './matIcon-compress.icon';
import { matIconComputer } from './matIcon-computer.icon';
import { matIconConfirmationNumber } from './matIcon-confirmation_number.icon';
import { matIconConnectWithoutContact } from './matIcon-connect_without_contact.icon';
import { matIconConnectedTv } from './matIcon-connected_tv.icon';
import { matIconConnectingAirports } from './matIcon-connecting_airports.icon';
import { matIconConstruction } from './matIcon-construction.icon';
import { matIconContactEmergency } from './matIcon-contact_emergency.icon';
import { matIconContactMail } from './matIcon-contact_mail.icon';
import { matIconContactPage } from './matIcon-contact_page.icon';
import { matIconContactPhone } from './matIcon-contact_phone.icon';
import { matIconContactSupport } from './matIcon-contact_support.icon';
import { matIconContactless } from './matIcon-contactless.icon';
import { matIconContacts } from './matIcon-contacts.icon';
import { matIconContentCopy } from './matIcon-content_copy.icon';
import { matIconContentCut } from './matIcon-content_cut.icon';
import { matIconContentPasteGo } from './matIcon-content_paste_go.icon';
import { matIconContentPasteOff } from './matIcon-content_paste_off.icon';
import { matIconContentPasteSearch } from './matIcon-content_paste_search.icon';
import { matIconContentPaste } from './matIcon-content_paste.icon';
import { matIconContrast } from './matIcon-contrast.icon';
import { matIconControlCamera } from './matIcon-control_camera.icon';
import { matIconControlPointDuplicate } from './matIcon-control_point_duplicate.icon';
import { matIconControlPoint } from './matIcon-control_point.icon';
import { matIconCookie } from './matIcon-cookie.icon';
import { matIconCopyAll } from './matIcon-copy_all.icon';
import { matIconCopyright } from './matIcon-copyright.icon';
import { matIconCoronavirus } from './matIcon-coronavirus.icon';
import { matIconCorporateFare } from './matIcon-corporate_fare.icon';
import { matIconCottage } from './matIcon-cottage.icon';
import { matIconCountertops } from './matIcon-countertops.icon';
import { matIconCreateNewFolder } from './matIcon-create_new_folder.icon';
import { matIconCreate } from './matIcon-create.icon';
import { matIconCreditCardOff } from './matIcon-credit_card_off.icon';
import { matIconCreditCard } from './matIcon-credit_card.icon';
import { matIconCreditScore } from './matIcon-credit_score.icon';
import { matIconCrib } from './matIcon-crib.icon';
import { matIconCrisisAlert } from './matIcon-crisis_alert.icon';
import { matIconCrop169 } from './matIcon-crop_16_9.icon';
import { matIconCrop32 } from './matIcon-crop_3_2.icon';
import { matIconCrop54 } from './matIcon-crop_5_4.icon';
import { matIconCrop75 } from './matIcon-crop_7_5.icon';
import { matIconCropDin } from './matIcon-crop_din.icon';
import { matIconCropFree } from './matIcon-crop_free.icon';
import { matIconCropLandscape } from './matIcon-crop_landscape.icon';
import { matIconCropOriginal } from './matIcon-crop_original.icon';
import { matIconCropPortrait } from './matIcon-crop_portrait.icon';
import { matIconCropRotate } from './matIcon-crop_rotate.icon';
import { matIconCropSquare } from './matIcon-crop_square.icon';
import { matIconCrop } from './matIcon-crop.icon';
import { matIconCrueltyFree } from './matIcon-cruelty_free.icon';
import { matIconCss } from './matIcon-css.icon';
import { matIconCurrencyBitcoin } from './matIcon-currency_bitcoin.icon';
import { matIconCurrencyExchange } from './matIcon-currency_exchange.icon';
import { matIconCurrencyFranc } from './matIcon-currency_franc.icon';
import { matIconCurrencyLira } from './matIcon-currency_lira.icon';
import { matIconCurrencyPound } from './matIcon-currency_pound.icon';
import { matIconCurrencyRuble } from './matIcon-currency_ruble.icon';
import { matIconCurrencyRupee } from './matIcon-currency_rupee.icon';
import { matIconCurrencyYen } from './matIcon-currency_yen.icon';
import { matIconCurrencyYuan } from './matIcon-currency_yuan.icon';
import { matIconCurtainsClosed } from './matIcon-curtains_closed.icon';
import { matIconCurtains } from './matIcon-curtains.icon';
import { matIconCyclone } from './matIcon-cyclone.icon';
import { matIconDangerous } from './matIcon-dangerous.icon';
import { matIconDarkMode } from './matIcon-dark_mode.icon';
import { matIconDashboardCustomize } from './matIcon-dashboard_customize.icon';
import { matIconDashboard } from './matIcon-dashboard.icon';
import { matIconDataArray } from './matIcon-data_array.icon';
import { matIconDataExploration } from './matIcon-data_exploration.icon';
import { matIconDataObject } from './matIcon-data_object.icon';
import { matIconDataSaverOff } from './matIcon-data_saver_off.icon';
import { matIconDataSaverOn } from './matIcon-data_saver_on.icon';
import { matIconDataThresholding } from './matIcon-data_thresholding.icon';
import { matIconDataUsage } from './matIcon-data_usage.icon';
import { matIconDatasetLinked } from './matIcon-dataset_linked.icon';
import { matIconDataset } from './matIcon-dataset.icon';
import { matIconDateRange } from './matIcon-date_range.icon';
import { matIconDeblur } from './matIcon-deblur.icon';
import { matIconDeck } from './matIcon-deck.icon';
import { matIconDehaze } from './matIcon-dehaze.icon';
import { matIconDeleteForever } from './matIcon-delete_forever.icon';
import { matIconDeleteOutline } from './matIcon-delete_outline.icon';
import { matIconDeleteSweep } from './matIcon-delete_sweep.icon';
import { matIconDelete } from './matIcon-delete.icon';
import { matIconDeliveryDining } from './matIcon-delivery_dining.icon';
import { matIconDensityLarge } from './matIcon-density_large.icon';
import { matIconDensityMedium } from './matIcon-density_medium.icon';
import { matIconDensitySmall } from './matIcon-density_small.icon';
import { matIconDepartureBoard } from './matIcon-departure_board.icon';
import { matIconDescription } from './matIcon-description.icon';
import { matIconDeselect } from './matIcon-deselect.icon';
import { matIconDesignServices } from './matIcon-design_services.icon';
import { matIconDesk } from './matIcon-desk.icon';
import { matIconDesktopAccessDisabled } from './matIcon-desktop_access_disabled.icon';
import { matIconDesktopMac } from './matIcon-desktop_mac.icon';
import { matIconDesktopWindows } from './matIcon-desktop_windows.icon';
import { matIconDetails } from './matIcon-details.icon';
import { matIconDeveloperBoardOff } from './matIcon-developer_board_off.icon';
import { matIconDeveloperBoard } from './matIcon-developer_board.icon';
import { matIconDeveloperMode } from './matIcon-developer_mode.icon';
import { matIconDeviceHub } from './matIcon-device_hub.icon';
import { matIconDeviceThermostat } from './matIcon-device_thermostat.icon';
import { matIconDeviceUnknown } from './matIcon-device_unknown.icon';
import { matIconDevicesFold } from './matIcon-devices_fold.icon';
import { matIconDevicesOther } from './matIcon-devices_other.icon';
import { matIconDevices } from './matIcon-devices.icon';
import { matIconDialerSip } from './matIcon-dialer_sip.icon';
import { matIconDialpad } from './matIcon-dialpad.icon';
import { matIconDiamond } from './matIcon-diamond.icon';
import { matIconDifference } from './matIcon-difference.icon';
import { matIconDining } from './matIcon-dining.icon';
import { matIconDinnerDining } from './matIcon-dinner_dining.icon';
import { matIconDirectionsBike } from './matIcon-directions_bike.icon';
import { matIconDirectionsBoatFilled } from './matIcon-directions_boat_filled.icon';
import { matIconDirectionsBoat } from './matIcon-directions_boat.icon';
import { matIconDirectionsBusFilled } from './matIcon-directions_bus_filled.icon';
import { matIconDirectionsBus } from './matIcon-directions_bus.icon';
import { matIconDirectionsCarFilled } from './matIcon-directions_car_filled.icon';
import { matIconDirectionsCar } from './matIcon-directions_car.icon';
import { matIconDirectionsOff } from './matIcon-directions_off.icon';
import { matIconDirectionsRailwayFilled } from './matIcon-directions_railway_filled.icon';
import { matIconDirectionsRailway } from './matIcon-directions_railway.icon';
import { matIconDirectionsRun } from './matIcon-directions_run.icon';
import { matIconDirectionsSubwayFilled } from './matIcon-directions_subway_filled.icon';
import { matIconDirectionsSubway } from './matIcon-directions_subway.icon';
import { matIconDirectionsTransitFilled } from './matIcon-directions_transit_filled.icon';
import { matIconDirectionsTransit } from './matIcon-directions_transit.icon';
import { matIconDirectionsWalk } from './matIcon-directions_walk.icon';
import { matIconDirections } from './matIcon-directions.icon';
import { matIconDirtyLens } from './matIcon-dirty_lens.icon';
import { matIconDisabledByDefault } from './matIcon-disabled_by_default.icon';
import { matIconDisabledVisible } from './matIcon-disabled_visible.icon';
import { matIconDiscFull } from './matIcon-disc_full.icon';
import { matIconDiscount } from './matIcon-discount.icon';
import { matIconDisplaySettings } from './matIcon-display_settings.icon';
import { matIconDiversity1 } from './matIcon-diversity_1.icon';
import { matIconDiversity2 } from './matIcon-diversity_2.icon';
import { matIconDiversity3 } from './matIcon-diversity_3.icon';
import { matIconDns } from './matIcon-dns.icon';
import { matIconDoDisturbAlt } from './matIcon-do_disturb_alt.icon';
import { matIconDoDisturbOff } from './matIcon-do_disturb_off.icon';
import { matIconDoDisturbOn } from './matIcon-do_disturb_on.icon';
import { matIconDoDisturb } from './matIcon-do_disturb.icon';
import { matIconDoNotDisturbAlt } from './matIcon-do_not_disturb_alt.icon';
import { matIconDoNotDisturbOff } from './matIcon-do_not_disturb_off.icon';
import { matIconDoNotDisturbOnTotalSilence } from './matIcon-do_not_disturb_on_total_silence.icon';
import { matIconDoNotDisturbOn } from './matIcon-do_not_disturb_on.icon';
import { matIconDoNotDisturb } from './matIcon-do_not_disturb.icon';
import { matIconDoNotStep } from './matIcon-do_not_step.icon';
import { matIconDoNotTouch } from './matIcon-do_not_touch.icon';
import { matIconDock } from './matIcon-dock.icon';
import { matIconDocumentScanner } from './matIcon-document_scanner.icon';
import { matIconDomainAdd } from './matIcon-domain_add.icon';
import { matIconDomainDisabled } from './matIcon-domain_disabled.icon';
import { matIconDomainVerification } from './matIcon-domain_verification.icon';
import { matIconDomain } from './matIcon-domain.icon';
import { matIconDoneAll } from './matIcon-done_all.icon';
import { matIconDoneOutline } from './matIcon-done_outline.icon';
import { matIconDone } from './matIcon-done.icon';
import { matIconDonutLarge } from './matIcon-donut_large.icon';
import { matIconDonutSmall } from './matIcon-donut_small.icon';
import { matIconDoorBack } from './matIcon-door_back.icon';
import { matIconDoorFront } from './matIcon-door_front.icon';
import { matIconDoorSliding } from './matIcon-door_sliding.icon';
import { matIconDoorbell } from './matIcon-doorbell.icon';
import { matIconDoubleArrow } from './matIcon-double_arrow.icon';
import { matIconDownhillSkiing } from './matIcon-downhill_skiing.icon';
import { matIconDownloadDone } from './matIcon-download_done.icon';
import { matIconDownloadForOffline } from './matIcon-download_for_offline.icon';
import { matIconDownload } from './matIcon-download.icon';
import { matIconDownloading } from './matIcon-downloading.icon';
import { matIconDrafts } from './matIcon-drafts.icon';
import { matIconDragHandle } from './matIcon-drag_handle.icon';
import { matIconDragIndicator } from './matIcon-drag_indicator.icon';
import { matIconDraw } from './matIcon-draw.icon';
import { matIconDriveEta } from './matIcon-drive_eta.icon';
import { matIconDriveFileMoveRtl } from './matIcon-drive_file_move_rtl.icon';
import { matIconDriveFileMove } from './matIcon-drive_file_move.icon';
import { matIconDriveFileRenameOutline } from './matIcon-drive_file_rename_outline.icon';
import { matIconDriveFolderUpload } from './matIcon-drive_folder_upload.icon';
import { matIconDryCleaning } from './matIcon-dry_cleaning.icon';
import { matIconDry } from './matIcon-dry.icon';
import { matIconDuo } from './matIcon-duo.icon';
import { matIconDvr } from './matIcon-dvr.icon';
import { matIconDynamicFeed } from './matIcon-dynamic_feed.icon';
import { matIconDynamicForm } from './matIcon-dynamic_form.icon';
import { matIconEMobiledata } from './matIcon-e_mobiledata.icon';
import { matIconEarbudsBattery } from './matIcon-earbuds_battery.icon';
import { matIconEarbuds } from './matIcon-earbuds.icon';
import { matIconEast } from './matIcon-east.icon';
import { matIconEdgesensorHigh } from './matIcon-edgesensor_high.icon';
import { matIconEdgesensorLow } from './matIcon-edgesensor_low.icon';
import { matIconEditAttributes } from './matIcon-edit_attributes.icon';
import { matIconEditCalendar } from './matIcon-edit_calendar.icon';
import { matIconEditLocationAlt } from './matIcon-edit_location_alt.icon';
import { matIconEditLocation } from './matIcon-edit_location.icon';
import { matIconEditNote } from './matIcon-edit_note.icon';
import { matIconEditNotifications } from './matIcon-edit_notifications.icon';
import { matIconEditOff } from './matIcon-edit_off.icon';
import { matIconEditRoad } from './matIcon-edit_road.icon';
import { matIconEdit } from './matIcon-edit.icon';
import { matIconEggAlt } from './matIcon-egg_alt.icon';
import { matIconEgg } from './matIcon-egg.icon';
import { matIconEject } from './matIcon-eject.icon';
import { matIconElderlyWoman } from './matIcon-elderly_woman.icon';
import { matIconElderly } from './matIcon-elderly.icon';
import { matIconElectricBike } from './matIcon-electric_bike.icon';
import { matIconElectricBolt } from './matIcon-electric_bolt.icon';
import { matIconElectricCar } from './matIcon-electric_car.icon';
import { matIconElectricMeter } from './matIcon-electric_meter.icon';
import { matIconElectricMoped } from './matIcon-electric_moped.icon';
import { matIconElectricRickshaw } from './matIcon-electric_rickshaw.icon';
import { matIconElectricScooter } from './matIcon-electric_scooter.icon';
import { matIconElectricalServices } from './matIcon-electrical_services.icon';
import { matIconElevator } from './matIcon-elevator.icon';
import { matIconEmail } from './matIcon-email.icon';
import { matIconEmergencyRecording } from './matIcon-emergency_recording.icon';
import { matIconEmergencyShare } from './matIcon-emergency_share.icon';
import { matIconEmergency } from './matIcon-emergency.icon';
import { matIconEmojiEmotions } from './matIcon-emoji_emotions.icon';
import { matIconEmojiEvents } from './matIcon-emoji_events.icon';
import { matIconEmojiFoodBeverage } from './matIcon-emoji_food_beverage.icon';
import { matIconEmojiNature } from './matIcon-emoji_nature.icon';
import { matIconEmojiObjects } from './matIcon-emoji_objects.icon';
import { matIconEmojiPeople } from './matIcon-emoji_people.icon';
import { matIconEmojiSymbols } from './matIcon-emoji_symbols.icon';
import { matIconEmojiTransportation } from './matIcon-emoji_transportation.icon';
import { matIconEnergySavingsLeaf } from './matIcon-energy_savings_leaf.icon';
import { matIconEngineering } from './matIcon-engineering.icon';
import { matIconEnhancedEncryption } from './matIcon-enhanced_encryption.icon';
import { matIconEqualizer } from './matIcon-equalizer.icon';
import { matIconErrorOutline } from './matIcon-error_outline.icon';
import { matIconError } from './matIcon-error.icon';
import { matIconEscalatorWarning } from './matIcon-escalator_warning.icon';
import { matIconEscalator } from './matIcon-escalator.icon';
import { matIconEuroSymbol } from './matIcon-euro_symbol.icon';
import { matIconEuro } from './matIcon-euro.icon';
import { matIconEvStation } from './matIcon-ev_station.icon';
import { matIconEventAvailable } from './matIcon-event_available.icon';
import { matIconEventBusy } from './matIcon-event_busy.icon';
import { matIconEventNote } from './matIcon-event_note.icon';
import { matIconEventRepeat } from './matIcon-event_repeat.icon';
import { matIconEventSeat } from './matIcon-event_seat.icon';
import { matIconEvent } from './matIcon-event.icon';
import { matIconExitToApp } from './matIcon-exit_to_app.icon';
import { matIconExpandCircleDown } from './matIcon-expand_circle_down.icon';
import { matIconExpandLess } from './matIcon-expand_less.icon';
import { matIconExpandMore } from './matIcon-expand_more.icon';
import { matIconExpand } from './matIcon-expand.icon';
import { matIconExplicit } from './matIcon-explicit.icon';
import { matIconExploreOff } from './matIcon-explore_off.icon';
import { matIconExplore } from './matIcon-explore.icon';
import { matIconExposureNeg1 } from './matIcon-exposure_neg_1.icon';
import { matIconExposureNeg2 } from './matIcon-exposure_neg_2.icon';
import { matIconExposurePlus1 } from './matIcon-exposure_plus_1.icon';
import { matIconExposurePlus2 } from './matIcon-exposure_plus_2.icon';
import { matIconExposureZero } from './matIcon-exposure_zero.icon';
import { matIconExposure } from './matIcon-exposure.icon';
import { matIconExtensionOff } from './matIcon-extension_off.icon';
import { matIconExtension } from './matIcon-extension.icon';
import { matIconFace2 } from './matIcon-face_2.icon';
import { matIconFace3 } from './matIcon-face_3.icon';
import { matIconFace4 } from './matIcon-face_4.icon';
import { matIconFace5 } from './matIcon-face_5.icon';
import { matIconFace6 } from './matIcon-face_6.icon';
import { matIconFaceRetouchingNatural } from './matIcon-face_retouching_natural.icon';
import { matIconFaceRetouchingOff } from './matIcon-face_retouching_off.icon';
import { matIconFace } from './matIcon-face.icon';
import { matIconFactCheck } from './matIcon-fact_check.icon';
import { matIconFactory } from './matIcon-factory.icon';
import { matIconFamilyRestroom } from './matIcon-family_restroom.icon';
import { matIconFastForward } from './matIcon-fast_forward.icon';
import { matIconFastRewind } from './matIcon-fast_rewind.icon';
import { matIconFastfood } from './matIcon-fastfood.icon';
import { matIconFavoriteBorder } from './matIcon-favorite_border.icon';
import { matIconFavorite } from './matIcon-favorite.icon';
import { matIconFax } from './matIcon-fax.icon';
import { matIconFeaturedPlayList } from './matIcon-featured_play_list.icon';
import { matIconFeaturedVideo } from './matIcon-featured_video.icon';
import { matIconFeed } from './matIcon-feed.icon';
import { matIconFeedback } from './matIcon-feedback.icon';
import { matIconFemale } from './matIcon-female.icon';
import { matIconFence } from './matIcon-fence.icon';
import { matIconFestival } from './matIcon-festival.icon';
import { matIconFiberDvr } from './matIcon-fiber_dvr.icon';
import { matIconFiberManualRecord } from './matIcon-fiber_manual_record.icon';
import { matIconFiberNew } from './matIcon-fiber_new.icon';
import { matIconFiberPin } from './matIcon-fiber_pin.icon';
import { matIconFiberSmartRecord } from './matIcon-fiber_smart_record.icon';
import { matIconFileCopy } from './matIcon-file_copy.icon';
import { matIconFileDownloadDone } from './matIcon-file_download_done.icon';
import { matIconFileDownloadOff } from './matIcon-file_download_off.icon';
import { matIconFileDownload } from './matIcon-file_download.icon';
import { matIconFileOpen } from './matIcon-file_open.icon';
import { matIconFilePresent } from './matIcon-file_present.icon';
import { matIconFileUpload } from './matIcon-file_upload.icon';
import { matIconFilter1 } from './matIcon-filter_1.icon';
import { matIconFilter2 } from './matIcon-filter_2.icon';
import { matIconFilter3 } from './matIcon-filter_3.icon';
import { matIconFilter4 } from './matIcon-filter_4.icon';
import { matIconFilter5 } from './matIcon-filter_5.icon';
import { matIconFilter6 } from './matIcon-filter_6.icon';
import { matIconFilter7 } from './matIcon-filter_7.icon';
import { matIconFilter8 } from './matIcon-filter_8.icon';
import { matIconFilter9Plus } from './matIcon-filter_9_plus.icon';
import { matIconFilter9 } from './matIcon-filter_9.icon';
import { matIconFilterAltOff } from './matIcon-filter_alt_off.icon';
import { matIconFilterAlt } from './matIcon-filter_alt.icon';
import { matIconFilterBAndW } from './matIcon-filter_b_and_w.icon';
import { matIconFilterCenterFocus } from './matIcon-filter_center_focus.icon';
import { matIconFilterDrama } from './matIcon-filter_drama.icon';
import { matIconFilterFrames } from './matIcon-filter_frames.icon';
import { matIconFilterHdr } from './matIcon-filter_hdr.icon';
import { matIconFilterListOff } from './matIcon-filter_list_off.icon';
import { matIconFilterList } from './matIcon-filter_list.icon';
import { matIconFilterNone } from './matIcon-filter_none.icon';
import { matIconFilterTiltShift } from './matIcon-filter_tilt_shift.icon';
import { matIconFilterVintage } from './matIcon-filter_vintage.icon';
import { matIconFilter } from './matIcon-filter.icon';
import { matIconFindInPage } from './matIcon-find_in_page.icon';
import { matIconFindReplace } from './matIcon-find_replace.icon';
import { matIconFingerprint } from './matIcon-fingerprint.icon';
import { matIconFireExtinguisher } from './matIcon-fire_extinguisher.icon';
import { matIconFireHydrantAlt } from './matIcon-fire_hydrant_alt.icon';
import { matIconFireTruck } from './matIcon-fire_truck.icon';
import { matIconFireplace } from './matIcon-fireplace.icon';
import { matIconFirstPage } from './matIcon-first_page.icon';
import { matIconFitScreen } from './matIcon-fit_screen.icon';
import { matIconFitbit } from './matIcon-fitbit.icon';
import { matIconFitnessCenter } from './matIcon-fitness_center.icon';
import { matIconFlagCircle } from './matIcon-flag_circle.icon';
import { matIconFlag } from './matIcon-flag.icon';
import { matIconFlaky } from './matIcon-flaky.icon';
import { matIconFlare } from './matIcon-flare.icon';
import { matIconFlashAuto } from './matIcon-flash_auto.icon';
import { matIconFlashOff } from './matIcon-flash_off.icon';
import { matIconFlashOn } from './matIcon-flash_on.icon';
import { matIconFlashlightOff } from './matIcon-flashlight_off.icon';
import { matIconFlashlightOn } from './matIcon-flashlight_on.icon';
import { matIconFlatware } from './matIcon-flatware.icon';
import { matIconFlightClass } from './matIcon-flight_class.icon';
import { matIconFlightLand } from './matIcon-flight_land.icon';
import { matIconFlightTakeoff } from './matIcon-flight_takeoff.icon';
import { matIconFlight } from './matIcon-flight.icon';
import { matIconFlipCameraAndroid } from './matIcon-flip_camera_android.icon';
import { matIconFlipCameraIos } from './matIcon-flip_camera_ios.icon';
import { matIconFlipToBack } from './matIcon-flip_to_back.icon';
import { matIconFlipToFront } from './matIcon-flip_to_front.icon';
import { matIconFlip } from './matIcon-flip.icon';
import { matIconFlood } from './matIcon-flood.icon';
import { matIconFluorescent } from './matIcon-fluorescent.icon';
import { matIconFlutterDash } from './matIcon-flutter_dash.icon';
import { matIconFmdBad } from './matIcon-fmd_bad.icon';
import { matIconFmdGood } from './matIcon-fmd_good.icon';
import { matIconFolderCopy } from './matIcon-folder_copy.icon';
import { matIconFolderDelete } from './matIcon-folder_delete.icon';
import { matIconFolderOff } from './matIcon-folder_off.icon';
import { matIconFolderOpen } from './matIcon-folder_open.icon';
import { matIconFolderShared } from './matIcon-folder_shared.icon';
import { matIconFolderSpecial } from './matIcon-folder_special.icon';
import { matIconFolderZip } from './matIcon-folder_zip.icon';
import { matIconFolder } from './matIcon-folder.icon';
import { matIconFollowTheSigns } from './matIcon-follow_the_signs.icon';
import { matIconFontDownloadOff } from './matIcon-font_download_off.icon';
import { matIconFontDownload } from './matIcon-font_download.icon';
import { matIconFoodBank } from './matIcon-food_bank.icon';
import { matIconForest } from './matIcon-forest.icon';
import { matIconForkLeft } from './matIcon-fork_left.icon';
import { matIconForkRight } from './matIcon-fork_right.icon';
import { matIconFormatAlignCenter } from './matIcon-format_align_center.icon';
import { matIconFormatAlignJustify } from './matIcon-format_align_justify.icon';
import { matIconFormatAlignLeft } from './matIcon-format_align_left.icon';
import { matIconFormatAlignRight } from './matIcon-format_align_right.icon';
import { matIconFormatBold } from './matIcon-format_bold.icon';
import { matIconFormatClear } from './matIcon-format_clear.icon';
import { matIconFormatColorFill } from './matIcon-format_color_fill.icon';
import { matIconFormatColorReset } from './matIcon-format_color_reset.icon';
import { matIconFormatColorText } from './matIcon-format_color_text.icon';
import { matIconFormatIndentDecrease } from './matIcon-format_indent_decrease.icon';
import { matIconFormatIndentIncrease } from './matIcon-format_indent_increase.icon';
import { matIconFormatItalic } from './matIcon-format_italic.icon';
import { matIconFormatLineSpacing } from './matIcon-format_line_spacing.icon';
import { matIconFormatListBulleted } from './matIcon-format_list_bulleted.icon';
import { matIconFormatListNumberedRtl } from './matIcon-format_list_numbered_rtl.icon';
import { matIconFormatListNumbered } from './matIcon-format_list_numbered.icon';
import { matIconFormatOverline } from './matIcon-format_overline.icon';
import { matIconFormatPaint } from './matIcon-format_paint.icon';
import { matIconFormatQuote } from './matIcon-format_quote.icon';
import { matIconFormatShapes } from './matIcon-format_shapes.icon';
import { matIconFormatSize } from './matIcon-format_size.icon';
import { matIconFormatStrikethrough } from './matIcon-format_strikethrough.icon';
import { matIconFormatTextdirectionLToR } from './matIcon-format_textdirection_l_to_r.icon';
import { matIconFormatTextdirectionRToL } from './matIcon-format_textdirection_r_to_l.icon';
import { matIconFormatUnderlined } from './matIcon-format_underlined.icon';
import { matIconFort } from './matIcon-fort.icon';
import { matIconForum } from './matIcon-forum.icon';
import { matIconForward10 } from './matIcon-forward_10.icon';
import { matIconForward30 } from './matIcon-forward_30.icon';
import { matIconForward5 } from './matIcon-forward_5.icon';
import { matIconForwardToInbox } from './matIcon-forward_to_inbox.icon';
import { matIconForward } from './matIcon-forward.icon';
import { matIconFoundation } from './matIcon-foundation.icon';
import { matIconFreeBreakfast } from './matIcon-free_breakfast.icon';
import { matIconFreeCancellation } from './matIcon-free_cancellation.icon';
import { matIconFrontHand } from './matIcon-front_hand.icon';
import { matIconFullscreenExit } from './matIcon-fullscreen_exit.icon';
import { matIconFullscreen } from './matIcon-fullscreen.icon';
import { matIconFunctions } from './matIcon-functions.icon';
import { matIconGMobiledata } from './matIcon-g_mobiledata.icon';
import { matIconGTranslate } from './matIcon-g_translate.icon';
import { matIconGamepad } from './matIcon-gamepad.icon';
import { matIconGames } from './matIcon-games.icon';
import { matIconGarage } from './matIcon-garage.icon';
import { matIconGasMeter } from './matIcon-gas_meter.icon';
import { matIconGavel } from './matIcon-gavel.icon';
import { matIconGeneratingTokens } from './matIcon-generating_tokens.icon';
import { matIconGesture } from './matIcon-gesture.icon';
import { matIconGetApp } from './matIcon-get_app.icon';
import { matIconGifBox } from './matIcon-gif_box.icon';
import { matIconGif } from './matIcon-gif.icon';
import { matIconGirl } from './matIcon-girl.icon';
import { matIconGite } from './matIcon-gite.icon';
import { matIconGolfCourse } from './matIcon-golf_course.icon';
import { matIconGppBad } from './matIcon-gpp_bad.icon';
import { matIconGppGood } from './matIcon-gpp_good.icon';
import { matIconGppMaybe } from './matIcon-gpp_maybe.icon';
import { matIconGpsFixed } from './matIcon-gps_fixed.icon';
import { matIconGpsNotFixed } from './matIcon-gps_not_fixed.icon';
import { matIconGpsOff } from './matIcon-gps_off.icon';
import { matIconGrade } from './matIcon-grade.icon';
import { matIconGradient } from './matIcon-gradient.icon';
import { matIconGrading } from './matIcon-grading.icon';
import { matIconGrain } from './matIcon-grain.icon';
import { matIconGraphicEq } from './matIcon-graphic_eq.icon';
import { matIconGrass } from './matIcon-grass.icon';
import { matIconGrid3X3 } from './matIcon-grid_3x3.icon';
import { matIconGrid4X4 } from './matIcon-grid_4x4.icon';
import { matIconGridGoldenratio } from './matIcon-grid_goldenratio.icon';
import { matIconGridOff } from './matIcon-grid_off.icon';
import { matIconGridOn } from './matIcon-grid_on.icon';
import { matIconGridView } from './matIcon-grid_view.icon';
import { matIconGroupAdd } from './matIcon-group_add.icon';
import { matIconGroupOff } from './matIcon-group_off.icon';
import { matIconGroupRemove } from './matIcon-group_remove.icon';
import { matIconGroupWork } from './matIcon-group_work.icon';
import { matIconGroup } from './matIcon-group.icon';
import { matIconGroups2 } from './matIcon-groups_2.icon';
import { matIconGroups3 } from './matIcon-groups_3.icon';
import { matIconGroups } from './matIcon-groups.icon';
import { matIconHMobiledata } from './matIcon-h_mobiledata.icon';
import { matIconHPlusMobiledata } from './matIcon-h_plus_mobiledata.icon';
import { matIconHail } from './matIcon-hail.icon';
import { matIconHandshake } from './matIcon-handshake.icon';
import { matIconHandyman } from './matIcon-handyman.icon';
import { matIconHardware } from './matIcon-hardware.icon';
import { matIconHd } from './matIcon-hd.icon';
import { matIconHdrAutoSelect } from './matIcon-hdr_auto_select.icon';
import { matIconHdrAuto } from './matIcon-hdr_auto.icon';
import { matIconHdrEnhancedSelect } from './matIcon-hdr_enhanced_select.icon';
import { matIconHdrOffSelect } from './matIcon-hdr_off_select.icon';
import { matIconHdrOff } from './matIcon-hdr_off.icon';
import { matIconHdrOnSelect } from './matIcon-hdr_on_select.icon';
import { matIconHdrOn } from './matIcon-hdr_on.icon';
import { matIconHdrPlus } from './matIcon-hdr_plus.icon';
import { matIconHdrStrong } from './matIcon-hdr_strong.icon';
import { matIconHdrWeak } from './matIcon-hdr_weak.icon';
import { matIconHeadphonesBattery } from './matIcon-headphones_battery.icon';
import { matIconHeadphones } from './matIcon-headphones.icon';
import { matIconHeadsetMic } from './matIcon-headset_mic.icon';
import { matIconHeadsetOff } from './matIcon-headset_off.icon';
import { matIconHeadset } from './matIcon-headset.icon';
import { matIconHealing } from './matIcon-healing.icon';
import { matIconHealthAndSafety } from './matIcon-health_and_safety.icon';
import { matIconHearingDisabled } from './matIcon-hearing_disabled.icon';
import { matIconHearing } from './matIcon-hearing.icon';
import { matIconHeartBroken } from './matIcon-heart_broken.icon';
import { matIconHeatPump } from './matIcon-heat_pump.icon';
import { matIconHeight } from './matIcon-height.icon';
import { matIconHelpCenter } from './matIcon-help_center.icon';
import { matIconHelpOutline } from './matIcon-help_outline.icon';
import { matIconHelp } from './matIcon-help.icon';
import { matIconHevc } from './matIcon-hevc.icon';
import { matIconHexagon } from './matIcon-hexagon.icon';
import { matIconHideImage } from './matIcon-hide_image.icon';
import { matIconHideSource } from './matIcon-hide_source.icon';
import { matIconHighQuality } from './matIcon-high_quality.icon';
import { matIconHighlightAlt } from './matIcon-highlight_alt.icon';
import { matIconHighlightOff } from './matIcon-highlight_off.icon';
import { matIconHighlight } from './matIcon-highlight.icon';
import { matIconHiking } from './matIcon-hiking.icon';
import { matIconHistoryEdu } from './matIcon-history_edu.icon';
import { matIconHistoryToggleOff } from './matIcon-history_toggle_off.icon';
import { matIconHistory } from './matIcon-history.icon';
import { matIconHive } from './matIcon-hive.icon';
import { matIconHlsOff } from './matIcon-hls_off.icon';
import { matIconHls } from './matIcon-hls.icon';
import { matIconHolidayVillage } from './matIcon-holiday_village.icon';
import { matIconHomeMax } from './matIcon-home_max.icon';
import { matIconHomeMini } from './matIcon-home_mini.icon';
import { matIconHomeRepairService } from './matIcon-home_repair_service.icon';
import { matIconHomeWork } from './matIcon-home_work.icon';
import { matIconHome } from './matIcon-home.icon';
import { matIconHorizontalDistribute } from './matIcon-horizontal_distribute.icon';
import { matIconHorizontalRule } from './matIcon-horizontal_rule.icon';
import { matIconHorizontalSplit } from './matIcon-horizontal_split.icon';
import { matIconHotTub } from './matIcon-hot_tub.icon';
import { matIconHotelClass } from './matIcon-hotel_class.icon';
import { matIconHotel } from './matIcon-hotel.icon';
import { matIconHourglassBottom } from './matIcon-hourglass_bottom.icon';
import { matIconHourglassDisabled } from './matIcon-hourglass_disabled.icon';
import { matIconHourglassEmpty } from './matIcon-hourglass_empty.icon';
import { matIconHourglassFull } from './matIcon-hourglass_full.icon';
import { matIconHourglassTop } from './matIcon-hourglass_top.icon';
import { matIconHouseSiding } from './matIcon-house_siding.icon';
import { matIconHouse } from './matIcon-house.icon';
import { matIconHouseboat } from './matIcon-houseboat.icon';
import { matIconHowToReg } from './matIcon-how_to_reg.icon';
import { matIconHowToVote } from './matIcon-how_to_vote.icon';
import { matIconHtml } from './matIcon-html.icon';
import { matIconHttp } from './matIcon-http.icon';
import { matIconHttps } from './matIcon-https.icon';
import { matIconHub } from './matIcon-hub.icon';
import { matIconHvac } from './matIcon-hvac.icon';
import { matIconIceSkating } from './matIcon-ice_skating.icon';
import { matIconIcecream } from './matIcon-icecream.icon';
import { matIconImageAspectRatio } from './matIcon-image_aspect_ratio.icon';
import { matIconImageNotSupported } from './matIcon-image_not_supported.icon';
import { matIconImageSearch } from './matIcon-image_search.icon';
import { matIconImage } from './matIcon-image.icon';
import { matIconImagesearchRoller } from './matIcon-imagesearch_roller.icon';
import { matIconImportContacts } from './matIcon-import_contacts.icon';
import { matIconImportExport } from './matIcon-import_export.icon';
import { matIconImportantDevices } from './matIcon-important_devices.icon';
import { matIconInbox } from './matIcon-inbox.icon';
import { matIconIncompleteCircle } from './matIcon-incomplete_circle.icon';
import { matIconIndeterminateCheckBox } from './matIcon-indeterminate_check_box.icon';
import { matIconInfo } from './matIcon-info.icon';
import { matIconInput } from './matIcon-input.icon';
import { matIconInsertChartOutlined } from './matIcon-insert_chart_outlined.icon';
import { matIconInsertChart } from './matIcon-insert_chart.icon';
import { matIconInsertComment } from './matIcon-insert_comment.icon';
import { matIconInsertDriveFile } from './matIcon-insert_drive_file.icon';
import { matIconInsertEmoticon } from './matIcon-insert_emoticon.icon';
import { matIconInsertInvitation } from './matIcon-insert_invitation.icon';
import { matIconInsertLink } from './matIcon-insert_link.icon';
import { matIconInsertPageBreak } from './matIcon-insert_page_break.icon';
import { matIconInsertPhoto } from './matIcon-insert_photo.icon';
import { matIconInsights } from './matIcon-insights.icon';
import { matIconInstallDesktop } from './matIcon-install_desktop.icon';
import { matIconInstallMobile } from './matIcon-install_mobile.icon';
import { matIconIntegrationInstructions } from './matIcon-integration_instructions.icon';
import { matIconInterests } from './matIcon-interests.icon';
import { matIconInterpreterMode } from './matIcon-interpreter_mode.icon';
import { matIconInventory2 } from './matIcon-inventory_2.icon';
import { matIconInventory } from './matIcon-inventory.icon';
import { matIconInvertColorsOff } from './matIcon-invert_colors_off.icon';
import { matIconInvertColors } from './matIcon-invert_colors.icon';
import { matIconIosShare } from './matIcon-ios_share.icon';
import { matIconIron } from './matIcon-iron.icon';
import { matIconIso } from './matIcon-iso.icon';
import { matIconJavascript } from './matIcon-javascript.icon';
import { matIconJoinFull } from './matIcon-join_full.icon';
import { matIconJoinInner } from './matIcon-join_inner.icon';
import { matIconJoinLeft } from './matIcon-join_left.icon';
import { matIconJoinRight } from './matIcon-join_right.icon';
import { matIconKayaking } from './matIcon-kayaking.icon';
import { matIconKebabDining } from './matIcon-kebab_dining.icon';
import { matIconKeyOff } from './matIcon-key_off.icon';
import { matIconKey } from './matIcon-key.icon';
import { matIconKeyboardAlt } from './matIcon-keyboard_alt.icon';
import { matIconKeyboardArrowDown } from './matIcon-keyboard_arrow_down.icon';
import { matIconKeyboardArrowLeft } from './matIcon-keyboard_arrow_left.icon';
import { matIconKeyboardArrowRight } from './matIcon-keyboard_arrow_right.icon';
import { matIconKeyboardArrowUp } from './matIcon-keyboard_arrow_up.icon';
import { matIconKeyboardBackspace } from './matIcon-keyboard_backspace.icon';
import { matIconKeyboardCapslock } from './matIcon-keyboard_capslock.icon';
import { matIconKeyboardCommandKey } from './matIcon-keyboard_command_key.icon';
import { matIconKeyboardControlKey } from './matIcon-keyboard_control_key.icon';
import { matIconKeyboardDoubleArrowDown } from './matIcon-keyboard_double_arrow_down.icon';
import { matIconKeyboardDoubleArrowLeft } from './matIcon-keyboard_double_arrow_left.icon';
import { matIconKeyboardDoubleArrowRight } from './matIcon-keyboard_double_arrow_right.icon';
import { matIconKeyboardDoubleArrowUp } from './matIcon-keyboard_double_arrow_up.icon';
import { matIconKeyboardHide } from './matIcon-keyboard_hide.icon';
import { matIconKeyboardOptionKey } from './matIcon-keyboard_option_key.icon';
import { matIconKeyboardReturn } from './matIcon-keyboard_return.icon';
import { matIconKeyboardTab } from './matIcon-keyboard_tab.icon';
import { matIconKeyboardVoice } from './matIcon-keyboard_voice.icon';
import { matIconKeyboard } from './matIcon-keyboard.icon';
import { matIconKingBed } from './matIcon-king_bed.icon';
import { matIconKitchen } from './matIcon-kitchen.icon';
import { matIconKitesurfing } from './matIcon-kitesurfing.icon';
import { matIconLabelImportant } from './matIcon-label_important.icon';
import { matIconLabelOff } from './matIcon-label_off.icon';
import { matIconLabel } from './matIcon-label.icon';
import { matIconLan } from './matIcon-lan.icon';
import { matIconLandscape } from './matIcon-landscape.icon';
import { matIconLandslide } from './matIcon-landslide.icon';
import { matIconLanguage } from './matIcon-language.icon';
import { matIconLaptopChromebook } from './matIcon-laptop_chromebook.icon';
import { matIconLaptopMac } from './matIcon-laptop_mac.icon';
import { matIconLaptopWindows } from './matIcon-laptop_windows.icon';
import { matIconLaptop } from './matIcon-laptop.icon';
import { matIconLastPage } from './matIcon-last_page.icon';
import { matIconLaunch } from './matIcon-launch.icon';
import { matIconLayersClear } from './matIcon-layers_clear.icon';
import { matIconLayers } from './matIcon-layers.icon';
import { matIconLeaderboard } from './matIcon-leaderboard.icon';
import { matIconLeakAdd } from './matIcon-leak_add.icon';
import { matIconLeakRemove } from './matIcon-leak_remove.icon';
import { matIconLegendToggle } from './matIcon-legend_toggle.icon';
import { matIconLensBlur } from './matIcon-lens_blur.icon';
import { matIconLens } from './matIcon-lens.icon';
import { matIconLibraryAddCheck } from './matIcon-library_add_check.icon';
import { matIconLibraryAdd } from './matIcon-library_add.icon';
import { matIconLibraryBooks } from './matIcon-library_books.icon';
import { matIconLibraryMusic } from './matIcon-library_music.icon';
import { matIconLightMode } from './matIcon-light_mode.icon';
import { matIconLight } from './matIcon-light.icon';
import { matIconLightbulbCircle } from './matIcon-lightbulb_circle.icon';
import { matIconLightbulb } from './matIcon-lightbulb.icon';
import { matIconLineAxis } from './matIcon-line_axis.icon';
import { matIconLineStyle } from './matIcon-line_style.icon';
import { matIconLineWeight } from './matIcon-line_weight.icon';
import { matIconLinearScale } from './matIcon-linear_scale.icon';
import { matIconLinkOff } from './matIcon-link_off.icon';
import { matIconLink } from './matIcon-link.icon';
import { matIconLinkedCamera } from './matIcon-linked_camera.icon';
import { matIconLiquor } from './matIcon-liquor.icon';
import { matIconListAlt } from './matIcon-list_alt.icon';
import { matIconList } from './matIcon-list.icon';
import { matIconLiveHelp } from './matIcon-live_help.icon';
import { matIconLiveTv } from './matIcon-live_tv.icon';
import { matIconLiving } from './matIcon-living.icon';
import { matIconLocalActivity } from './matIcon-local_activity.icon';
import { matIconLocalAirport } from './matIcon-local_airport.icon';
import { matIconLocalAtm } from './matIcon-local_atm.icon';
import { matIconLocalBar } from './matIcon-local_bar.icon';
import { matIconLocalCafe } from './matIcon-local_cafe.icon';
import { matIconLocalCarWash } from './matIcon-local_car_wash.icon';
import { matIconLocalConvenienceStore } from './matIcon-local_convenience_store.icon';
import { matIconLocalDining } from './matIcon-local_dining.icon';
import { matIconLocalDrink } from './matIcon-local_drink.icon';
import { matIconLocalFireDepartment } from './matIcon-local_fire_department.icon';
import { matIconLocalFlorist } from './matIcon-local_florist.icon';
import { matIconLocalGasStation } from './matIcon-local_gas_station.icon';
import { matIconLocalGroceryStore } from './matIcon-local_grocery_store.icon';
import { matIconLocalHospital } from './matIcon-local_hospital.icon';
import { matIconLocalHotel } from './matIcon-local_hotel.icon';
import { matIconLocalLaundryService } from './matIcon-local_laundry_service.icon';
import { matIconLocalLibrary } from './matIcon-local_library.icon';
import { matIconLocalMall } from './matIcon-local_mall.icon';
import { matIconLocalMovies } from './matIcon-local_movies.icon';
import { matIconLocalOffer } from './matIcon-local_offer.icon';
import { matIconLocalParking } from './matIcon-local_parking.icon';
import { matIconLocalPharmacy } from './matIcon-local_pharmacy.icon';
import { matIconLocalPhone } from './matIcon-local_phone.icon';
import { matIconLocalPizza } from './matIcon-local_pizza.icon';
import { matIconLocalPlay } from './matIcon-local_play.icon';
import { matIconLocalPolice } from './matIcon-local_police.icon';
import { matIconLocalPostOffice } from './matIcon-local_post_office.icon';
import { matIconLocalPrintshop } from './matIcon-local_printshop.icon';
import { matIconLocalSee } from './matIcon-local_see.icon';
import { matIconLocalShipping } from './matIcon-local_shipping.icon';
import { matIconLocalTaxi } from './matIcon-local_taxi.icon';
import { matIconLocationCity } from './matIcon-location_city.icon';
import { matIconLocationDisabled } from './matIcon-location_disabled.icon';
import { matIconLocationOff } from './matIcon-location_off.icon';
import { matIconLocationOn } from './matIcon-location_on.icon';
import { matIconLocationSearching } from './matIcon-location_searching.icon';
import { matIconLockClock } from './matIcon-lock_clock.icon';
import { matIconLockOpen } from './matIcon-lock_open.icon';
import { matIconLockPerson } from './matIcon-lock_person.icon';
import { matIconLockReset } from './matIcon-lock_reset.icon';
import { matIconLock } from './matIcon-lock.icon';
import { matIconLogin } from './matIcon-login.icon';
import { matIconLogoDev } from './matIcon-logo_dev.icon';
import { matIconLogout } from './matIcon-logout.icon';
import { matIconLooks3 } from './matIcon-looks_3.icon';
import { matIconLooks4 } from './matIcon-looks_4.icon';
import { matIconLooks5 } from './matIcon-looks_5.icon';
import { matIconLooks6 } from './matIcon-looks_6.icon';
import { matIconLooksOne } from './matIcon-looks_one.icon';
import { matIconLooksTwo } from './matIcon-looks_two.icon';
import { matIconLooks } from './matIcon-looks.icon';
import { matIconLoop } from './matIcon-loop.icon';
import { matIconLoupe } from './matIcon-loupe.icon';
import { matIconLowPriority } from './matIcon-low_priority.icon';
import { matIconLoyalty } from './matIcon-loyalty.icon';
import { matIconLteMobiledata } from './matIcon-lte_mobiledata.icon';
import { matIconLtePlusMobiledata } from './matIcon-lte_plus_mobiledata.icon';
import { matIconLuggage } from './matIcon-luggage.icon';
import { matIconLunchDining } from './matIcon-lunch_dining.icon';
import { matIconLyrics } from './matIcon-lyrics.icon';
import { matIconMacroOff } from './matIcon-macro_off.icon';
import { matIconMailLock } from './matIcon-mail_lock.icon';
import { matIconMailOutline } from './matIcon-mail_outline.icon';
import { matIconMail } from './matIcon-mail.icon';
import { matIconMale } from './matIcon-male.icon';
import { matIconMan2 } from './matIcon-man_2.icon';
import { matIconMan3 } from './matIcon-man_3.icon';
import { matIconMan4 } from './matIcon-man_4.icon';
import { matIconMan } from './matIcon-man.icon';
import { matIconManageAccounts } from './matIcon-manage_accounts.icon';
import { matIconManageHistory } from './matIcon-manage_history.icon';
import { matIconManageSearch } from './matIcon-manage_search.icon';
import { matIconMap } from './matIcon-map.icon';
import { matIconMapsHomeWork } from './matIcon-maps_home_work.icon';
import { matIconMapsUgc } from './matIcon-maps_ugc.icon';
import { matIconMargin } from './matIcon-margin.icon';
import { matIconMarkAsUnread } from './matIcon-mark_as_unread.icon';
import { matIconMarkChatRead } from './matIcon-mark_chat_read.icon';
import { matIconMarkChatUnread } from './matIcon-mark_chat_unread.icon';
import { matIconMarkEmailRead } from './matIcon-mark_email_read.icon';
import { matIconMarkEmailUnread } from './matIcon-mark_email_unread.icon';
import { matIconMarkUnreadChatAlt } from './matIcon-mark_unread_chat_alt.icon';
import { matIconMarkunreadMailbox } from './matIcon-markunread_mailbox.icon';
import { matIconMarkunread } from './matIcon-markunread.icon';
import { matIconMasks } from './matIcon-masks.icon';
import { matIconMaximize } from './matIcon-maximize.icon';
import { matIconMediaBluetoothOff } from './matIcon-media_bluetooth_off.icon';
import { matIconMediaBluetoothOn } from './matIcon-media_bluetooth_on.icon';
import { matIconMediation } from './matIcon-mediation.icon';
import { matIconMedicalInformation } from './matIcon-medical_information.icon';
import { matIconMedicalServices } from './matIcon-medical_services.icon';
import { matIconMedicationLiquid } from './matIcon-medication_liquid.icon';
import { matIconMedication } from './matIcon-medication.icon';
import { matIconMeetingRoom } from './matIcon-meeting_room.icon';
import { matIconMemory } from './matIcon-memory.icon';
import { matIconMenuBook } from './matIcon-menu_book.icon';
import { matIconMenuOpen } from './matIcon-menu_open.icon';
import { matIconMenu } from './matIcon-menu.icon';
import { matIconMergeType } from './matIcon-merge_type.icon';
import { matIconMerge } from './matIcon-merge.icon';
import { matIconMessage } from './matIcon-message.icon';
import { matIconMicExternalOff } from './matIcon-mic_external_off.icon';
import { matIconMicExternalOn } from './matIcon-mic_external_on.icon';
import { matIconMicNone } from './matIcon-mic_none.icon';
import { matIconMicOff } from './matIcon-mic_off.icon';
import { matIconMic } from './matIcon-mic.icon';
import { matIconMicrowave } from './matIcon-microwave.icon';
import { matIconMilitaryTech } from './matIcon-military_tech.icon';
import { matIconMinimize } from './matIcon-minimize.icon';
import { matIconMinorCrash } from './matIcon-minor_crash.icon';
import { matIconMiscellaneousServices } from './matIcon-miscellaneous_services.icon';
import { matIconMissedVideoCall } from './matIcon-missed_video_call.icon';
import { matIconMms } from './matIcon-mms.icon';
import { matIconMobileFriendly } from './matIcon-mobile_friendly.icon';
import { matIconMobileOff } from './matIcon-mobile_off.icon';
import { matIconMobileScreenShare } from './matIcon-mobile_screen_share.icon';
import { matIconMobiledataOff } from './matIcon-mobiledata_off.icon';
import { matIconModeComment } from './matIcon-mode_comment.icon';
import { matIconModeEditOutline } from './matIcon-mode_edit_outline.icon';
import { matIconModeEdit } from './matIcon-mode_edit.icon';
import { matIconModeFanOff } from './matIcon-mode_fan_off.icon';
import { matIconModeNight } from './matIcon-mode_night.icon';
import { matIconModeOfTravel } from './matIcon-mode_of_travel.icon';
import { matIconModeStandby } from './matIcon-mode_standby.icon';
import { matIconMode } from './matIcon-mode.icon';
import { matIconModelTraining } from './matIcon-model_training.icon';
import { matIconMonetizationOn } from './matIcon-monetization_on.icon';
import { matIconMoneyOffCsred } from './matIcon-money_off_csred.icon';
import { matIconMoneyOff } from './matIcon-money_off.icon';
import { matIconMoney } from './matIcon-money.icon';
import { matIconMonitorHeart } from './matIcon-monitor_heart.icon';
import { matIconMonitorWeight } from './matIcon-monitor_weight.icon';
import { matIconMonitor } from './matIcon-monitor.icon';
import { matIconMonochromePhotos } from './matIcon-monochrome_photos.icon';
import { matIconMoodBad } from './matIcon-mood_bad.icon';
import { matIconMood } from './matIcon-mood.icon';
import { matIconMoped } from './matIcon-moped.icon';
import { matIconMoreHoriz } from './matIcon-more_horiz.icon';
import { matIconMoreTime } from './matIcon-more_time.icon';
import { matIconMoreVert } from './matIcon-more_vert.icon';
import { matIconMore } from './matIcon-more.icon';
import { matIconMosque } from './matIcon-mosque.icon';
import { matIconMotionPhotosAuto } from './matIcon-motion_photos_auto.icon';
import { matIconMotionPhotosOff } from './matIcon-motion_photos_off.icon';
import { matIconMotionPhotosOn } from './matIcon-motion_photos_on.icon';
import { matIconMotionPhotosPause } from './matIcon-motion_photos_pause.icon';
import { matIconMotionPhotosPaused } from './matIcon-motion_photos_paused.icon';
import { matIconMouse } from './matIcon-mouse.icon';
import { matIconMoveDown } from './matIcon-move_down.icon';
import { matIconMoveToInbox } from './matIcon-move_to_inbox.icon';
import { matIconMoveUp } from './matIcon-move_up.icon';
import { matIconMovieCreation } from './matIcon-movie_creation.icon';
import { matIconMovieFilter } from './matIcon-movie_filter.icon';
import { matIconMovie } from './matIcon-movie.icon';
import { matIconMoving } from './matIcon-moving.icon';
import { matIconMp } from './matIcon-mp.icon';
import { matIconMultilineChart } from './matIcon-multiline_chart.icon';
import { matIconMultipleStop } from './matIcon-multiple_stop.icon';
import { matIconMuseum } from './matIcon-museum.icon';
import { matIconMusicNote } from './matIcon-music_note.icon';
import { matIconMusicOff } from './matIcon-music_off.icon';
import { matIconMusicVideo } from './matIcon-music_video.icon';
import { matIconMyLocation } from './matIcon-my_location.icon';
import { matIconNat } from './matIcon-nat.icon';
import { matIconNaturePeople } from './matIcon-nature_people.icon';
import { matIconNature } from './matIcon-nature.icon';
import { matIconNavigateBefore } from './matIcon-navigate_before.icon';
import { matIconNavigateNext } from './matIcon-navigate_next.icon';
import { matIconNavigation } from './matIcon-navigation.icon';
import { matIconNearMeDisabled } from './matIcon-near_me_disabled.icon';
import { matIconNearMe } from './matIcon-near_me.icon';
import { matIconNearbyError } from './matIcon-nearby_error.icon';
import { matIconNearbyOff } from './matIcon-nearby_off.icon';
import { matIconNestCamWiredStand } from './matIcon-nest_cam_wired_stand.icon';
import { matIconNetworkCell } from './matIcon-network_cell.icon';
import { matIconNetworkCheck } from './matIcon-network_check.icon';
import { matIconNetworkLocked } from './matIcon-network_locked.icon';
import { matIconNetworkPing } from './matIcon-network_ping.icon';
import { matIconNetworkWifi1Bar } from './matIcon-network_wifi_1_bar.icon';
import { matIconNetworkWifi2Bar } from './matIcon-network_wifi_2_bar.icon';
import { matIconNetworkWifi3Bar } from './matIcon-network_wifi_3_bar.icon';
import { matIconNetworkWifi } from './matIcon-network_wifi.icon';
import { matIconNewLabel } from './matIcon-new_label.icon';
import { matIconNewReleases } from './matIcon-new_releases.icon';
import { matIconNewspaper } from './matIcon-newspaper.icon';
import { matIconNextPlan } from './matIcon-next_plan.icon';
import { matIconNextWeek } from './matIcon-next_week.icon';
import { matIconNfc } from './matIcon-nfc.icon';
import { matIconNightShelter } from './matIcon-night_shelter.icon';
import { matIconNightlife } from './matIcon-nightlife.icon';
import { matIconNightlightRound } from './matIcon-nightlight_round.icon';
import { matIconNightlight } from './matIcon-nightlight.icon';
import { matIconNightsStay } from './matIcon-nights_stay.icon';
import { matIconNoAccounts } from './matIcon-no_accounts.icon';
import { matIconNoAdultContent } from './matIcon-no_adult_content.icon';
import { matIconNoBackpack } from './matIcon-no_backpack.icon';
import { matIconNoCell } from './matIcon-no_cell.icon';
import { matIconNoCrash } from './matIcon-no_crash.icon';
import { matIconNoDrinks } from './matIcon-no_drinks.icon';
import { matIconNoEncryptionGmailerrorred } from './matIcon-no_encryption_gmailerrorred.icon';
import { matIconNoEncryption } from './matIcon-no_encryption.icon';
import { matIconNoFlash } from './matIcon-no_flash.icon';
import { matIconNoFood } from './matIcon-no_food.icon';
import { matIconNoLuggage } from './matIcon-no_luggage.icon';
import { matIconNoMeals } from './matIcon-no_meals.icon';
import { matIconNoMeetingRoom } from './matIcon-no_meeting_room.icon';
import { matIconNoPhotography } from './matIcon-no_photography.icon';
import { matIconNoSim } from './matIcon-no_sim.icon';
import { matIconNoStroller } from './matIcon-no_stroller.icon';
import { matIconNoTransfer } from './matIcon-no_transfer.icon';
import { matIconNoiseAware } from './matIcon-noise_aware.icon';
import { matIconNoiseControlOff } from './matIcon-noise_control_off.icon';
import { matIconNordicWalking } from './matIcon-nordic_walking.icon';
import { matIconNorthEast } from './matIcon-north_east.icon';
import { matIconNorthWest } from './matIcon-north_west.icon';
import { matIconNorth } from './matIcon-north.icon';
import { matIconNotAccessible } from './matIcon-not_accessible.icon';
import { matIconNotInterested } from './matIcon-not_interested.icon';
import { matIconNotListedLocation } from './matIcon-not_listed_location.icon';
import { matIconNotStarted } from './matIcon-not_started.icon';
import { matIconNoteAdd } from './matIcon-note_add.icon';
import { matIconNoteAlt } from './matIcon-note_alt.icon';
import { matIconNote } from './matIcon-note.icon';
import { matIconNotes } from './matIcon-notes.icon';
import { matIconNotificationAdd } from './matIcon-notification_add.icon';
import { matIconNotificationImportant } from './matIcon-notification_important.icon';
import { matIconNotificationsActive } from './matIcon-notifications_active.icon';
import { matIconNotificationsNone } from './matIcon-notifications_none.icon';
import { matIconNotificationsOff } from './matIcon-notifications_off.icon';
import { matIconNotificationsPaused } from './matIcon-notifications_paused.icon';
import { matIconNotifications } from './matIcon-notifications.icon';
import { matIconNumbers } from './matIcon-numbers.icon';
import { matIconOfflineBolt } from './matIcon-offline_bolt.icon';
import { matIconOfflinePin } from './matIcon-offline_pin.icon';
import { matIconOfflineShare } from './matIcon-offline_share.icon';
import { matIconOilBarrel } from './matIcon-oil_barrel.icon';
import { matIconOnDeviceTraining } from './matIcon-on_device_training.icon';
import { matIconOndemandVideo } from './matIcon-ondemand_video.icon';
import { matIconOnlinePrediction } from './matIcon-online_prediction.icon';
import { matIconOpacity } from './matIcon-opacity.icon';
import { matIconOpenInBrowser } from './matIcon-open_in_browser.icon';
import { matIconOpenInFull } from './matIcon-open_in_full.icon';
import { matIconOpenInNewOff } from './matIcon-open_in_new_off.icon';
import { matIconOpenInNew } from './matIcon-open_in_new.icon';
import { matIconOpenWith } from './matIcon-open_with.icon';
import { matIconOtherHouses } from './matIcon-other_houses.icon';
import { matIconOutbound } from './matIcon-outbound.icon';
import { matIconOutbox } from './matIcon-outbox.icon';
import { matIconOutdoorGrill } from './matIcon-outdoor_grill.icon';
import { matIconOutlet } from './matIcon-outlet.icon';
import { matIconOutlinedFlag } from './matIcon-outlined_flag.icon';
import { matIconOutput } from './matIcon-output.icon';
import { matIconPadding } from './matIcon-padding.icon';
import { matIconPages } from './matIcon-pages.icon';
import { matIconPageview } from './matIcon-pageview.icon';
import { matIconPaid } from './matIcon-paid.icon';
import { matIconPalette } from './matIcon-palette.icon';
import { matIconPanToolAlt } from './matIcon-pan_tool_alt.icon';
import { matIconPanTool } from './matIcon-pan_tool.icon';
import { matIconPanoramaFishEye } from './matIcon-panorama_fish_eye.icon';
import { matIconPanoramaHorizontalSelect } from './matIcon-panorama_horizontal_select.icon';
import { matIconPanoramaHorizontal } from './matIcon-panorama_horizontal.icon';
import { matIconPanoramaPhotosphereSelect } from './matIcon-panorama_photosphere_select.icon';
import { matIconPanoramaPhotosphere } from './matIcon-panorama_photosphere.icon';
import { matIconPanoramaVerticalSelect } from './matIcon-panorama_vertical_select.icon';
import { matIconPanoramaVertical } from './matIcon-panorama_vertical.icon';
import { matIconPanoramaWideAngleSelect } from './matIcon-panorama_wide_angle_select.icon';
import { matIconPanoramaWideAngle } from './matIcon-panorama_wide_angle.icon';
import { matIconPanorama } from './matIcon-panorama.icon';
import { matIconParagliding } from './matIcon-paragliding.icon';
import { matIconPark } from './matIcon-park.icon';
import { matIconPartyMode } from './matIcon-party_mode.icon';
import { matIconPassword } from './matIcon-password.icon';
import { matIconPattern } from './matIcon-pattern.icon';
import { matIconPauseCircleFilled } from './matIcon-pause_circle_filled.icon';
import { matIconPauseCircleOutline } from './matIcon-pause_circle_outline.icon';
import { matIconPauseCircle } from './matIcon-pause_circle.icon';
import { matIconPausePresentation } from './matIcon-pause_presentation.icon';
import { matIconPause } from './matIcon-pause.icon';
import { matIconPayment } from './matIcon-payment.icon';
import { matIconPayments } from './matIcon-payments.icon';
import { matIconPedalBike } from './matIcon-pedal_bike.icon';
import { matIconPendingActions } from './matIcon-pending_actions.icon';
import { matIconPending } from './matIcon-pending.icon';
import { matIconPentagon } from './matIcon-pentagon.icon';
import { matIconPeopleAlt } from './matIcon-people_alt.icon';
import { matIconPeopleOutline } from './matIcon-people_outline.icon';
import { matIconPeople } from './matIcon-people.icon';
import { matIconPercent } from './matIcon-percent.icon';
import { matIconPermCameraMic } from './matIcon-perm_camera_mic.icon';
import { matIconPermContactCalendar } from './matIcon-perm_contact_calendar.icon';
import { matIconPermDataSetting } from './matIcon-perm_data_setting.icon';
import { matIconPermDeviceInformation } from './matIcon-perm_device_information.icon';
import { matIconPermIdentity } from './matIcon-perm_identity.icon';
import { matIconPermMedia } from './matIcon-perm_media.icon';
import { matIconPermPhoneMsg } from './matIcon-perm_phone_msg.icon';
import { matIconPermScanWifi } from './matIcon-perm_scan_wifi.icon';
import { matIconPerson2 } from './matIcon-person_2.icon';
import { matIconPerson3 } from './matIcon-person_3.icon';
import { matIconPerson4 } from './matIcon-person_4.icon';
import { matIconPersonAddAlt1 } from './matIcon-person_add_alt_1.icon';
import { matIconPersonAddAlt } from './matIcon-person_add_alt.icon';
import { matIconPersonAddDisabled } from './matIcon-person_add_disabled.icon';
import { matIconPersonAdd } from './matIcon-person_add.icon';
import { matIconPersonOff } from './matIcon-person_off.icon';
import { matIconPersonOutline } from './matIcon-person_outline.icon';
import { matIconPersonPinCircle } from './matIcon-person_pin_circle.icon';
import { matIconPersonPin } from './matIcon-person_pin.icon';
import { matIconPersonRemoveAlt1 } from './matIcon-person_remove_alt_1.icon';
import { matIconPersonRemove } from './matIcon-person_remove.icon';
import { matIconPersonSearch } from './matIcon-person_search.icon';
import { matIconPerson } from './matIcon-person.icon';
import { matIconPersonalInjury } from './matIcon-personal_injury.icon';
import { matIconPersonalVideo } from './matIcon-personal_video.icon';
import { matIconPestControlRodent } from './matIcon-pest_control_rodent.icon';
import { matIconPestControl } from './matIcon-pest_control.icon';
import { matIconPets } from './matIcon-pets.icon';
import { matIconPhishing } from './matIcon-phishing.icon';
import { matIconPhoneAndroid } from './matIcon-phone_android.icon';
import { matIconPhoneBluetoothSpeaker } from './matIcon-phone_bluetooth_speaker.icon';
import { matIconPhoneCallback } from './matIcon-phone_callback.icon';
import { matIconPhoneDisabled } from './matIcon-phone_disabled.icon';
import { matIconPhoneEnabled } from './matIcon-phone_enabled.icon';
import { matIconPhoneForwarded } from './matIcon-phone_forwarded.icon';
import { matIconPhoneIphone } from './matIcon-phone_iphone.icon';
import { matIconPhoneLocked } from './matIcon-phone_locked.icon';
import { matIconPhoneMissed } from './matIcon-phone_missed.icon';
import { matIconPhonePaused } from './matIcon-phone_paused.icon';
import { matIconPhone } from './matIcon-phone.icon';
import { matIconPhonelinkErase } from './matIcon-phonelink_erase.icon';
import { matIconPhonelinkLock } from './matIcon-phonelink_lock.icon';
import { matIconPhonelinkOff } from './matIcon-phonelink_off.icon';
import { matIconPhonelinkRing } from './matIcon-phonelink_ring.icon';
import { matIconPhonelinkSetup } from './matIcon-phonelink_setup.icon';
import { matIconPhonelink } from './matIcon-phonelink.icon';
import { matIconPhotoAlbum } from './matIcon-photo_album.icon';
import { matIconPhotoCameraBack } from './matIcon-photo_camera_back.icon';
import { matIconPhotoCameraFront } from './matIcon-photo_camera_front.icon';
import { matIconPhotoCamera } from './matIcon-photo_camera.icon';
import { matIconPhotoFilter } from './matIcon-photo_filter.icon';
import { matIconPhotoLibrary } from './matIcon-photo_library.icon';
import { matIconPhotoSizeSelectActual } from './matIcon-photo_size_select_actual.icon';
import { matIconPhotoSizeSelectLarge } from './matIcon-photo_size_select_large.icon';
import { matIconPhotoSizeSelectSmall } from './matIcon-photo_size_select_small.icon';
import { matIconPhoto } from './matIcon-photo.icon';
import { matIconPhp } from './matIcon-php.icon';
import { matIconPianoOff } from './matIcon-piano_off.icon';
import { matIconPiano } from './matIcon-piano.icon';
import { matIconPictureAsPdf } from './matIcon-picture_as_pdf.icon';
import { matIconPictureInPictureAlt } from './matIcon-picture_in_picture_alt.icon';
import { matIconPictureInPicture } from './matIcon-picture_in_picture.icon';
import { matIconPieChartOutline } from './matIcon-pie_chart_outline.icon';
import { matIconPieChart } from './matIcon-pie_chart.icon';
import { matIconPinDrop } from './matIcon-pin_drop.icon';
import { matIconPinEnd } from './matIcon-pin_end.icon';
import { matIconPinInvoke } from './matIcon-pin_invoke.icon';
import { matIconPin } from './matIcon-pin.icon';
import { matIconPinch } from './matIcon-pinch.icon';
import { matIconPivotTableChart } from './matIcon-pivot_table_chart.icon';
import { matIconPix } from './matIcon-pix.icon';
import { matIconPlace } from './matIcon-place.icon';
import { matIconPlagiarism } from './matIcon-plagiarism.icon';
import { matIconPlayArrow } from './matIcon-play_arrow.icon';
import { matIconPlayCircleFilled } from './matIcon-play_circle_filled.icon';
import { matIconPlayCircleOutline } from './matIcon-play_circle_outline.icon';
import { matIconPlayCircle } from './matIcon-play_circle.icon';
import { matIconPlayDisabled } from './matIcon-play_disabled.icon';
import { matIconPlayForWork } from './matIcon-play_for_work.icon';
import { matIconPlayLesson } from './matIcon-play_lesson.icon';
import { matIconPlaylistAddCheckCircle } from './matIcon-playlist_add_check_circle.icon';
import { matIconPlaylistAddCheck } from './matIcon-playlist_add_check.icon';
import { matIconPlaylistAddCircle } from './matIcon-playlist_add_circle.icon';
import { matIconPlaylistAdd } from './matIcon-playlist_add.icon';
import { matIconPlaylistPlay } from './matIcon-playlist_play.icon';
import { matIconPlaylistRemove } from './matIcon-playlist_remove.icon';
import { matIconPlumbing } from './matIcon-plumbing.icon';
import { matIconPlusOne } from './matIcon-plus_one.icon';
import { matIconPodcasts } from './matIcon-podcasts.icon';
import { matIconPointOfSale } from './matIcon-point_of_sale.icon';
import { matIconPolicy } from './matIcon-policy.icon';
import { matIconPoll } from './matIcon-poll.icon';
import { matIconPolyline } from './matIcon-polyline.icon';
import { matIconPolymer } from './matIcon-polymer.icon';
import { matIconPool } from './matIcon-pool.icon';
import { matIconPortableWifiOff } from './matIcon-portable_wifi_off.icon';
import { matIconPortrait } from './matIcon-portrait.icon';
import { matIconPostAdd } from './matIcon-post_add.icon';
import { matIconPowerInput } from './matIcon-power_input.icon';
import { matIconPowerOff } from './matIcon-power_off.icon';
import { matIconPowerSettingsNew } from './matIcon-power_settings_new.icon';
import { matIconPower } from './matIcon-power.icon';
import { matIconPrecisionManufacturing } from './matIcon-precision_manufacturing.icon';
import { matIconPregnantWoman } from './matIcon-pregnant_woman.icon';
import { matIconPresentToAll } from './matIcon-present_to_all.icon';
import { matIconPreview } from './matIcon-preview.icon';
import { matIconPriceChange } from './matIcon-price_change.icon';
import { matIconPriceCheck } from './matIcon-price_check.icon';
import { matIconPrintDisabled } from './matIcon-print_disabled.icon';
import { matIconPrint } from './matIcon-print.icon';
import { matIconPriorityHigh } from './matIcon-priority_high.icon';
import { matIconPrivacyTip } from './matIcon-privacy_tip.icon';
import { matIconPrivateConnectivity } from './matIcon-private_connectivity.icon';
import { matIconProductionQuantityLimits } from './matIcon-production_quantity_limits.icon';
import { matIconPropaneTank } from './matIcon-propane_tank.icon';
import { matIconPropane } from './matIcon-propane.icon';
import { matIconPsychologyAlt } from './matIcon-psychology_alt.icon';
import { matIconPsychology } from './matIcon-psychology.icon';
import { matIconPublicOff } from './matIcon-public_off.icon';
import { matIconPublic } from './matIcon-public.icon';
import { matIconPublish } from './matIcon-publish.icon';
import { matIconPublishedWithChanges } from './matIcon-published_with_changes.icon';
import { matIconPunchClock } from './matIcon-punch_clock.icon';
import { matIconPushPin } from './matIcon-push_pin.icon';
import { matIconQrCode2 } from './matIcon-qr_code_2.icon';
import { matIconQrCodeScanner } from './matIcon-qr_code_scanner.icon';
import { matIconQrCode } from './matIcon-qr_code.icon';
import { matIconQueryBuilder } from './matIcon-query_builder.icon';
import { matIconQueryStats } from './matIcon-query_stats.icon';
import { matIconQuestionAnswer } from './matIcon-question_answer.icon';
import { matIconQuestionMark } from './matIcon-question_mark.icon';
import { matIconQueueMusic } from './matIcon-queue_music.icon';
import { matIconQueuePlayNext } from './matIcon-queue_play_next.icon';
import { matIconQueue } from './matIcon-queue.icon';
import { matIconQuickreply } from './matIcon-quickreply.icon';
import { matIconQuiz } from './matIcon-quiz.icon';
import { matIconRMobiledata } from './matIcon-r_mobiledata.icon';
import { matIconRadar } from './matIcon-radar.icon';
import { matIconRadioButtonChecked } from './matIcon-radio_button_checked.icon';
import { matIconRadioButtonUnchecked } from './matIcon-radio_button_unchecked.icon';
import { matIconRadio } from './matIcon-radio.icon';
import { matIconRailwayAlert } from './matIcon-railway_alert.icon';
import { matIconRamenDining } from './matIcon-ramen_dining.icon';
import { matIconRampLeft } from './matIcon-ramp_left.icon';
import { matIconRampRight } from './matIcon-ramp_right.icon';
import { matIconRateReview } from './matIcon-rate_review.icon';
import { matIconRawOff } from './matIcon-raw_off.icon';
import { matIconRawOn } from './matIcon-raw_on.icon';
import { matIconReadMore } from './matIcon-read_more.icon';
import { matIconRealEstateAgent } from './matIcon-real_estate_agent.icon';
import { matIconReceiptLong } from './matIcon-receipt_long.icon';
import { matIconReceipt } from './matIcon-receipt.icon';
import { matIconRecentActors } from './matIcon-recent_actors.icon';
import { matIconRecommend } from './matIcon-recommend.icon';
import { matIconRecordVoiceOver } from './matIcon-record_voice_over.icon';
import { matIconRectangle } from './matIcon-rectangle.icon';
import { matIconRecycling } from './matIcon-recycling.icon';
import { matIconRedeem } from './matIcon-redeem.icon';
import { matIconRedo } from './matIcon-redo.icon';
import { matIconReduceCapacity } from './matIcon-reduce_capacity.icon';
import { matIconRefresh } from './matIcon-refresh.icon';
import { matIconRememberMe } from './matIcon-remember_me.icon';
import { matIconRemoveCircleOutline } from './matIcon-remove_circle_outline.icon';
import { matIconRemoveCircle } from './matIcon-remove_circle.icon';
import { matIconRemoveDone } from './matIcon-remove_done.icon';
import { matIconRemoveFromQueue } from './matIcon-remove_from_queue.icon';
import { matIconRemoveModerator } from './matIcon-remove_moderator.icon';
import { matIconRemoveRedEye } from './matIcon-remove_red_eye.icon';
import { matIconRemoveRoad } from './matIcon-remove_road.icon';
import { matIconRemoveShoppingCart } from './matIcon-remove_shopping_cart.icon';
import { matIconRemove } from './matIcon-remove.icon';
import { matIconReorder } from './matIcon-reorder.icon';
import { matIconRepartition } from './matIcon-repartition.icon';
import { matIconRepeatOn } from './matIcon-repeat_on.icon';
import { matIconRepeatOneOn } from './matIcon-repeat_one_on.icon';
import { matIconRepeatOne } from './matIcon-repeat_one.icon';
import { matIconRepeat } from './matIcon-repeat.icon';
import { matIconReplay10 } from './matIcon-replay_10.icon';
import { matIconReplay30 } from './matIcon-replay_30.icon';
import { matIconReplay5 } from './matIcon-replay_5.icon';
import { matIconReplayCircleFilled } from './matIcon-replay_circle_filled.icon';
import { matIconReplay } from './matIcon-replay.icon';
import { matIconReplyAll } from './matIcon-reply_all.icon';
import { matIconReply } from './matIcon-reply.icon';
import { matIconReportGmailerrorred } from './matIcon-report_gmailerrorred.icon';
import { matIconReportOff } from './matIcon-report_off.icon';
import { matIconReportProblem } from './matIcon-report_problem.icon';
import { matIconReport } from './matIcon-report.icon';
import { matIconRequestPage } from './matIcon-request_page.icon';
import { matIconRequestQuote } from './matIcon-request_quote.icon';
import { matIconResetTv } from './matIcon-reset_tv.icon';
import { matIconRestartAlt } from './matIcon-restart_alt.icon';
import { matIconRestaurantMenu } from './matIcon-restaurant_menu.icon';
import { matIconRestaurant } from './matIcon-restaurant.icon';
import { matIconRestoreFromTrash } from './matIcon-restore_from_trash.icon';
import { matIconRestorePage } from './matIcon-restore_page.icon';
import { matIconRestore } from './matIcon-restore.icon';
import { matIconReviews } from './matIcon-reviews.icon';
import { matIconRiceBowl } from './matIcon-rice_bowl.icon';
import { matIconRingVolume } from './matIcon-ring_volume.icon';
import { matIconRocketLaunch } from './matIcon-rocket_launch.icon';
import { matIconRocket } from './matIcon-rocket.icon';
import { matIconRollerShadesClosed } from './matIcon-roller_shades_closed.icon';
import { matIconRollerShades } from './matIcon-roller_shades.icon';
import { matIconRollerSkating } from './matIcon-roller_skating.icon';
import { matIconRoofing } from './matIcon-roofing.icon';
import { matIconRoomPreferences } from './matIcon-room_preferences.icon';
import { matIconRoomService } from './matIcon-room_service.icon';
import { matIconRoom } from './matIcon-room.icon';
import { matIconRotate90DegreesCcw } from './matIcon-rotate_90_degrees_ccw.icon';
import { matIconRotate90DegreesCw } from './matIcon-rotate_90_degrees_cw.icon';
import { matIconRotateLeft } from './matIcon-rotate_left.icon';
import { matIconRotateRight } from './matIcon-rotate_right.icon';
import { matIconRoundaboutLeft } from './matIcon-roundabout_left.icon';
import { matIconRoundaboutRight } from './matIcon-roundabout_right.icon';
import { matIconRoundedCorner } from './matIcon-rounded_corner.icon';
import { matIconRoute } from './matIcon-route.icon';
import { matIconRouter } from './matIcon-router.icon';
import { matIconRowing } from './matIcon-rowing.icon';
import { matIconRssFeed } from './matIcon-rss_feed.icon';
import { matIconRsvp } from './matIcon-rsvp.icon';
import { matIconRtt } from './matIcon-rtt.icon';
import { matIconRuleFolder } from './matIcon-rule_folder.icon';
import { matIconRule } from './matIcon-rule.icon';
import { matIconRunCircle } from './matIcon-run_circle.icon';
import { matIconRunningWithErrors } from './matIcon-running_with_errors.icon';
import { matIconRvHookup } from './matIcon-rv_hookup.icon';
import { matIconSafetyCheck } from './matIcon-safety_check.icon';
import { matIconSafetyDivider } from './matIcon-safety_divider.icon';
import { matIconSailing } from './matIcon-sailing.icon';
import { matIconSanitizer } from './matIcon-sanitizer.icon';
import { matIconSatelliteAlt } from './matIcon-satellite_alt.icon';
import { matIconSatellite } from './matIcon-satellite.icon';
import { matIconSaveAlt } from './matIcon-save_alt.icon';
import { matIconSaveAs } from './matIcon-save_as.icon';
import { matIconSave } from './matIcon-save.icon';
import { matIconSavedSearch } from './matIcon-saved_search.icon';
import { matIconSavings } from './matIcon-savings.icon';
import { matIconScale } from './matIcon-scale.icon';
import { matIconScanner } from './matIcon-scanner.icon';
import { matIconScatterPlot } from './matIcon-scatter_plot.icon';
import { matIconScheduleSend } from './matIcon-schedule_send.icon';
import { matIconSchedule } from './matIcon-schedule.icon';
import { matIconSchema } from './matIcon-schema.icon';
import { matIconSchool } from './matIcon-school.icon';
import { matIconScience } from './matIcon-science.icon';
import { matIconScore } from './matIcon-score.icon';
import { matIconScoreboard } from './matIcon-scoreboard.icon';
import { matIconScreenLockLandscape } from './matIcon-screen_lock_landscape.icon';
import { matIconScreenLockPortrait } from './matIcon-screen_lock_portrait.icon';
import { matIconScreenLockRotation } from './matIcon-screen_lock_rotation.icon';
import { matIconScreenRotationAlt } from './matIcon-screen_rotation_alt.icon';
import { matIconScreenRotation } from './matIcon-screen_rotation.icon';
import { matIconScreenSearchDesktop } from './matIcon-screen_search_desktop.icon';
import { matIconScreenShare } from './matIcon-screen_share.icon';
import { matIconScreenshotMonitor } from './matIcon-screenshot_monitor.icon';
import { matIconScreenshot } from './matIcon-screenshot.icon';
import { matIconScubaDiving } from './matIcon-scuba_diving.icon';
import { matIconSdCardAlert } from './matIcon-sd_card_alert.icon';
import { matIconSdCard } from './matIcon-sd_card.icon';
import { matIconSdStorage } from './matIcon-sd_storage.icon';
import { matIconSd } from './matIcon-sd.icon';
import { matIconSearchOff } from './matIcon-search_off.icon';
import { matIconSearch } from './matIcon-search.icon';
import { matIconSecurityUpdateGood } from './matIcon-security_update_good.icon';
import { matIconSecurityUpdateWarning } from './matIcon-security_update_warning.icon';
import { matIconSecurityUpdate } from './matIcon-security_update.icon';
import { matIconSecurity } from './matIcon-security.icon';
import { matIconSegment } from './matIcon-segment.icon';
import { matIconSelectAll } from './matIcon-select_all.icon';
import { matIconSelfImprovement } from './matIcon-self_improvement.icon';
import { matIconSell } from './matIcon-sell.icon';
import { matIconSendAndArchive } from './matIcon-send_and_archive.icon';
import { matIconSendTimeExtension } from './matIcon-send_time_extension.icon';
import { matIconSendToMobile } from './matIcon-send_to_mobile.icon';
import { matIconSend } from './matIcon-send.icon';
import { matIconSensorDoor } from './matIcon-sensor_door.icon';
import { matIconSensorOccupied } from './matIcon-sensor_occupied.icon';
import { matIconSensorWindow } from './matIcon-sensor_window.icon';
import { matIconSensorsOff } from './matIcon-sensors_off.icon';
import { matIconSensors } from './matIcon-sensors.icon';
import { matIconSentimentDissatisfied } from './matIcon-sentiment_dissatisfied.icon';
import { matIconSentimentNeutral } from './matIcon-sentiment_neutral.icon';
import { matIconSentimentSatisfiedAlt } from './matIcon-sentiment_satisfied_alt.icon';
import { matIconSentimentSatisfied } from './matIcon-sentiment_satisfied.icon';
import { matIconSentimentVeryDissatisfied } from './matIcon-sentiment_very_dissatisfied.icon';
import { matIconSentimentVerySatisfied } from './matIcon-sentiment_very_satisfied.icon';
import { matIconSetMeal } from './matIcon-set_meal.icon';
import { matIconSettingsAccessibility } from './matIcon-settings_accessibility.icon';
import { matIconSettingsApplications } from './matIcon-settings_applications.icon';
import { matIconSettingsBackupRestore } from './matIcon-settings_backup_restore.icon';
import { matIconSettingsBluetooth } from './matIcon-settings_bluetooth.icon';
import { matIconSettingsBrightness } from './matIcon-settings_brightness.icon';
import { matIconSettingsCell } from './matIcon-settings_cell.icon';
import { matIconSettingsEthernet } from './matIcon-settings_ethernet.icon';
import { matIconSettingsInputAntenna } from './matIcon-settings_input_antenna.icon';
import { matIconSettingsInputComponent } from './matIcon-settings_input_component.icon';
import { matIconSettingsInputComposite } from './matIcon-settings_input_composite.icon';
import { matIconSettingsInputHdmi } from './matIcon-settings_input_hdmi.icon';
import { matIconSettingsInputSvideo } from './matIcon-settings_input_svideo.icon';
import { matIconSettingsOverscan } from './matIcon-settings_overscan.icon';
import { matIconSettingsPhone } from './matIcon-settings_phone.icon';
import { matIconSettingsPower } from './matIcon-settings_power.icon';
import { matIconSettingsRemote } from './matIcon-settings_remote.icon';
import { matIconSettingsSuggest } from './matIcon-settings_suggest.icon';
import { matIconSettingsSystemDaydream } from './matIcon-settings_system_daydream.icon';
import { matIconSettingsVoice } from './matIcon-settings_voice.icon';
import { matIconSettings } from './matIcon-settings.icon';
import { matIconSevereCold } from './matIcon-severe_cold.icon';
import { matIconShapeLine } from './matIcon-shape_line.icon';
import { matIconShareLocation } from './matIcon-share_location.icon';
import { matIconShare } from './matIcon-share.icon';
import { matIconShieldMoon } from './matIcon-shield_moon.icon';
import { matIconShield } from './matIcon-shield.icon';
import { matIconShop2 } from './matIcon-shop_2.icon';
import { matIconShopTwo } from './matIcon-shop_two.icon';
import { matIconShop } from './matIcon-shop.icon';
import { matIconShoppingBag } from './matIcon-shopping_bag.icon';
import { matIconShoppingBasket } from './matIcon-shopping_basket.icon';
import { matIconShoppingCartCheckout } from './matIcon-shopping_cart_checkout.icon';
import { matIconShoppingCart } from './matIcon-shopping_cart.icon';
import { matIconShortText } from './matIcon-short_text.icon';
import { matIconShortcut } from './matIcon-shortcut.icon';
import { matIconShowChart } from './matIcon-show_chart.icon';
import { matIconShower } from './matIcon-shower.icon';
import { matIconShuffleOn } from './matIcon-shuffle_on.icon';
import { matIconShuffle } from './matIcon-shuffle.icon';
import { matIconShutterSpeed } from './matIcon-shutter_speed.icon';
import { matIconSick } from './matIcon-sick.icon';
import { matIconSignLanguage } from './matIcon-sign_language.icon';
import { matIconSignalCellular0Bar } from './matIcon-signal_cellular_0_bar.icon';
import { matIconSignalCellular4Bar } from './matIcon-signal_cellular_4_bar.icon';
import { matIconSignalCellularAlt1Bar } from './matIcon-signal_cellular_alt_1_bar.icon';
import { matIconSignalCellularAlt2Bar } from './matIcon-signal_cellular_alt_2_bar.icon';
import { matIconSignalCellularAlt } from './matIcon-signal_cellular_alt.icon';
import { matIconSignalCellularConnectedNoInternet0Bar } from './matIcon-signal_cellular_connected_no_internet_0_bar.icon';
import { matIconSignalCellularConnectedNoInternet4Bar } from './matIcon-signal_cellular_connected_no_internet_4_bar.icon';
import { matIconSignalCellularNoSim } from './matIcon-signal_cellular_no_sim.icon';
import { matIconSignalCellularNodata } from './matIcon-signal_cellular_nodata.icon';
import { matIconSignalCellularNull } from './matIcon-signal_cellular_null.icon';
import { matIconSignalCellularOff } from './matIcon-signal_cellular_off.icon';
import { matIconSignalWifi0Bar } from './matIcon-signal_wifi_0_bar.icon';
import { matIconSignalWifi4BarLock } from './matIcon-signal_wifi_4_bar_lock.icon';
import { matIconSignalWifi4Bar } from './matIcon-signal_wifi_4_bar.icon';
import { matIconSignalWifiBad } from './matIcon-signal_wifi_bad.icon';
import { matIconSignalWifiConnectedNoInternet4 } from './matIcon-signal_wifi_connected_no_internet_4.icon';
import { matIconSignalWifiOff } from './matIcon-signal_wifi_off.icon';
import { matIconSignalWifiStatusbar4Bar } from './matIcon-signal_wifi_statusbar_4_bar.icon';
import { matIconSignalWifiStatusbarConnectedNoInternet4 } from './matIcon-signal_wifi_statusbar_connected_no_internet_4.icon';
import { matIconSignalWifiStatusbarNull } from './matIcon-signal_wifi_statusbar_null.icon';
import { matIconSignpost } from './matIcon-signpost.icon';
import { matIconSimCardAlert } from './matIcon-sim_card_alert.icon';
import { matIconSimCardDownload } from './matIcon-sim_card_download.icon';
import { matIconSimCard } from './matIcon-sim_card.icon';
import { matIconSingleBed } from './matIcon-single_bed.icon';
import { matIconSip } from './matIcon-sip.icon';
import { matIconSkateboarding } from './matIcon-skateboarding.icon';
import { matIconSkipNext } from './matIcon-skip_next.icon';
import { matIconSkipPrevious } from './matIcon-skip_previous.icon';
import { matIconSledding } from './matIcon-sledding.icon';
import { matIconSlideshow } from './matIcon-slideshow.icon';
import { matIconSlowMotionVideo } from './matIcon-slow_motion_video.icon';
import { matIconSmartButton } from './matIcon-smart_button.icon';
import { matIconSmartDisplay } from './matIcon-smart_display.icon';
import { matIconSmartScreen } from './matIcon-smart_screen.icon';
import { matIconSmartToy } from './matIcon-smart_toy.icon';
import { matIconSmartphone } from './matIcon-smartphone.icon';
import { matIconSmokeFree } from './matIcon-smoke_free.icon';
import { matIconSmokingRooms } from './matIcon-smoking_rooms.icon';
import { matIconSmsFailed } from './matIcon-sms_failed.icon';
import { matIconSms } from './matIcon-sms.icon';
import { matIconSnippetFolder } from './matIcon-snippet_folder.icon';
import { matIconSnooze } from './matIcon-snooze.icon';
import { matIconSnowboarding } from './matIcon-snowboarding.icon';
import { matIconSnowmobile } from './matIcon-snowmobile.icon';
import { matIconSnowshoeing } from './matIcon-snowshoeing.icon';
import { matIconSoap } from './matIcon-soap.icon';
import { matIconSocialDistance } from './matIcon-social_distance.icon';
import { matIconSolarPower } from './matIcon-solar_power.icon';
import { matIconSortByAlpha } from './matIcon-sort_by_alpha.icon';
import { matIconSort } from './matIcon-sort.icon';
import { matIconSos } from './matIcon-sos.icon';
import { matIconSoupKitchen } from './matIcon-soup_kitchen.icon';
import { matIconSource } from './matIcon-source.icon';
import { matIconSouthAmerica } from './matIcon-south_america.icon';
import { matIconSouthEast } from './matIcon-south_east.icon';
import { matIconSouthWest } from './matIcon-south_west.icon';
import { matIconSouth } from './matIcon-south.icon';
import { matIconSpa } from './matIcon-spa.icon';
import { matIconSpaceBar } from './matIcon-space_bar.icon';
import { matIconSpaceDashboard } from './matIcon-space_dashboard.icon';
import { matIconSpatialAudioOff } from './matIcon-spatial_audio_off.icon';
import { matIconSpatialAudio } from './matIcon-spatial_audio.icon';
import { matIconSpatialTracking } from './matIcon-spatial_tracking.icon';
import { matIconSpeakerGroup } from './matIcon-speaker_group.icon';
import { matIconSpeakerNotesOff } from './matIcon-speaker_notes_off.icon';
import { matIconSpeakerNotes } from './matIcon-speaker_notes.icon';
import { matIconSpeakerPhone } from './matIcon-speaker_phone.icon';
import { matIconSpeaker } from './matIcon-speaker.icon';
import { matIconSpeed } from './matIcon-speed.icon';
import { matIconSpellcheck } from './matIcon-spellcheck.icon';
import { matIconSplitscreen } from './matIcon-splitscreen.icon';
import { matIconSpoke } from './matIcon-spoke.icon';
import { matIconSportsBar } from './matIcon-sports_bar.icon';
import { matIconSportsBaseball } from './matIcon-sports_baseball.icon';
import { matIconSportsBasketball } from './matIcon-sports_basketball.icon';
import { matIconSportsCricket } from './matIcon-sports_cricket.icon';
import { matIconSportsEsports } from './matIcon-sports_esports.icon';
import { matIconSportsFootball } from './matIcon-sports_football.icon';
import { matIconSportsGolf } from './matIcon-sports_golf.icon';
import { matIconSportsGymnastics } from './matIcon-sports_gymnastics.icon';
import { matIconSportsHandball } from './matIcon-sports_handball.icon';
import { matIconSportsHockey } from './matIcon-sports_hockey.icon';
import { matIconSportsKabaddi } from './matIcon-sports_kabaddi.icon';
import { matIconSportsMartialArts } from './matIcon-sports_martial_arts.icon';
import { matIconSportsMma } from './matIcon-sports_mma.icon';
import { matIconSportsMotorsports } from './matIcon-sports_motorsports.icon';
import { matIconSportsRugby } from './matIcon-sports_rugby.icon';
import { matIconSportsScore } from './matIcon-sports_score.icon';
import { matIconSportsSoccer } from './matIcon-sports_soccer.icon';
import { matIconSportsTennis } from './matIcon-sports_tennis.icon';
import { matIconSportsVolleyball } from './matIcon-sports_volleyball.icon';
import { matIconSports } from './matIcon-sports.icon';
import { matIconSquareFoot } from './matIcon-square_foot.icon';
import { matIconSquare } from './matIcon-square.icon';
import { matIconSsidChart } from './matIcon-ssid_chart.icon';
import { matIconStackedBarChart } from './matIcon-stacked_bar_chart.icon';
import { matIconStackedLineChart } from './matIcon-stacked_line_chart.icon';
import { matIconStadium } from './matIcon-stadium.icon';
import { matIconStairs } from './matIcon-stairs.icon';
import { matIconStarBorderPurple500 } from './matIcon-star_border_purple500.icon';
import { matIconStarBorder } from './matIcon-star_border.icon';
import { matIconStarHalf } from './matIcon-star_half.icon';
import { matIconStarOutline } from './matIcon-star_outline.icon';
import { matIconStarPurple500 } from './matIcon-star_purple500.icon';
import { matIconStarRate } from './matIcon-star_rate.icon';
import { matIconStar } from './matIcon-star.icon';
import { matIconStars } from './matIcon-stars.icon';
import { matIconStart } from './matIcon-start.icon';
import { matIconStayCurrentLandscape } from './matIcon-stay_current_landscape.icon';
import { matIconStayCurrentPortrait } from './matIcon-stay_current_portrait.icon';
import { matIconStayPrimaryLandscape } from './matIcon-stay_primary_landscape.icon';
import { matIconStayPrimaryPortrait } from './matIcon-stay_primary_portrait.icon';
import { matIconStickyNote2 } from './matIcon-sticky_note_2.icon';
import { matIconStopCircle } from './matIcon-stop_circle.icon';
import { matIconStopScreenShare } from './matIcon-stop_screen_share.icon';
import { matIconStop } from './matIcon-stop.icon';
import { matIconStorage } from './matIcon-storage.icon';
import { matIconStoreMallDirectory } from './matIcon-store_mall_directory.icon';
import { matIconStore } from './matIcon-store.icon';
import { matIconStorefront } from './matIcon-storefront.icon';
import { matIconStorm } from './matIcon-storm.icon';
import { matIconStraight } from './matIcon-straight.icon';
import { matIconStraighten } from './matIcon-straighten.icon';
import { matIconStream } from './matIcon-stream.icon';
import { matIconStreetview } from './matIcon-streetview.icon';
import { matIconStrikethroughS } from './matIcon-strikethrough_s.icon';
import { matIconStroller } from './matIcon-stroller.icon';
import { matIconStyle } from './matIcon-style.icon';
import { matIconSubdirectoryArrowLeft } from './matIcon-subdirectory_arrow_left.icon';
import { matIconSubdirectoryArrowRight } from './matIcon-subdirectory_arrow_right.icon';
import { matIconSubject } from './matIcon-subject.icon';
import { matIconSubscript } from './matIcon-subscript.icon';
import { matIconSubscriptions } from './matIcon-subscriptions.icon';
import { matIconSubtitlesOff } from './matIcon-subtitles_off.icon';
import { matIconSubtitles } from './matIcon-subtitles.icon';
import { matIconSubway } from './matIcon-subway.icon';
import { matIconSummarize } from './matIcon-summarize.icon';
import { matIconSuperscript } from './matIcon-superscript.icon';
import { matIconSupervisedUserCircle } from './matIcon-supervised_user_circle.icon';
import { matIconSupervisorAccount } from './matIcon-supervisor_account.icon';
import { matIconSupportAgent } from './matIcon-support_agent.icon';
import { matIconSupport } from './matIcon-support.icon';
import { matIconSurfing } from './matIcon-surfing.icon';
import { matIconSurroundSound } from './matIcon-surround_sound.icon';
import { matIconSwapCalls } from './matIcon-swap_calls.icon';
import { matIconSwapHoriz } from './matIcon-swap_horiz.icon';
import { matIconSwapHorizontalCircle } from './matIcon-swap_horizontal_circle.icon';
import { matIconSwapVert } from './matIcon-swap_vert.icon';
import { matIconSwapVerticalCircle } from './matIcon-swap_vertical_circle.icon';
import { matIconSwipeDownAlt } from './matIcon-swipe_down_alt.icon';
import { matIconSwipeDown } from './matIcon-swipe_down.icon';
import { matIconSwipeLeftAlt } from './matIcon-swipe_left_alt.icon';
import { matIconSwipeLeft } from './matIcon-swipe_left.icon';
import { matIconSwipeRightAlt } from './matIcon-swipe_right_alt.icon';
import { matIconSwipeRight } from './matIcon-swipe_right.icon';
import { matIconSwipeUpAlt } from './matIcon-swipe_up_alt.icon';
import { matIconSwipeUp } from './matIcon-swipe_up.icon';
import { matIconSwipeVertical } from './matIcon-swipe_vertical.icon';
import { matIconSwipe } from './matIcon-swipe.icon';
import { matIconSwitchAccessShortcutAdd } from './matIcon-switch_access_shortcut_add.icon';
import { matIconSwitchAccessShortcut } from './matIcon-switch_access_shortcut.icon';
import { matIconSwitchAccount } from './matIcon-switch_account.icon';
import { matIconSwitchCamera } from './matIcon-switch_camera.icon';
import { matIconSwitchLeft } from './matIcon-switch_left.icon';
import { matIconSwitchRight } from './matIcon-switch_right.icon';
import { matIconSwitchVideo } from './matIcon-switch_video.icon';
import { matIconSynagogue } from './matIcon-synagogue.icon';
import { matIconSyncAlt } from './matIcon-sync_alt.icon';
import { matIconSyncDisabled } from './matIcon-sync_disabled.icon';
import { matIconSyncLock } from './matIcon-sync_lock.icon';
import { matIconSyncProblem } from './matIcon-sync_problem.icon';
import { matIconSync } from './matIcon-sync.icon';
import { matIconSystemSecurityUpdateGood } from './matIcon-system_security_update_good.icon';
import { matIconSystemSecurityUpdateWarning } from './matIcon-system_security_update_warning.icon';
import { matIconSystemSecurityUpdate } from './matIcon-system_security_update.icon';
import { matIconSystemUpdateAlt } from './matIcon-system_update_alt.icon';
import { matIconSystemUpdate } from './matIcon-system_update.icon';
import { matIconTabUnselected } from './matIcon-tab_unselected.icon';
import { matIconTab } from './matIcon-tab.icon';
import { matIconTableBar } from './matIcon-table_bar.icon';
import { matIconTableChart } from './matIcon-table_chart.icon';
import { matIconTableRestaurant } from './matIcon-table_restaurant.icon';
import { matIconTableRows } from './matIcon-table_rows.icon';
import { matIconTableView } from './matIcon-table_view.icon';
import { matIconTabletAndroid } from './matIcon-tablet_android.icon';
import { matIconTabletMac } from './matIcon-tablet_mac.icon';
import { matIconTablet } from './matIcon-tablet.icon';
import { matIconTagFaces } from './matIcon-tag_faces.icon';
import { matIconTag } from './matIcon-tag.icon';
import { matIconTakeoutDining } from './matIcon-takeout_dining.icon';
import { matIconTapAndPlay } from './matIcon-tap_and_play.icon';
import { matIconTapas } from './matIcon-tapas.icon';
import { matIconTaskAlt } from './matIcon-task_alt.icon';
import { matIconTask } from './matIcon-task.icon';
import { matIconTaxiAlert } from './matIcon-taxi_alert.icon';
import { matIconTempleBuddhist } from './matIcon-temple_buddhist.icon';
import { matIconTempleHindu } from './matIcon-temple_hindu.icon';
import { matIconTerminal } from './matIcon-terminal.icon';
import { matIconTerrain } from './matIcon-terrain.icon';
import { matIconTextDecrease } from './matIcon-text_decrease.icon';
import { matIconTextFields } from './matIcon-text_fields.icon';
import { matIconTextFormat } from './matIcon-text_format.icon';
import { matIconTextIncrease } from './matIcon-text_increase.icon';
import { matIconTextRotateUp } from './matIcon-text_rotate_up.icon';
import { matIconTextRotateVertical } from './matIcon-text_rotate_vertical.icon';
import { matIconTextRotationAngledown } from './matIcon-text_rotation_angledown.icon';
import { matIconTextRotationAngleup } from './matIcon-text_rotation_angleup.icon';
import { matIconTextRotationDown } from './matIcon-text_rotation_down.icon';
import { matIconTextRotationNone } from './matIcon-text_rotation_none.icon';
import { matIconTextSnippet } from './matIcon-text_snippet.icon';
import { matIconTextsms } from './matIcon-textsms.icon';
import { matIconTexture } from './matIcon-texture.icon';
import { matIconTheaterComedy } from './matIcon-theater_comedy.icon';
import { matIconTheaters } from './matIcon-theaters.icon';
import { matIconThermostatAuto } from './matIcon-thermostat_auto.icon';
import { matIconThermostat } from './matIcon-thermostat.icon';
import { matIconThumbDownAlt } from './matIcon-thumb_down_alt.icon';
import { matIconThumbDownOffAlt } from './matIcon-thumb_down_off_alt.icon';
import { matIconThumbDown } from './matIcon-thumb_down.icon';
import { matIconThumbUpAlt } from './matIcon-thumb_up_alt.icon';
import { matIconThumbUpOffAlt } from './matIcon-thumb_up_off_alt.icon';
import { matIconThumbUp } from './matIcon-thumb_up.icon';
import { matIconThumbsUpDown } from './matIcon-thumbs_up_down.icon';
import { matIconThunderstorm } from './matIcon-thunderstorm.icon';
import { matIconTimeToLeave } from './matIcon-time_to_leave.icon';
import { matIconTimelapse } from './matIcon-timelapse.icon';
import { matIconTimeline } from './matIcon-timeline.icon';
import { matIconTimer10Select } from './matIcon-timer_10_select.icon';
import { matIconTimer10 } from './matIcon-timer_10.icon';
import { matIconTimer3Select } from './matIcon-timer_3_select.icon';
import { matIconTimer3 } from './matIcon-timer_3.icon';
import { matIconTimerOff } from './matIcon-timer_off.icon';
import { matIconTimer } from './matIcon-timer.icon';
import { matIconTipsAndUpdates } from './matIcon-tips_and_updates.icon';
import { matIconTireRepair } from './matIcon-tire_repair.icon';
import { matIconTitle } from './matIcon-title.icon';
import { matIconToc } from './matIcon-toc.icon';
import { matIconToday } from './matIcon-today.icon';
import { matIconToggleOff } from './matIcon-toggle_off.icon';
import { matIconToggleOn } from './matIcon-toggle_on.icon';
import { matIconToken } from './matIcon-token.icon';
import { matIconToll } from './matIcon-toll.icon';
import { matIconTonality } from './matIcon-tonality.icon';
import { matIconTopic } from './matIcon-topic.icon';
import { matIconTornado } from './matIcon-tornado.icon';
import { matIconTouchApp } from './matIcon-touch_app.icon';
import { matIconTour } from './matIcon-tour.icon';
import { matIconToys } from './matIcon-toys.icon';
import { matIconTrackChanges } from './matIcon-track_changes.icon';
import { matIconTraffic } from './matIcon-traffic.icon';
import { matIconTrain } from './matIcon-train.icon';
import { matIconTram } from './matIcon-tram.icon';
import { matIconTranscribe } from './matIcon-transcribe.icon';
import { matIconTransferWithinAStation } from './matIcon-transfer_within_a_station.icon';
import { matIconTransform } from './matIcon-transform.icon';
import { matIconTransgender } from './matIcon-transgender.icon';
import { matIconTransitEnterexit } from './matIcon-transit_enterexit.icon';
import { matIconTranslate } from './matIcon-translate.icon';
import { matIconTravelExplore } from './matIcon-travel_explore.icon';
import { matIconTrendingDown } from './matIcon-trending_down.icon';
import { matIconTrendingFlat } from './matIcon-trending_flat.icon';
import { matIconTrendingUp } from './matIcon-trending_up.icon';
import { matIconTripOrigin } from './matIcon-trip_origin.icon';
import { matIconTroubleshoot } from './matIcon-troubleshoot.icon';
import { matIconTry } from './matIcon-try.icon';
import { matIconTsunami } from './matIcon-tsunami.icon';
import { matIconTty } from './matIcon-tty.icon';
import { matIconTune } from './matIcon-tune.icon';
import { matIconTungsten } from './matIcon-tungsten.icon';
import { matIconTurnLeft } from './matIcon-turn_left.icon';
import { matIconTurnRight } from './matIcon-turn_right.icon';
import { matIconTurnSharpLeft } from './matIcon-turn_sharp_left.icon';
import { matIconTurnSharpRight } from './matIcon-turn_sharp_right.icon';
import { matIconTurnSlightLeft } from './matIcon-turn_slight_left.icon';
import { matIconTurnSlightRight } from './matIcon-turn_slight_right.icon';
import { matIconTurnedInNot } from './matIcon-turned_in_not.icon';
import { matIconTurnedIn } from './matIcon-turned_in.icon';
import { matIconTvOff } from './matIcon-tv_off.icon';
import { matIconTv } from './matIcon-tv.icon';
import { matIconTwoWheeler } from './matIcon-two_wheeler.icon';
import { matIconTypeSpecimen } from './matIcon-type_specimen.icon';
import { matIconUTurnLeft } from './matIcon-u_turn_left.icon';
import { matIconUTurnRight } from './matIcon-u_turn_right.icon';
import { matIconUmbrella } from './matIcon-umbrella.icon';
import { matIconUnarchive } from './matIcon-unarchive.icon';
import { matIconUndo } from './matIcon-undo.icon';
import { matIconUnfoldLessDouble } from './matIcon-unfold_less_double.icon';
import { matIconUnfoldLess } from './matIcon-unfold_less.icon';
import { matIconUnfoldMoreDouble } from './matIcon-unfold_more_double.icon';
import { matIconUnfoldMore } from './matIcon-unfold_more.icon';
import { matIconUnpublished } from './matIcon-unpublished.icon';
import { matIconUnsubscribe } from './matIcon-unsubscribe.icon';
import { matIconUpcoming } from './matIcon-upcoming.icon';
import { matIconUpdateDisabled } from './matIcon-update_disabled.icon';
import { matIconUpdate } from './matIcon-update.icon';
import { matIconUpgrade } from './matIcon-upgrade.icon';
import { matIconUploadFile } from './matIcon-upload_file.icon';
import { matIconUpload } from './matIcon-upload.icon';
import { matIconUsbOff } from './matIcon-usb_off.icon';
import { matIconUsb } from './matIcon-usb.icon';
import { matIconVaccines } from './matIcon-vaccines.icon';
import { matIconVapeFree } from './matIcon-vape_free.icon';
import { matIconVapingRooms } from './matIcon-vaping_rooms.icon';
import { matIconVerifiedUser } from './matIcon-verified_user.icon';
import { matIconVerified } from './matIcon-verified.icon';
import { matIconVerticalAlignBottom } from './matIcon-vertical_align_bottom.icon';
import { matIconVerticalAlignCenter } from './matIcon-vertical_align_center.icon';
import { matIconVerticalAlignTop } from './matIcon-vertical_align_top.icon';
import { matIconVerticalDistribute } from './matIcon-vertical_distribute.icon';
import { matIconVerticalShadesClosed } from './matIcon-vertical_shades_closed.icon';
import { matIconVerticalShades } from './matIcon-vertical_shades.icon';
import { matIconVerticalSplit } from './matIcon-vertical_split.icon';
import { matIconVibration } from './matIcon-vibration.icon';
import { matIconVideoCall } from './matIcon-video_call.icon';
import { matIconVideoCameraBack } from './matIcon-video_camera_back.icon';
import { matIconVideoCameraFront } from './matIcon-video_camera_front.icon';
import { matIconVideoChat } from './matIcon-video_chat.icon';
import { matIconVideoFile } from './matIcon-video_file.icon';
import { matIconVideoLabel } from './matIcon-video_label.icon';
import { matIconVideoLibrary } from './matIcon-video_library.icon';
import { matIconVideoSettings } from './matIcon-video_settings.icon';
import { matIconVideoStable } from './matIcon-video_stable.icon';
import { matIconVideocamOff } from './matIcon-videocam_off.icon';
import { matIconVideocam } from './matIcon-videocam.icon';
import { matIconVideogameAssetOff } from './matIcon-videogame_asset_off.icon';
import { matIconVideogameAsset } from './matIcon-videogame_asset.icon';
import { matIconViewAgenda } from './matIcon-view_agenda.icon';
import { matIconViewArray } from './matIcon-view_array.icon';
import { matIconViewCarousel } from './matIcon-view_carousel.icon';
import { matIconViewColumn } from './matIcon-view_column.icon';
import { matIconViewComfyAlt } from './matIcon-view_comfy_alt.icon';
import { matIconViewComfy } from './matIcon-view_comfy.icon';
import { matIconViewCompactAlt } from './matIcon-view_compact_alt.icon';
import { matIconViewCompact } from './matIcon-view_compact.icon';
import { matIconViewCozy } from './matIcon-view_cozy.icon';
import { matIconViewDay } from './matIcon-view_day.icon';
import { matIconViewHeadline } from './matIcon-view_headline.icon';
import { matIconViewInAr } from './matIcon-view_in_ar.icon';
import { matIconViewKanban } from './matIcon-view_kanban.icon';
import { matIconViewList } from './matIcon-view_list.icon';
import { matIconViewModule } from './matIcon-view_module.icon';
import { matIconViewQuilt } from './matIcon-view_quilt.icon';
import { matIconViewSidebar } from './matIcon-view_sidebar.icon';
import { matIconViewStream } from './matIcon-view_stream.icon';
import { matIconViewTimeline } from './matIcon-view_timeline.icon';
import { matIconViewWeek } from './matIcon-view_week.icon';
import { matIconVignette } from './matIcon-vignette.icon';
import { matIconVilla } from './matIcon-villa.icon';
import { matIconVisibilityOff } from './matIcon-visibility_off.icon';
import { matIconVisibility } from './matIcon-visibility.icon';
import { matIconVoiceChat } from './matIcon-voice_chat.icon';
import { matIconVoiceOverOff } from './matIcon-voice_over_off.icon';
import { matIconVoicemail } from './matIcon-voicemail.icon';
import { matIconVolcano } from './matIcon-volcano.icon';
import { matIconVolumeDown } from './matIcon-volume_down.icon';
import { matIconVolumeMute } from './matIcon-volume_mute.icon';
import { matIconVolumeOff } from './matIcon-volume_off.icon';
import { matIconVolumeUp } from './matIcon-volume_up.icon';
import { matIconVolunteerActivism } from './matIcon-volunteer_activism.icon';
import { matIconVpnKeyOff } from './matIcon-vpn_key_off.icon';
import { matIconVpnKey } from './matIcon-vpn_key.icon';
import { matIconVpnLock } from './matIcon-vpn_lock.icon';
import { matIconVrpano } from './matIcon-vrpano.icon';
import { matIconWallet } from './matIcon-wallet.icon';
import { matIconWallpaper } from './matIcon-wallpaper.icon';
import { matIconWarehouse } from './matIcon-warehouse.icon';
import { matIconWarningAmber } from './matIcon-warning_amber.icon';
import { matIconWarning } from './matIcon-warning.icon';
import { matIconWash } from './matIcon-wash.icon';
import { matIconWatchLater } from './matIcon-watch_later.icon';
import { matIconWatchOff } from './matIcon-watch_off.icon';
import { matIconWatch } from './matIcon-watch.icon';
import { matIconWaterDamage } from './matIcon-water_damage.icon';
import { matIconWaterDrop } from './matIcon-water_drop.icon';
import { matIconWater } from './matIcon-water.icon';
import { matIconWaterfallChart } from './matIcon-waterfall_chart.icon';
import { matIconWaves } from './matIcon-waves.icon';
import { matIconWavingHand } from './matIcon-waving_hand.icon';
import { matIconWbAuto } from './matIcon-wb_auto.icon';
import { matIconWbCloudy } from './matIcon-wb_cloudy.icon';
import { matIconWbIncandescent } from './matIcon-wb_incandescent.icon';
import { matIconWbIridescent } from './matIcon-wb_iridescent.icon';
import { matIconWbShade } from './matIcon-wb_shade.icon';
import { matIconWbSunny } from './matIcon-wb_sunny.icon';
import { matIconWbTwilight } from './matIcon-wb_twilight.icon';
import { matIconWc } from './matIcon-wc.icon';
import { matIconWebAssetOff } from './matIcon-web_asset_off.icon';
import { matIconWebAsset } from './matIcon-web_asset.icon';
import { matIconWebStories } from './matIcon-web_stories.icon';
import { matIconWeb } from './matIcon-web.icon';
import { matIconWebhook } from './matIcon-webhook.icon';
import { matIconWeekend } from './matIcon-weekend.icon';
import { matIconWest } from './matIcon-west.icon';
import { matIconWhatshot } from './matIcon-whatshot.icon';
import { matIconWheelchairPickup } from './matIcon-wheelchair_pickup.icon';
import { matIconWhereToVote } from './matIcon-where_to_vote.icon';
import { matIconWidgets } from './matIcon-widgets.icon';
import { matIconWidthFull } from './matIcon-width_full.icon';
import { matIconWidthNormal } from './matIcon-width_normal.icon';
import { matIconWidthWide } from './matIcon-width_wide.icon';
import { matIconWifi1Bar } from './matIcon-wifi_1_bar.icon';
import { matIconWifi2Bar } from './matIcon-wifi_2_bar.icon';
import { matIconWifiCalling3 } from './matIcon-wifi_calling_3.icon';
import { matIconWifiCalling } from './matIcon-wifi_calling.icon';
import { matIconWifiChannel } from './matIcon-wifi_channel.icon';
import { matIconWifiFind } from './matIcon-wifi_find.icon';
import { matIconWifiLock } from './matIcon-wifi_lock.icon';
import { matIconWifiOff } from './matIcon-wifi_off.icon';
import { matIconWifiPassword } from './matIcon-wifi_password.icon';
import { matIconWifiProtectedSetup } from './matIcon-wifi_protected_setup.icon';
import { matIconWifiTetheringError } from './matIcon-wifi_tethering_error.icon';
import { matIconWifiTetheringOff } from './matIcon-wifi_tethering_off.icon';
import { matIconWifiTethering } from './matIcon-wifi_tethering.icon';
import { matIconWifi } from './matIcon-wifi.icon';
import { matIconWindPower } from './matIcon-wind_power.icon';
import { matIconWindow } from './matIcon-window.icon';
import { matIconWineBar } from './matIcon-wine_bar.icon';
import { matIconWoman2 } from './matIcon-woman_2.icon';
import { matIconWoman } from './matIcon-woman.icon';
import { matIconWorkHistory } from './matIcon-work_history.icon';
import { matIconWorkOff } from './matIcon-work_off.icon';
import { matIconWorkOutline } from './matIcon-work_outline.icon';
import { matIconWork } from './matIcon-work.icon';
import { matIconWorkspacePremium } from './matIcon-workspace_premium.icon';
import { matIconWorkspaces } from './matIcon-workspaces.icon';
import { matIconWrapText } from './matIcon-wrap_text.icon';
import { matIconWrongLocation } from './matIcon-wrong_location.icon';
import { matIconWysiwyg } from './matIcon-wysiwyg.icon';
import { matIconYard } from './matIcon-yard.icon';
import { matIconYoutubeSearchedFor } from './matIcon-youtube_searched_for.icon';
import { matIconZoomInMap } from './matIcon-zoom_in_map.icon';
import { matIconZoomIn } from './matIcon-zoom_in.icon';
import { matIconZoomOutMap } from './matIcon-zoom_out_map.icon';
import { matIconZoomOut } from './matIcon-zoom_out.icon';
import { matIconEyeglasses } from './matIcon-eyeglasses.icon';
export const completeIconSet: MatIcon[] = [
  matIcon10K as MatIcon,
  matIcon10Mp as MatIcon,
  matIcon11Mp as MatIcon,
  matIcon12Mp as MatIcon,
  matIcon13Mp as MatIcon,
  matIcon14Mp as MatIcon,
  matIcon15Mp as MatIcon,
  matIcon16Mp as MatIcon,
  matIcon17Mp as MatIcon,
  matIcon18UpRating as MatIcon,
  matIcon18Mp as MatIcon,
  matIcon19Mp as MatIcon,
  matIcon1KPlus as MatIcon,
  matIcon1K as MatIcon,
  matIcon1XMobiledata as MatIcon,
  matIcon20Mp as MatIcon,
  matIcon21Mp as MatIcon,
  matIcon22Mp as MatIcon,
  matIcon23Mp as MatIcon,
  matIcon24Mp as MatIcon,
  matIcon2KPlus as MatIcon,
  matIcon2K as MatIcon,
  matIcon2Mp as MatIcon,
  matIcon30FpsSelect as MatIcon,
  matIcon30Fps as MatIcon,
  matIcon3DRotation as MatIcon,
  matIcon3GMobiledata as MatIcon,
  matIcon3KPlus as MatIcon,
  matIcon3K as MatIcon,
  matIcon3Mp as MatIcon,
  matIcon3P as MatIcon,
  matIcon4GMobiledata as MatIcon,
  matIcon4GPlusMobiledata as MatIcon,
  matIcon4KPlus as MatIcon,
  matIcon4K as MatIcon,
  matIcon4Mp as MatIcon,
  matIcon5G as MatIcon,
  matIcon5KPlus as MatIcon,
  matIcon5K as MatIcon,
  matIcon5Mp as MatIcon,
  matIcon6FtApart as MatIcon,
  matIcon60FpsSelect as MatIcon,
  matIcon60Fps as MatIcon,
  matIcon6KPlus as MatIcon,
  matIcon6K as MatIcon,
  matIcon6Mp as MatIcon,
  matIcon7KPlus as MatIcon,
  matIcon7K as MatIcon,
  matIcon7Mp as MatIcon,
  matIcon8KPlus as MatIcon,
  matIcon8K as MatIcon,
  matIcon8Mp as MatIcon,
  matIcon9KPlus as MatIcon,
  matIcon9K as MatIcon,
  matIcon9Mp as MatIcon,
  matIconAbc as MatIcon,
  matIconAcUnit as MatIcon,
  matIconAccessAlarm as MatIcon,
  matIconAccessAlarms as MatIcon,
  matIconAccessTimeFilled as MatIcon,
  matIconAccessTime as MatIcon,
  matIconAccessibilityNew as MatIcon,
  matIconAccessibility as MatIcon,
  matIconAccessibleForward as MatIcon,
  matIconAccessible as MatIcon,
  matIconAccountBalanceWallet as MatIcon,
  matIconAccountBalance as MatIcon,
  matIconAccountBox as MatIcon,
  matIconAccountCircle as MatIcon,
  matIconAccountTree as MatIcon,
  matIconAdUnits as MatIcon,
  matIconAdb as MatIcon,
  matIconAddAPhoto as MatIcon,
  matIconAddAlarm as MatIcon,
  matIconAddAlert as MatIcon,
  matIconAddBox as MatIcon,
  matIconAddBusiness as MatIcon,
  matIconAddCard as MatIcon,
  matIconAddChart as MatIcon,
  matIconAddCircleOutline as MatIcon,
  matIconAddCircle as MatIcon,
  matIconAddComment as MatIcon,
  matIconAddHomeWork as MatIcon,
  matIconAddHome as MatIcon,
  matIconAddIcCall as MatIcon,
  matIconAddLink as MatIcon,
  matIconAddLocationAlt as MatIcon,
  matIconAddLocation as MatIcon,
  matIconAddModerator as MatIcon,
  matIconAddPhotoAlternate as MatIcon,
  matIconAddReaction as MatIcon,
  matIconAddRoad as MatIcon,
  matIconAddShoppingCart as MatIcon,
  matIconAddTask as MatIcon,
  matIconAddToDrive as MatIcon,
  matIconAddToHomeScreen as MatIcon,
  matIconAddToPhotos as MatIcon,
  matIconAddToQueue as MatIcon,
  matIconAdd as MatIcon,
  matIconAddchart as MatIcon,
  matIconAdfScanner as MatIcon,
  matIconAdjust as MatIcon,
  matIconAdminPanelSettings as MatIcon,
  matIconAdsClick as MatIcon,
  matIconAgriculture as MatIcon,
  matIconAir as MatIcon,
  matIconAirlineSeatFlatAngled as MatIcon,
  matIconAirlineSeatFlat as MatIcon,
  matIconAirlineSeatIndividualSuite as MatIcon,
  matIconAirlineSeatLegroomExtra as MatIcon,
  matIconAirlineSeatLegroomNormal as MatIcon,
  matIconAirlineSeatLegroomReduced as MatIcon,
  matIconAirlineSeatReclineExtra as MatIcon,
  matIconAirlineSeatReclineNormal as MatIcon,
  matIconAirlineStops as MatIcon,
  matIconAirlines as MatIcon,
  matIconAirplaneTicket as MatIcon,
  matIconAirplanemodeActive as MatIcon,
  matIconAirplanemodeInactive as MatIcon,
  matIconAirplay as MatIcon,
  matIconAirportShuttle as MatIcon,
  matIconAlarmAdd as MatIcon,
  matIconAlarmOff as MatIcon,
  matIconAlarmOn as MatIcon,
  matIconAlarm as MatIcon,
  matIconAlbum as MatIcon,
  matIconAlignHorizontalCenter as MatIcon,
  matIconAlignHorizontalLeft as MatIcon,
  matIconAlignHorizontalRight as MatIcon,
  matIconAlignVerticalBottom as MatIcon,
  matIconAlignVerticalCenter as MatIcon,
  matIconAlignVerticalTop as MatIcon,
  matIconAllInbox as MatIcon,
  matIconAllInclusive as MatIcon,
  matIconAllOut as MatIcon,
  matIconAltRoute as MatIcon,
  matIconAlternateEmail as MatIcon,
  matIconAnalytics as MatIcon,
  matIconAnchor as MatIcon,
  matIconAndroid as MatIcon,
  matIconAnimation as MatIcon,
  matIconAnnouncement as MatIcon,
  matIconAod as MatIcon,
  matIconApartment as MatIcon,
  matIconApi as MatIcon,
  matIconAppBlocking as MatIcon,
  matIconAppRegistration as MatIcon,
  matIconAppSettingsAlt as MatIcon,
  matIconAppShortcut as MatIcon,
  matIconApproval as MatIcon,
  matIconAppsOutage as MatIcon,
  matIconApps as MatIcon,
  matIconArchitecture as MatIcon,
  matIconArchive as MatIcon,
  matIconAreaChart as MatIcon,
  matIconArrowBackIosNew as MatIcon,
  matIconArrowBackIos as MatIcon,
  matIconArrowBack as MatIcon,
  matIconArrowCircleDown as MatIcon,
  matIconArrowCircleLeft as MatIcon,
  matIconArrowCircleRight as MatIcon,
  matIconArrowCircleUp as MatIcon,
  matIconArrowDownward as MatIcon,
  matIconArrowDropDownCircle as MatIcon,
  matIconArrowDropDown as MatIcon,
  matIconArrowDropUp as MatIcon,
  matIconArrowForwardIos as MatIcon,
  matIconArrowForward as MatIcon,
  matIconArrowLeft as MatIcon,
  matIconArrowOutward as MatIcon,
  matIconArrowRightAlt as MatIcon,
  matIconArrowRight as MatIcon,
  matIconArrowUpward as MatIcon,
  matIconArtTrack as MatIcon,
  matIconArticle as MatIcon,
  matIconAspectRatio as MatIcon,
  matIconAssessment as MatIcon,
  matIconAssignmentInd as MatIcon,
  matIconAssignmentLate as MatIcon,
  matIconAssignmentReturn as MatIcon,
  matIconAssignmentReturned as MatIcon,
  matIconAssignmentTurnedIn as MatIcon,
  matIconAssignment as MatIcon,
  matIconAssistWalker as MatIcon,
  matIconAssistantDirection as MatIcon,
  matIconAssistantPhoto as MatIcon,
  matIconAssistant as MatIcon,
  matIconAssuredWorkload as MatIcon,
  matIconAtm as MatIcon,
  matIconAttachEmail as MatIcon,
  matIconAttachFile as MatIcon,
  matIconAttachMoney as MatIcon,
  matIconAttachment as MatIcon,
  matIconAttractions as MatIcon,
  matIconAttribution as MatIcon,
  matIconAudioFile as MatIcon,
  matIconAudiotrack as MatIcon,
  matIconAutoAwesomeMosaic as MatIcon,
  matIconAutoAwesomeMotion as MatIcon,
  matIconAutoAwesome as MatIcon,
  matIconAutoDelete as MatIcon,
  matIconAutoFixHigh as MatIcon,
  matIconAutoFixNormal as MatIcon,
  matIconAutoFixOff as MatIcon,
  matIconAutoGraph as MatIcon,
  matIconAutoMode as MatIcon,
  matIconAutoStories as MatIcon,
  matIconAutofpsSelect as MatIcon,
  matIconAutorenew as MatIcon,
  matIconAvTimer as MatIcon,
  matIconBabyChangingStation as MatIcon,
  matIconBackHand as MatIcon,
  matIconBackpack as MatIcon,
  matIconBackspace as MatIcon,
  matIconBackupTable as MatIcon,
  matIconBackup as MatIcon,
  matIconBadge as MatIcon,
  matIconBakeryDining as MatIcon,
  matIconBalance as MatIcon,
  matIconBalcony as MatIcon,
  matIconBallot as MatIcon,
  matIconBarChart as MatIcon,
  matIconBatchPrediction as MatIcon,
  matIconBathroom as MatIcon,
  matIconBathtub as MatIcon,
  matIconBattery0Bar as MatIcon,
  matIconBattery1Bar as MatIcon,
  matIconBattery2Bar as MatIcon,
  matIconBattery3Bar as MatIcon,
  matIconBattery4Bar as MatIcon,
  matIconBattery5Bar as MatIcon,
  matIconBattery6Bar as MatIcon,
  matIconBatteryAlert as MatIcon,
  matIconBatteryChargingFull as MatIcon,
  matIconBatteryFull as MatIcon,
  matIconBatterySaver as MatIcon,
  matIconBatteryStd as MatIcon,
  matIconBatteryUnknown as MatIcon,
  matIconBeachAccess as MatIcon,
  matIconBed as MatIcon,
  matIconBedroomBaby as MatIcon,
  matIconBedroomChild as MatIcon,
  matIconBedroomParent as MatIcon,
  matIconBedtimeOff as MatIcon,
  matIconBedtime as MatIcon,
  matIconBeenhere as MatIcon,
  matIconBento as MatIcon,
  matIconBikeScooter as MatIcon,
  matIconBiotech as MatIcon,
  matIconBlender as MatIcon,
  matIconBlind as MatIcon,
  matIconBlindsClosed as MatIcon,
  matIconBlinds as MatIcon,
  matIconBlock as MatIcon,
  matIconBloodtype as MatIcon,
  matIconBluetoothAudio as MatIcon,
  matIconBluetoothConnected as MatIcon,
  matIconBluetoothDisabled as MatIcon,
  matIconBluetoothDrive as MatIcon,
  matIconBluetoothSearching as MatIcon,
  matIconBluetooth as MatIcon,
  matIconBlurCircular as MatIcon,
  matIconBlurLinear as MatIcon,
  matIconBlurOff as MatIcon,
  matIconBlurOn as MatIcon,
  matIconBolt as MatIcon,
  matIconBookOnline as MatIcon,
  matIconBook as MatIcon,
  matIconBookmarkAdd as MatIcon,
  matIconBookmarkAdded as MatIcon,
  matIconBookmarkBorder as MatIcon,
  matIconBookmarkRemove as MatIcon,
  matIconBookmark as MatIcon,
  matIconBookmarks as MatIcon,
  matIconBorderAll as MatIcon,
  matIconBorderBottom as MatIcon,
  matIconBorderClear as MatIcon,
  matIconBorderColor as MatIcon,
  matIconBorderHorizontal as MatIcon,
  matIconBorderInner as MatIcon,
  matIconBorderLeft as MatIcon,
  matIconBorderOuter as MatIcon,
  matIconBorderRight as MatIcon,
  matIconBorderStyle as MatIcon,
  matIconBorderTop as MatIcon,
  matIconBorderVertical as MatIcon,
  matIconBoy as MatIcon,
  matIconBrandingWatermark as MatIcon,
  matIconBreakfastDining as MatIcon,
  matIconBrightness1 as MatIcon,
  matIconBrightness2 as MatIcon,
  matIconBrightness3 as MatIcon,
  matIconBrightness4 as MatIcon,
  matIconBrightness5 as MatIcon,
  matIconBrightness6 as MatIcon,
  matIconBrightness7 as MatIcon,
  matIconBrightnessAuto as MatIcon,
  matIconBrightnessHigh as MatIcon,
  matIconBrightnessLow as MatIcon,
  matIconBrightnessMedium as MatIcon,
  matIconBroadcastOnHome as MatIcon,
  matIconBroadcastOnPersonal as MatIcon,
  matIconBrokenImage as MatIcon,
  matIconBrowseGallery as MatIcon,
  matIconBrowserNotSupported as MatIcon,
  matIconBrowserUpdated as MatIcon,
  matIconBrunchDining as MatIcon,
  matIconBrush as MatIcon,
  matIconBubbleChart as MatIcon,
  matIconBugReport as MatIcon,
  matIconBuildCircle as MatIcon,
  matIconBuild as MatIcon,
  matIconBungalow as MatIcon,
  matIconBurstMode as MatIcon,
  matIconBusAlert as MatIcon,
  matIconBusinessCenter as MatIcon,
  matIconBusiness as MatIcon,
  matIconCabin as MatIcon,
  matIconCable as MatIcon,
  matIconCached as MatIcon,
  matIconCake as MatIcon,
  matIconCalculate as MatIcon,
  matIconCalendarMonth as MatIcon,
  matIconCalendarToday as MatIcon,
  matIconCalendarViewDay as MatIcon,
  matIconCalendarViewMonth as MatIcon,
  matIconCalendarViewWeek as MatIcon,
  matIconCallEnd as MatIcon,
  matIconCallMade as MatIcon,
  matIconCallMerge as MatIcon,
  matIconCallMissedOutgoing as MatIcon,
  matIconCallMissed as MatIcon,
  matIconCallReceived as MatIcon,
  matIconCallSplit as MatIcon,
  matIconCallToAction as MatIcon,
  matIconCall as MatIcon,
  matIconCameraAlt as MatIcon,
  matIconCameraEnhance as MatIcon,
  matIconCameraFront as MatIcon,
  matIconCameraIndoor as MatIcon,
  matIconCameraOutdoor as MatIcon,
  matIconCameraRear as MatIcon,
  matIconCameraRoll as MatIcon,
  matIconCamera as MatIcon,
  matIconCameraswitch as MatIcon,
  matIconCampaign as MatIcon,
  matIconCancelPresentation as MatIcon,
  matIconCancelScheduleSend as MatIcon,
  matIconCancel as MatIcon,
  matIconCandlestickChart as MatIcon,
  matIconCarCrash as MatIcon,
  matIconCarRental as MatIcon,
  matIconCarRepair as MatIcon,
  matIconCardGiftcard as MatIcon,
  matIconCardMembership as MatIcon,
  matIconCardTravel as MatIcon,
  matIconCarpenter as MatIcon,
  matIconCases as MatIcon,
  matIconCasino as MatIcon,
  matIconCastConnected as MatIcon,
  matIconCastForEducation as MatIcon,
  matIconCast as MatIcon,
  matIconCastle as MatIcon,
  matIconCatchingPokemon as MatIcon,
  matIconCategory as MatIcon,
  matIconCelebration as MatIcon,
  matIconCellTower as MatIcon,
  matIconCellWifi as MatIcon,
  matIconCenterFocusStrong as MatIcon,
  matIconCenterFocusWeak as MatIcon,
  matIconChairAlt as MatIcon,
  matIconChair as MatIcon,
  matIconChalet as MatIcon,
  matIconChangeCircle as MatIcon,
  matIconChangeHistory as MatIcon,
  matIconChargingStation as MatIcon,
  matIconChatBubbleOutline as MatIcon,
  matIconChatBubble as MatIcon,
  matIconChat as MatIcon,
  matIconCheckBoxOutlineBlank as MatIcon,
  matIconCheckBox as MatIcon,
  matIconCheckCircleOutline as MatIcon,
  matIconCheckCircle as MatIcon,
  matIconCheck as MatIcon,
  matIconChecklistRtl as MatIcon,
  matIconChecklist as MatIcon,
  matIconCheckroom as MatIcon,
  matIconChevronLeft as MatIcon,
  matIconChevronRight as MatIcon,
  matIconChildCare as MatIcon,
  matIconChildFriendly as MatIcon,
  matIconChromeReaderMode as MatIcon,
  matIconChurch as MatIcon,
  matIconCircleNotifications as MatIcon,
  matIconCircle as MatIcon,
  matIconClass as MatIcon,
  matIconCleanHands as MatIcon,
  matIconCleaningServices as MatIcon,
  matIconClearAll as MatIcon,
  matIconClear as MatIcon,
  matIconCloseFullscreen as MatIcon,
  matIconClose as MatIcon,
  matIconClosedCaptionDisabled as MatIcon,
  matIconClosedCaptionOff as MatIcon,
  matIconClosedCaption as MatIcon,
  matIconCloudCircle as MatIcon,
  matIconCloudDone as MatIcon,
  matIconCloudDownload as MatIcon,
  matIconCloudOff as MatIcon,
  matIconCloudQueue as MatIcon,
  matIconCloudSync as MatIcon,
  matIconCloudUpload as MatIcon,
  matIconCloud as MatIcon,
  matIconCoPresent as MatIcon,
  matIconCo2 as MatIcon,
  matIconCodeOff as MatIcon,
  matIconCode as MatIcon,
  matIconCoffeeMaker as MatIcon,
  matIconCoffee as MatIcon,
  matIconCollectionsBookmark as MatIcon,
  matIconCollections as MatIcon,
  matIconColorLens as MatIcon,
  matIconColorize as MatIcon,
  matIconCommentBank as MatIcon,
  matIconComment as MatIcon,
  matIconCommentsDisabled as MatIcon,
  matIconCommit as MatIcon,
  matIconCommute as MatIcon,
  matIconCompareArrows as MatIcon,
  matIconCompare as MatIcon,
  matIconCompassCalibration as MatIcon,
  matIconCompost as MatIcon,
  matIconCompress as MatIcon,
  matIconComputer as MatIcon,
  matIconConfirmationNumber as MatIcon,
  matIconConnectWithoutContact as MatIcon,
  matIconConnectedTv as MatIcon,
  matIconConnectingAirports as MatIcon,
  matIconConstruction as MatIcon,
  matIconContactEmergency as MatIcon,
  matIconContactMail as MatIcon,
  matIconContactPage as MatIcon,
  matIconContactPhone as MatIcon,
  matIconContactSupport as MatIcon,
  matIconContactless as MatIcon,
  matIconContacts as MatIcon,
  matIconContentCopy as MatIcon,
  matIconContentCut as MatIcon,
  matIconContentPasteGo as MatIcon,
  matIconContentPasteOff as MatIcon,
  matIconContentPasteSearch as MatIcon,
  matIconContentPaste as MatIcon,
  matIconContrast as MatIcon,
  matIconControlCamera as MatIcon,
  matIconControlPointDuplicate as MatIcon,
  matIconControlPoint as MatIcon,
  matIconCookie as MatIcon,
  matIconCopyAll as MatIcon,
  matIconCopyright as MatIcon,
  matIconCoronavirus as MatIcon,
  matIconCorporateFare as MatIcon,
  matIconCottage as MatIcon,
  matIconCountertops as MatIcon,
  matIconCreateNewFolder as MatIcon,
  matIconCreate as MatIcon,
  matIconCreditCardOff as MatIcon,
  matIconCreditCard as MatIcon,
  matIconCreditScore as MatIcon,
  matIconCrib as MatIcon,
  matIconCrisisAlert as MatIcon,
  matIconCrop169 as MatIcon,
  matIconCrop32 as MatIcon,
  matIconCrop54 as MatIcon,
  matIconCrop75 as MatIcon,
  matIconCropDin as MatIcon,
  matIconCropFree as MatIcon,
  matIconCropLandscape as MatIcon,
  matIconCropOriginal as MatIcon,
  matIconCropPortrait as MatIcon,
  matIconCropRotate as MatIcon,
  matIconCropSquare as MatIcon,
  matIconCrop as MatIcon,
  matIconCrueltyFree as MatIcon,
  matIconCss as MatIcon,
  matIconCurrencyBitcoin as MatIcon,
  matIconCurrencyExchange as MatIcon,
  matIconCurrencyFranc as MatIcon,
  matIconCurrencyLira as MatIcon,
  matIconCurrencyPound as MatIcon,
  matIconCurrencyRuble as MatIcon,
  matIconCurrencyRupee as MatIcon,
  matIconCurrencyYen as MatIcon,
  matIconCurrencyYuan as MatIcon,
  matIconCurtainsClosed as MatIcon,
  matIconCurtains as MatIcon,
  matIconCyclone as MatIcon,
  matIconDangerous as MatIcon,
  matIconDarkMode as MatIcon,
  matIconDashboardCustomize as MatIcon,
  matIconDashboard as MatIcon,
  matIconDataArray as MatIcon,
  matIconDataExploration as MatIcon,
  matIconDataObject as MatIcon,
  matIconDataSaverOff as MatIcon,
  matIconDataSaverOn as MatIcon,
  matIconDataThresholding as MatIcon,
  matIconDataUsage as MatIcon,
  matIconDatasetLinked as MatIcon,
  matIconDataset as MatIcon,
  matIconDateRange as MatIcon,
  matIconDeblur as MatIcon,
  matIconDeck as MatIcon,
  matIconDehaze as MatIcon,
  matIconDeleteForever as MatIcon,
  matIconDeleteOutline as MatIcon,
  matIconDeleteSweep as MatIcon,
  matIconDelete as MatIcon,
  matIconDeliveryDining as MatIcon,
  matIconDensityLarge as MatIcon,
  matIconDensityMedium as MatIcon,
  matIconDensitySmall as MatIcon,
  matIconDepartureBoard as MatIcon,
  matIconDescription as MatIcon,
  matIconDeselect as MatIcon,
  matIconDesignServices as MatIcon,
  matIconDesk as MatIcon,
  matIconDesktopAccessDisabled as MatIcon,
  matIconDesktopMac as MatIcon,
  matIconDesktopWindows as MatIcon,
  matIconDetails as MatIcon,
  matIconDeveloperBoardOff as MatIcon,
  matIconDeveloperBoard as MatIcon,
  matIconDeveloperMode as MatIcon,
  matIconDeviceHub as MatIcon,
  matIconDeviceThermostat as MatIcon,
  matIconDeviceUnknown as MatIcon,
  matIconDevicesFold as MatIcon,
  matIconDevicesOther as MatIcon,
  matIconDevices as MatIcon,
  matIconDialerSip as MatIcon,
  matIconDialpad as MatIcon,
  matIconDiamond as MatIcon,
  matIconDifference as MatIcon,
  matIconDining as MatIcon,
  matIconDinnerDining as MatIcon,
  matIconDirectionsBike as MatIcon,
  matIconDirectionsBoatFilled as MatIcon,
  matIconDirectionsBoat as MatIcon,
  matIconDirectionsBusFilled as MatIcon,
  matIconDirectionsBus as MatIcon,
  matIconDirectionsCarFilled as MatIcon,
  matIconDirectionsCar as MatIcon,
  matIconDirectionsOff as MatIcon,
  matIconDirectionsRailwayFilled as MatIcon,
  matIconDirectionsRailway as MatIcon,
  matIconDirectionsRun as MatIcon,
  matIconDirectionsSubwayFilled as MatIcon,
  matIconDirectionsSubway as MatIcon,
  matIconDirectionsTransitFilled as MatIcon,
  matIconDirectionsTransit as MatIcon,
  matIconDirectionsWalk as MatIcon,
  matIconDirections as MatIcon,
  matIconDirtyLens as MatIcon,
  matIconDisabledByDefault as MatIcon,
  matIconDisabledVisible as MatIcon,
  matIconDiscFull as MatIcon,
  matIconDiscount as MatIcon,
  matIconDisplaySettings as MatIcon,
  matIconDiversity1 as MatIcon,
  matIconDiversity2 as MatIcon,
  matIconDiversity3 as MatIcon,
  matIconDns as MatIcon,
  matIconDoDisturbAlt as MatIcon,
  matIconDoDisturbOff as MatIcon,
  matIconDoDisturbOn as MatIcon,
  matIconDoDisturb as MatIcon,
  matIconDoNotDisturbAlt as MatIcon,
  matIconDoNotDisturbOff as MatIcon,
  matIconDoNotDisturbOnTotalSilence as MatIcon,
  matIconDoNotDisturbOn as MatIcon,
  matIconDoNotDisturb as MatIcon,
  matIconDoNotStep as MatIcon,
  matIconDoNotTouch as MatIcon,
  matIconDock as MatIcon,
  matIconDocumentScanner as MatIcon,
  matIconDomainAdd as MatIcon,
  matIconDomainDisabled as MatIcon,
  matIconDomainVerification as MatIcon,
  matIconDomain as MatIcon,
  matIconDoneAll as MatIcon,
  matIconDoneOutline as MatIcon,
  matIconDone as MatIcon,
  matIconDonutLarge as MatIcon,
  matIconDonutSmall as MatIcon,
  matIconDoorBack as MatIcon,
  matIconDoorFront as MatIcon,
  matIconDoorSliding as MatIcon,
  matIconDoorbell as MatIcon,
  matIconDoubleArrow as MatIcon,
  matIconDownhillSkiing as MatIcon,
  matIconDownloadDone as MatIcon,
  matIconDownloadForOffline as MatIcon,
  matIconDownload as MatIcon,
  matIconDownloading as MatIcon,
  matIconDrafts as MatIcon,
  matIconDragHandle as MatIcon,
  matIconDragIndicator as MatIcon,
  matIconDraw as MatIcon,
  matIconDriveEta as MatIcon,
  matIconDriveFileMoveRtl as MatIcon,
  matIconDriveFileMove as MatIcon,
  matIconDriveFileRenameOutline as MatIcon,
  matIconDriveFolderUpload as MatIcon,
  matIconDryCleaning as MatIcon,
  matIconDry as MatIcon,
  matIconDuo as MatIcon,
  matIconDvr as MatIcon,
  matIconDynamicFeed as MatIcon,
  matIconDynamicForm as MatIcon,
  matIconEMobiledata as MatIcon,
  matIconEarbudsBattery as MatIcon,
  matIconEarbuds as MatIcon,
  matIconEast as MatIcon,
  matIconEdgesensorHigh as MatIcon,
  matIconEdgesensorLow as MatIcon,
  matIconEditAttributes as MatIcon,
  matIconEditCalendar as MatIcon,
  matIconEditLocationAlt as MatIcon,
  matIconEditLocation as MatIcon,
  matIconEditNote as MatIcon,
  matIconEditNotifications as MatIcon,
  matIconEditOff as MatIcon,
  matIconEditRoad as MatIcon,
  matIconEdit as MatIcon,
  matIconEggAlt as MatIcon,
  matIconEgg as MatIcon,
  matIconEject as MatIcon,
  matIconElderlyWoman as MatIcon,
  matIconElderly as MatIcon,
  matIconElectricBike as MatIcon,
  matIconElectricBolt as MatIcon,
  matIconElectricCar as MatIcon,
  matIconElectricMeter as MatIcon,
  matIconElectricMoped as MatIcon,
  matIconElectricRickshaw as MatIcon,
  matIconElectricScooter as MatIcon,
  matIconElectricalServices as MatIcon,
  matIconElevator as MatIcon,
  matIconEmail as MatIcon,
  matIconEmergencyRecording as MatIcon,
  matIconEmergencyShare as MatIcon,
  matIconEmergency as MatIcon,
  matIconEmojiEmotions as MatIcon,
  matIconEmojiEvents as MatIcon,
  matIconEmojiFoodBeverage as MatIcon,
  matIconEmojiNature as MatIcon,
  matIconEmojiObjects as MatIcon,
  matIconEmojiPeople as MatIcon,
  matIconEmojiSymbols as MatIcon,
  matIconEmojiTransportation as MatIcon,
  matIconEnergySavingsLeaf as MatIcon,
  matIconEngineering as MatIcon,
  matIconEnhancedEncryption as MatIcon,
  matIconEqualizer as MatIcon,
  matIconErrorOutline as MatIcon,
  matIconError as MatIcon,
  matIconEscalatorWarning as MatIcon,
  matIconEscalator as MatIcon,
  matIconEuroSymbol as MatIcon,
  matIconEuro as MatIcon,
  matIconEvStation as MatIcon,
  matIconEventAvailable as MatIcon,
  matIconEventBusy as MatIcon,
  matIconEventNote as MatIcon,
  matIconEventRepeat as MatIcon,
  matIconEventSeat as MatIcon,
  matIconEvent as MatIcon,
  matIconExitToApp as MatIcon,
  matIconExpandCircleDown as MatIcon,
  matIconExpandLess as MatIcon,
  matIconExpandMore as MatIcon,
  matIconExpand as MatIcon,
  matIconExplicit as MatIcon,
  matIconExploreOff as MatIcon,
  matIconExplore as MatIcon,
  matIconExposureNeg1 as MatIcon,
  matIconExposureNeg2 as MatIcon,
  matIconExposurePlus1 as MatIcon,
  matIconExposurePlus2 as MatIcon,
  matIconExposureZero as MatIcon,
  matIconExposure as MatIcon,
  matIconExtensionOff as MatIcon,
  matIconExtension as MatIcon,
  matIconFace2 as MatIcon,
  matIconFace3 as MatIcon,
  matIconFace4 as MatIcon,
  matIconFace5 as MatIcon,
  matIconFace6 as MatIcon,
  matIconFaceRetouchingNatural as MatIcon,
  matIconFaceRetouchingOff as MatIcon,
  matIconFace as MatIcon,
  matIconFactCheck as MatIcon,
  matIconFactory as MatIcon,
  matIconFamilyRestroom as MatIcon,
  matIconFastForward as MatIcon,
  matIconFastRewind as MatIcon,
  matIconFastfood as MatIcon,
  matIconFavoriteBorder as MatIcon,
  matIconFavorite as MatIcon,
  matIconFax as MatIcon,
  matIconFeaturedPlayList as MatIcon,
  matIconFeaturedVideo as MatIcon,
  matIconFeed as MatIcon,
  matIconFeedback as MatIcon,
  matIconFemale as MatIcon,
  matIconFence as MatIcon,
  matIconFestival as MatIcon,
  matIconFiberDvr as MatIcon,
  matIconFiberManualRecord as MatIcon,
  matIconFiberNew as MatIcon,
  matIconFiberPin as MatIcon,
  matIconFiberSmartRecord as MatIcon,
  matIconFileCopy as MatIcon,
  matIconFileDownloadDone as MatIcon,
  matIconFileDownloadOff as MatIcon,
  matIconFileDownload as MatIcon,
  matIconFileOpen as MatIcon,
  matIconFilePresent as MatIcon,
  matIconFileUpload as MatIcon,
  matIconFilter1 as MatIcon,
  matIconFilter2 as MatIcon,
  matIconFilter3 as MatIcon,
  matIconFilter4 as MatIcon,
  matIconFilter5 as MatIcon,
  matIconFilter6 as MatIcon,
  matIconFilter7 as MatIcon,
  matIconFilter8 as MatIcon,
  matIconFilter9Plus as MatIcon,
  matIconFilter9 as MatIcon,
  matIconFilterAltOff as MatIcon,
  matIconFilterAlt as MatIcon,
  matIconFilterBAndW as MatIcon,
  matIconFilterCenterFocus as MatIcon,
  matIconFilterDrama as MatIcon,
  matIconFilterFrames as MatIcon,
  matIconFilterHdr as MatIcon,
  matIconFilterListOff as MatIcon,
  matIconFilterList as MatIcon,
  matIconFilterNone as MatIcon,
  matIconFilterTiltShift as MatIcon,
  matIconFilterVintage as MatIcon,
  matIconFilter as MatIcon,
  matIconFindInPage as MatIcon,
  matIconFindReplace as MatIcon,
  matIconFingerprint as MatIcon,
  matIconFireExtinguisher as MatIcon,
  matIconFireHydrantAlt as MatIcon,
  matIconFireTruck as MatIcon,
  matIconFireplace as MatIcon,
  matIconFirstPage as MatIcon,
  matIconFitScreen as MatIcon,
  matIconFitbit as MatIcon,
  matIconFitnessCenter as MatIcon,
  matIconFlagCircle as MatIcon,
  matIconFlag as MatIcon,
  matIconFlaky as MatIcon,
  matIconFlare as MatIcon,
  matIconFlashAuto as MatIcon,
  matIconFlashOff as MatIcon,
  matIconFlashOn as MatIcon,
  matIconFlashlightOff as MatIcon,
  matIconFlashlightOn as MatIcon,
  matIconFlatware as MatIcon,
  matIconFlightClass as MatIcon,
  matIconFlightLand as MatIcon,
  matIconFlightTakeoff as MatIcon,
  matIconFlight as MatIcon,
  matIconFlipCameraAndroid as MatIcon,
  matIconFlipCameraIos as MatIcon,
  matIconFlipToBack as MatIcon,
  matIconFlipToFront as MatIcon,
  matIconFlip as MatIcon,
  matIconFlood as MatIcon,
  matIconFluorescent as MatIcon,
  matIconFlutterDash as MatIcon,
  matIconFmdBad as MatIcon,
  matIconFmdGood as MatIcon,
  matIconFolderCopy as MatIcon,
  matIconFolderDelete as MatIcon,
  matIconFolderOff as MatIcon,
  matIconFolderOpen as MatIcon,
  matIconFolderShared as MatIcon,
  matIconFolderSpecial as MatIcon,
  matIconFolderZip as MatIcon,
  matIconFolder as MatIcon,
  matIconFollowTheSigns as MatIcon,
  matIconFontDownloadOff as MatIcon,
  matIconFontDownload as MatIcon,
  matIconFoodBank as MatIcon,
  matIconForest as MatIcon,
  matIconForkLeft as MatIcon,
  matIconForkRight as MatIcon,
  matIconFormatAlignCenter as MatIcon,
  matIconFormatAlignJustify as MatIcon,
  matIconFormatAlignLeft as MatIcon,
  matIconFormatAlignRight as MatIcon,
  matIconFormatBold as MatIcon,
  matIconFormatClear as MatIcon,
  matIconFormatColorFill as MatIcon,
  matIconFormatColorReset as MatIcon,
  matIconFormatColorText as MatIcon,
  matIconFormatIndentDecrease as MatIcon,
  matIconFormatIndentIncrease as MatIcon,
  matIconFormatItalic as MatIcon,
  matIconFormatLineSpacing as MatIcon,
  matIconFormatListBulleted as MatIcon,
  matIconFormatListNumberedRtl as MatIcon,
  matIconFormatListNumbered as MatIcon,
  matIconFormatOverline as MatIcon,
  matIconFormatPaint as MatIcon,
  matIconFormatQuote as MatIcon,
  matIconFormatShapes as MatIcon,
  matIconFormatSize as MatIcon,
  matIconFormatStrikethrough as MatIcon,
  matIconFormatTextdirectionLToR as MatIcon,
  matIconFormatTextdirectionRToL as MatIcon,
  matIconFormatUnderlined as MatIcon,
  matIconFort as MatIcon,
  matIconForum as MatIcon,
  matIconForward10 as MatIcon,
  matIconForward30 as MatIcon,
  matIconForward5 as MatIcon,
  matIconForwardToInbox as MatIcon,
  matIconForward as MatIcon,
  matIconFoundation as MatIcon,
  matIconFreeBreakfast as MatIcon,
  matIconFreeCancellation as MatIcon,
  matIconFrontHand as MatIcon,
  matIconFullscreenExit as MatIcon,
  matIconFullscreen as MatIcon,
  matIconFunctions as MatIcon,
  matIconGMobiledata as MatIcon,
  matIconGTranslate as MatIcon,
  matIconGamepad as MatIcon,
  matIconGames as MatIcon,
  matIconGarage as MatIcon,
  matIconGasMeter as MatIcon,
  matIconGavel as MatIcon,
  matIconGeneratingTokens as MatIcon,
  matIconGesture as MatIcon,
  matIconGetApp as MatIcon,
  matIconGifBox as MatIcon,
  matIconGif as MatIcon,
  matIconGirl as MatIcon,
  matIconGite as MatIcon,
  matIconGolfCourse as MatIcon,
  matIconGppBad as MatIcon,
  matIconGppGood as MatIcon,
  matIconGppMaybe as MatIcon,
  matIconGpsFixed as MatIcon,
  matIconGpsNotFixed as MatIcon,
  matIconGpsOff as MatIcon,
  matIconGrade as MatIcon,
  matIconGradient as MatIcon,
  matIconGrading as MatIcon,
  matIconGrain as MatIcon,
  matIconGraphicEq as MatIcon,
  matIconGrass as MatIcon,
  matIconGrid3X3 as MatIcon,
  matIconGrid4X4 as MatIcon,
  matIconGridGoldenratio as MatIcon,
  matIconGridOff as MatIcon,
  matIconGridOn as MatIcon,
  matIconGridView as MatIcon,
  matIconGroupAdd as MatIcon,
  matIconGroupOff as MatIcon,
  matIconGroupRemove as MatIcon,
  matIconGroupWork as MatIcon,
  matIconGroup as MatIcon,
  matIconGroups2 as MatIcon,
  matIconGroups3 as MatIcon,
  matIconGroups as MatIcon,
  matIconHMobiledata as MatIcon,
  matIconHPlusMobiledata as MatIcon,
  matIconHail as MatIcon,
  matIconHandshake as MatIcon,
  matIconHandyman as MatIcon,
  matIconHardware as MatIcon,
  matIconHd as MatIcon,
  matIconHdrAutoSelect as MatIcon,
  matIconHdrAuto as MatIcon,
  matIconHdrEnhancedSelect as MatIcon,
  matIconHdrOffSelect as MatIcon,
  matIconHdrOff as MatIcon,
  matIconHdrOnSelect as MatIcon,
  matIconHdrOn as MatIcon,
  matIconHdrPlus as MatIcon,
  matIconHdrStrong as MatIcon,
  matIconHdrWeak as MatIcon,
  matIconHeadphonesBattery as MatIcon,
  matIconHeadphones as MatIcon,
  matIconHeadsetMic as MatIcon,
  matIconHeadsetOff as MatIcon,
  matIconHeadset as MatIcon,
  matIconHealing as MatIcon,
  matIconHealthAndSafety as MatIcon,
  matIconHearingDisabled as MatIcon,
  matIconHearing as MatIcon,
  matIconHeartBroken as MatIcon,
  matIconHeatPump as MatIcon,
  matIconHeight as MatIcon,
  matIconHelpCenter as MatIcon,
  matIconHelpOutline as MatIcon,
  matIconHelp as MatIcon,
  matIconHevc as MatIcon,
  matIconHexagon as MatIcon,
  matIconHideImage as MatIcon,
  matIconHideSource as MatIcon,
  matIconHighQuality as MatIcon,
  matIconHighlightAlt as MatIcon,
  matIconHighlightOff as MatIcon,
  matIconHighlight as MatIcon,
  matIconHiking as MatIcon,
  matIconHistoryEdu as MatIcon,
  matIconHistoryToggleOff as MatIcon,
  matIconHistory as MatIcon,
  matIconHive as MatIcon,
  matIconHlsOff as MatIcon,
  matIconHls as MatIcon,
  matIconHolidayVillage as MatIcon,
  matIconHomeMax as MatIcon,
  matIconHomeMini as MatIcon,
  matIconHomeRepairService as MatIcon,
  matIconHomeWork as MatIcon,
  matIconHome as MatIcon,
  matIconHorizontalDistribute as MatIcon,
  matIconHorizontalRule as MatIcon,
  matIconHorizontalSplit as MatIcon,
  matIconHotTub as MatIcon,
  matIconHotelClass as MatIcon,
  matIconHotel as MatIcon,
  matIconHourglassBottom as MatIcon,
  matIconHourglassDisabled as MatIcon,
  matIconHourglassEmpty as MatIcon,
  matIconHourglassFull as MatIcon,
  matIconHourglassTop as MatIcon,
  matIconHouseSiding as MatIcon,
  matIconHouse as MatIcon,
  matIconHouseboat as MatIcon,
  matIconHowToReg as MatIcon,
  matIconHowToVote as MatIcon,
  matIconHtml as MatIcon,
  matIconHttp as MatIcon,
  matIconHttps as MatIcon,
  matIconHub as MatIcon,
  matIconHvac as MatIcon,
  matIconIceSkating as MatIcon,
  matIconIcecream as MatIcon,
  matIconImageAspectRatio as MatIcon,
  matIconImageNotSupported as MatIcon,
  matIconImageSearch as MatIcon,
  matIconImage as MatIcon,
  matIconImagesearchRoller as MatIcon,
  matIconImportContacts as MatIcon,
  matIconImportExport as MatIcon,
  matIconImportantDevices as MatIcon,
  matIconInbox as MatIcon,
  matIconIncompleteCircle as MatIcon,
  matIconIndeterminateCheckBox as MatIcon,
  matIconInfo as MatIcon,
  matIconInput as MatIcon,
  matIconInsertChartOutlined as MatIcon,
  matIconInsertChart as MatIcon,
  matIconInsertComment as MatIcon,
  matIconInsertDriveFile as MatIcon,
  matIconInsertEmoticon as MatIcon,
  matIconInsertInvitation as MatIcon,
  matIconInsertLink as MatIcon,
  matIconInsertPageBreak as MatIcon,
  matIconInsertPhoto as MatIcon,
  matIconInsights as MatIcon,
  matIconInstallDesktop as MatIcon,
  matIconInstallMobile as MatIcon,
  matIconIntegrationInstructions as MatIcon,
  matIconInterests as MatIcon,
  matIconInterpreterMode as MatIcon,
  matIconInventory2 as MatIcon,
  matIconInventory as MatIcon,
  matIconInvertColorsOff as MatIcon,
  matIconInvertColors as MatIcon,
  matIconIosShare as MatIcon,
  matIconIron as MatIcon,
  matIconIso as MatIcon,
  matIconJavascript as MatIcon,
  matIconJoinFull as MatIcon,
  matIconJoinInner as MatIcon,
  matIconJoinLeft as MatIcon,
  matIconJoinRight as MatIcon,
  matIconKayaking as MatIcon,
  matIconKebabDining as MatIcon,
  matIconKeyOff as MatIcon,
  matIconKey as MatIcon,
  matIconKeyboardAlt as MatIcon,
  matIconKeyboardArrowDown as MatIcon,
  matIconKeyboardArrowLeft as MatIcon,
  matIconKeyboardArrowRight as MatIcon,
  matIconKeyboardArrowUp as MatIcon,
  matIconKeyboardBackspace as MatIcon,
  matIconKeyboardCapslock as MatIcon,
  matIconKeyboardCommandKey as MatIcon,
  matIconKeyboardControlKey as MatIcon,
  matIconKeyboardDoubleArrowDown as MatIcon,
  matIconKeyboardDoubleArrowLeft as MatIcon,
  matIconKeyboardDoubleArrowRight as MatIcon,
  matIconKeyboardDoubleArrowUp as MatIcon,
  matIconKeyboardHide as MatIcon,
  matIconKeyboardOptionKey as MatIcon,
  matIconKeyboardReturn as MatIcon,
  matIconKeyboardTab as MatIcon,
  matIconKeyboardVoice as MatIcon,
  matIconKeyboard as MatIcon,
  matIconKingBed as MatIcon,
  matIconKitchen as MatIcon,
  matIconKitesurfing as MatIcon,
  matIconLabelImportant as MatIcon,
  matIconLabelOff as MatIcon,
  matIconLabel as MatIcon,
  matIconLan as MatIcon,
  matIconLandscape as MatIcon,
  matIconLandslide as MatIcon,
  matIconLanguage as MatIcon,
  matIconLaptopChromebook as MatIcon,
  matIconLaptopMac as MatIcon,
  matIconLaptopWindows as MatIcon,
  matIconLaptop as MatIcon,
  matIconLastPage as MatIcon,
  matIconLaunch as MatIcon,
  matIconLayersClear as MatIcon,
  matIconLayers as MatIcon,
  matIconLeaderboard as MatIcon,
  matIconLeakAdd as MatIcon,
  matIconLeakRemove as MatIcon,
  matIconLegendToggle as MatIcon,
  matIconLensBlur as MatIcon,
  matIconLens as MatIcon,
  matIconLibraryAddCheck as MatIcon,
  matIconLibraryAdd as MatIcon,
  matIconLibraryBooks as MatIcon,
  matIconLibraryMusic as MatIcon,
  matIconLightMode as MatIcon,
  matIconLight as MatIcon,
  matIconLightbulbCircle as MatIcon,
  matIconLightbulb as MatIcon,
  matIconLineAxis as MatIcon,
  matIconLineStyle as MatIcon,
  matIconLineWeight as MatIcon,
  matIconLinearScale as MatIcon,
  matIconLinkOff as MatIcon,
  matIconLink as MatIcon,
  matIconLinkedCamera as MatIcon,
  matIconLiquor as MatIcon,
  matIconListAlt as MatIcon,
  matIconList as MatIcon,
  matIconLiveHelp as MatIcon,
  matIconLiveTv as MatIcon,
  matIconLiving as MatIcon,
  matIconLocalActivity as MatIcon,
  matIconLocalAirport as MatIcon,
  matIconLocalAtm as MatIcon,
  matIconLocalBar as MatIcon,
  matIconLocalCafe as MatIcon,
  matIconLocalCarWash as MatIcon,
  matIconLocalConvenienceStore as MatIcon,
  matIconLocalDining as MatIcon,
  matIconLocalDrink as MatIcon,
  matIconLocalFireDepartment as MatIcon,
  matIconLocalFlorist as MatIcon,
  matIconLocalGasStation as MatIcon,
  matIconLocalGroceryStore as MatIcon,
  matIconLocalHospital as MatIcon,
  matIconLocalHotel as MatIcon,
  matIconLocalLaundryService as MatIcon,
  matIconLocalLibrary as MatIcon,
  matIconLocalMall as MatIcon,
  matIconLocalMovies as MatIcon,
  matIconLocalOffer as MatIcon,
  matIconLocalParking as MatIcon,
  matIconLocalPharmacy as MatIcon,
  matIconLocalPhone as MatIcon,
  matIconLocalPizza as MatIcon,
  matIconLocalPlay as MatIcon,
  matIconLocalPolice as MatIcon,
  matIconLocalPostOffice as MatIcon,
  matIconLocalPrintshop as MatIcon,
  matIconLocalSee as MatIcon,
  matIconLocalShipping as MatIcon,
  matIconLocalTaxi as MatIcon,
  matIconLocationCity as MatIcon,
  matIconLocationDisabled as MatIcon,
  matIconLocationOff as MatIcon,
  matIconLocationOn as MatIcon,
  matIconLocationSearching as MatIcon,
  matIconLockClock as MatIcon,
  matIconLockOpen as MatIcon,
  matIconLockPerson as MatIcon,
  matIconLockReset as MatIcon,
  matIconLock as MatIcon,
  matIconLogin as MatIcon,
  matIconLogoDev as MatIcon,
  matIconLogout as MatIcon,
  matIconLooks3 as MatIcon,
  matIconLooks4 as MatIcon,
  matIconLooks5 as MatIcon,
  matIconLooks6 as MatIcon,
  matIconLooksOne as MatIcon,
  matIconLooksTwo as MatIcon,
  matIconLooks as MatIcon,
  matIconLoop as MatIcon,
  matIconLoupe as MatIcon,
  matIconLowPriority as MatIcon,
  matIconLoyalty as MatIcon,
  matIconLteMobiledata as MatIcon,
  matIconLtePlusMobiledata as MatIcon,
  matIconLuggage as MatIcon,
  matIconLunchDining as MatIcon,
  matIconLyrics as MatIcon,
  matIconMacroOff as MatIcon,
  matIconMailLock as MatIcon,
  matIconMailOutline as MatIcon,
  matIconMail as MatIcon,
  matIconMale as MatIcon,
  matIconMan2 as MatIcon,
  matIconMan3 as MatIcon,
  matIconMan4 as MatIcon,
  matIconMan as MatIcon,
  matIconManageAccounts as MatIcon,
  matIconManageHistory as MatIcon,
  matIconManageSearch as MatIcon,
  matIconMap as MatIcon,
  matIconMapsHomeWork as MatIcon,
  matIconMapsUgc as MatIcon,
  matIconMargin as MatIcon,
  matIconMarkAsUnread as MatIcon,
  matIconMarkChatRead as MatIcon,
  matIconMarkChatUnread as MatIcon,
  matIconMarkEmailRead as MatIcon,
  matIconMarkEmailUnread as MatIcon,
  matIconMarkUnreadChatAlt as MatIcon,
  matIconMarkunreadMailbox as MatIcon,
  matIconMarkunread as MatIcon,
  matIconMasks as MatIcon,
  matIconMaximize as MatIcon,
  matIconMediaBluetoothOff as MatIcon,
  matIconMediaBluetoothOn as MatIcon,
  matIconMediation as MatIcon,
  matIconMedicalInformation as MatIcon,
  matIconMedicalServices as MatIcon,
  matIconMedicationLiquid as MatIcon,
  matIconMedication as MatIcon,
  matIconMeetingRoom as MatIcon,
  matIconMemory as MatIcon,
  matIconMenuBook as MatIcon,
  matIconMenuOpen as MatIcon,
  matIconMenu as MatIcon,
  matIconMergeType as MatIcon,
  matIconMerge as MatIcon,
  matIconMessage as MatIcon,
  matIconMicExternalOff as MatIcon,
  matIconMicExternalOn as MatIcon,
  matIconMicNone as MatIcon,
  matIconMicOff as MatIcon,
  matIconMic as MatIcon,
  matIconMicrowave as MatIcon,
  matIconMilitaryTech as MatIcon,
  matIconMinimize as MatIcon,
  matIconMinorCrash as MatIcon,
  matIconMiscellaneousServices as MatIcon,
  matIconMissedVideoCall as MatIcon,
  matIconMms as MatIcon,
  matIconMobileFriendly as MatIcon,
  matIconMobileOff as MatIcon,
  matIconMobileScreenShare as MatIcon,
  matIconMobiledataOff as MatIcon,
  matIconModeComment as MatIcon,
  matIconModeEditOutline as MatIcon,
  matIconModeEdit as MatIcon,
  matIconModeFanOff as MatIcon,
  matIconModeNight as MatIcon,
  matIconModeOfTravel as MatIcon,
  matIconModeStandby as MatIcon,
  matIconMode as MatIcon,
  matIconModelTraining as MatIcon,
  matIconMonetizationOn as MatIcon,
  matIconMoneyOffCsred as MatIcon,
  matIconMoneyOff as MatIcon,
  matIconMoney as MatIcon,
  matIconMonitorHeart as MatIcon,
  matIconMonitorWeight as MatIcon,
  matIconMonitor as MatIcon,
  matIconMonochromePhotos as MatIcon,
  matIconMoodBad as MatIcon,
  matIconMood as MatIcon,
  matIconMoped as MatIcon,
  matIconMoreHoriz as MatIcon,
  matIconMoreTime as MatIcon,
  matIconMoreVert as MatIcon,
  matIconMore as MatIcon,
  matIconMosque as MatIcon,
  matIconMotionPhotosAuto as MatIcon,
  matIconMotionPhotosOff as MatIcon,
  matIconMotionPhotosOn as MatIcon,
  matIconMotionPhotosPause as MatIcon,
  matIconMotionPhotosPaused as MatIcon,
  matIconMouse as MatIcon,
  matIconMoveDown as MatIcon,
  matIconMoveToInbox as MatIcon,
  matIconMoveUp as MatIcon,
  matIconMovieCreation as MatIcon,
  matIconMovieFilter as MatIcon,
  matIconMovie as MatIcon,
  matIconMoving as MatIcon,
  matIconMp as MatIcon,
  matIconMultilineChart as MatIcon,
  matIconMultipleStop as MatIcon,
  matIconMuseum as MatIcon,
  matIconMusicNote as MatIcon,
  matIconMusicOff as MatIcon,
  matIconMusicVideo as MatIcon,
  matIconMyLocation as MatIcon,
  matIconNat as MatIcon,
  matIconNaturePeople as MatIcon,
  matIconNature as MatIcon,
  matIconNavigateBefore as MatIcon,
  matIconNavigateNext as MatIcon,
  matIconNavigation as MatIcon,
  matIconNearMeDisabled as MatIcon,
  matIconNearMe as MatIcon,
  matIconNearbyError as MatIcon,
  matIconNearbyOff as MatIcon,
  matIconNestCamWiredStand as MatIcon,
  matIconNetworkCell as MatIcon,
  matIconNetworkCheck as MatIcon,
  matIconNetworkLocked as MatIcon,
  matIconNetworkPing as MatIcon,
  matIconNetworkWifi1Bar as MatIcon,
  matIconNetworkWifi2Bar as MatIcon,
  matIconNetworkWifi3Bar as MatIcon,
  matIconNetworkWifi as MatIcon,
  matIconNewLabel as MatIcon,
  matIconNewReleases as MatIcon,
  matIconNewspaper as MatIcon,
  matIconNextPlan as MatIcon,
  matIconNextWeek as MatIcon,
  matIconNfc as MatIcon,
  matIconNightShelter as MatIcon,
  matIconNightlife as MatIcon,
  matIconNightlightRound as MatIcon,
  matIconNightlight as MatIcon,
  matIconNightsStay as MatIcon,
  matIconNoAccounts as MatIcon,
  matIconNoAdultContent as MatIcon,
  matIconNoBackpack as MatIcon,
  matIconNoCell as MatIcon,
  matIconNoCrash as MatIcon,
  matIconNoDrinks as MatIcon,
  matIconNoEncryptionGmailerrorred as MatIcon,
  matIconNoEncryption as MatIcon,
  matIconNoFlash as MatIcon,
  matIconNoFood as MatIcon,
  matIconNoLuggage as MatIcon,
  matIconNoMeals as MatIcon,
  matIconNoMeetingRoom as MatIcon,
  matIconNoPhotography as MatIcon,
  matIconNoSim as MatIcon,
  matIconNoStroller as MatIcon,
  matIconNoTransfer as MatIcon,
  matIconNoiseAware as MatIcon,
  matIconNoiseControlOff as MatIcon,
  matIconNordicWalking as MatIcon,
  matIconNorthEast as MatIcon,
  matIconNorthWest as MatIcon,
  matIconNorth as MatIcon,
  matIconNotAccessible as MatIcon,
  matIconNotInterested as MatIcon,
  matIconNotListedLocation as MatIcon,
  matIconNotStarted as MatIcon,
  matIconNoteAdd as MatIcon,
  matIconNoteAlt as MatIcon,
  matIconNote as MatIcon,
  matIconNotes as MatIcon,
  matIconNotificationAdd as MatIcon,
  matIconNotificationImportant as MatIcon,
  matIconNotificationsActive as MatIcon,
  matIconNotificationsNone as MatIcon,
  matIconNotificationsOff as MatIcon,
  matIconNotificationsPaused as MatIcon,
  matIconNotifications as MatIcon,
  matIconNumbers as MatIcon,
  matIconOfflineBolt as MatIcon,
  matIconOfflinePin as MatIcon,
  matIconOfflineShare as MatIcon,
  matIconOilBarrel as MatIcon,
  matIconOnDeviceTraining as MatIcon,
  matIconOndemandVideo as MatIcon,
  matIconOnlinePrediction as MatIcon,
  matIconOpacity as MatIcon,
  matIconOpenInBrowser as MatIcon,
  matIconOpenInFull as MatIcon,
  matIconOpenInNewOff as MatIcon,
  matIconOpenInNew as MatIcon,
  matIconOpenWith as MatIcon,
  matIconOtherHouses as MatIcon,
  matIconOutbound as MatIcon,
  matIconOutbox as MatIcon,
  matIconOutdoorGrill as MatIcon,
  matIconOutlet as MatIcon,
  matIconOutlinedFlag as MatIcon,
  matIconOutput as MatIcon,
  matIconPadding as MatIcon,
  matIconPages as MatIcon,
  matIconPageview as MatIcon,
  matIconPaid as MatIcon,
  matIconPalette as MatIcon,
  matIconPanToolAlt as MatIcon,
  matIconPanTool as MatIcon,
  matIconPanoramaFishEye as MatIcon,
  matIconPanoramaHorizontalSelect as MatIcon,
  matIconPanoramaHorizontal as MatIcon,
  matIconPanoramaPhotosphereSelect as MatIcon,
  matIconPanoramaPhotosphere as MatIcon,
  matIconPanoramaVerticalSelect as MatIcon,
  matIconPanoramaVertical as MatIcon,
  matIconPanoramaWideAngleSelect as MatIcon,
  matIconPanoramaWideAngle as MatIcon,
  matIconPanorama as MatIcon,
  matIconParagliding as MatIcon,
  matIconPark as MatIcon,
  matIconPartyMode as MatIcon,
  matIconPassword as MatIcon,
  matIconPattern as MatIcon,
  matIconPauseCircleFilled as MatIcon,
  matIconPauseCircleOutline as MatIcon,
  matIconPauseCircle as MatIcon,
  matIconPausePresentation as MatIcon,
  matIconPause as MatIcon,
  matIconPayment as MatIcon,
  matIconPayments as MatIcon,
  matIconPedalBike as MatIcon,
  matIconPendingActions as MatIcon,
  matIconPending as MatIcon,
  matIconPentagon as MatIcon,
  matIconPeopleAlt as MatIcon,
  matIconPeopleOutline as MatIcon,
  matIconPeople as MatIcon,
  matIconPercent as MatIcon,
  matIconPermCameraMic as MatIcon,
  matIconPermContactCalendar as MatIcon,
  matIconPermDataSetting as MatIcon,
  matIconPermDeviceInformation as MatIcon,
  matIconPermIdentity as MatIcon,
  matIconPermMedia as MatIcon,
  matIconPermPhoneMsg as MatIcon,
  matIconPermScanWifi as MatIcon,
  matIconPerson2 as MatIcon,
  matIconPerson3 as MatIcon,
  matIconPerson4 as MatIcon,
  matIconPersonAddAlt1 as MatIcon,
  matIconPersonAddAlt as MatIcon,
  matIconPersonAddDisabled as MatIcon,
  matIconPersonAdd as MatIcon,
  matIconPersonOff as MatIcon,
  matIconPersonOutline as MatIcon,
  matIconPersonPinCircle as MatIcon,
  matIconPersonPin as MatIcon,
  matIconPersonRemoveAlt1 as MatIcon,
  matIconPersonRemove as MatIcon,
  matIconPersonSearch as MatIcon,
  matIconPerson as MatIcon,
  matIconPersonalInjury as MatIcon,
  matIconPersonalVideo as MatIcon,
  matIconPestControlRodent as MatIcon,
  matIconPestControl as MatIcon,
  matIconPets as MatIcon,
  matIconPhishing as MatIcon,
  matIconPhoneAndroid as MatIcon,
  matIconPhoneBluetoothSpeaker as MatIcon,
  matIconPhoneCallback as MatIcon,
  matIconPhoneDisabled as MatIcon,
  matIconPhoneEnabled as MatIcon,
  matIconPhoneForwarded as MatIcon,
  matIconPhoneIphone as MatIcon,
  matIconPhoneLocked as MatIcon,
  matIconPhoneMissed as MatIcon,
  matIconPhonePaused as MatIcon,
  matIconPhone as MatIcon,
  matIconPhonelinkErase as MatIcon,
  matIconPhonelinkLock as MatIcon,
  matIconPhonelinkOff as MatIcon,
  matIconPhonelinkRing as MatIcon,
  matIconPhonelinkSetup as MatIcon,
  matIconPhonelink as MatIcon,
  matIconPhotoAlbum as MatIcon,
  matIconPhotoCameraBack as MatIcon,
  matIconPhotoCameraFront as MatIcon,
  matIconPhotoCamera as MatIcon,
  matIconPhotoFilter as MatIcon,
  matIconPhotoLibrary as MatIcon,
  matIconPhotoSizeSelectActual as MatIcon,
  matIconPhotoSizeSelectLarge as MatIcon,
  matIconPhotoSizeSelectSmall as MatIcon,
  matIconPhoto as MatIcon,
  matIconPhp as MatIcon,
  matIconPianoOff as MatIcon,
  matIconPiano as MatIcon,
  matIconPictureAsPdf as MatIcon,
  matIconPictureInPictureAlt as MatIcon,
  matIconPictureInPicture as MatIcon,
  matIconPieChartOutline as MatIcon,
  matIconPieChart as MatIcon,
  matIconPinDrop as MatIcon,
  matIconPinEnd as MatIcon,
  matIconPinInvoke as MatIcon,
  matIconPin as MatIcon,
  matIconPinch as MatIcon,
  matIconPivotTableChart as MatIcon,
  matIconPix as MatIcon,
  matIconPlace as MatIcon,
  matIconPlagiarism as MatIcon,
  matIconPlayArrow as MatIcon,
  matIconPlayCircleFilled as MatIcon,
  matIconPlayCircleOutline as MatIcon,
  matIconPlayCircle as MatIcon,
  matIconPlayDisabled as MatIcon,
  matIconPlayForWork as MatIcon,
  matIconPlayLesson as MatIcon,
  matIconPlaylistAddCheckCircle as MatIcon,
  matIconPlaylistAddCheck as MatIcon,
  matIconPlaylistAddCircle as MatIcon,
  matIconPlaylistAdd as MatIcon,
  matIconPlaylistPlay as MatIcon,
  matIconPlaylistRemove as MatIcon,
  matIconPlumbing as MatIcon,
  matIconPlusOne as MatIcon,
  matIconPodcasts as MatIcon,
  matIconPointOfSale as MatIcon,
  matIconPolicy as MatIcon,
  matIconPoll as MatIcon,
  matIconPolyline as MatIcon,
  matIconPolymer as MatIcon,
  matIconPool as MatIcon,
  matIconPortableWifiOff as MatIcon,
  matIconPortrait as MatIcon,
  matIconPostAdd as MatIcon,
  matIconPowerInput as MatIcon,
  matIconPowerOff as MatIcon,
  matIconPowerSettingsNew as MatIcon,
  matIconPower as MatIcon,
  matIconPrecisionManufacturing as MatIcon,
  matIconPregnantWoman as MatIcon,
  matIconPresentToAll as MatIcon,
  matIconPreview as MatIcon,
  matIconPriceChange as MatIcon,
  matIconPriceCheck as MatIcon,
  matIconPrintDisabled as MatIcon,
  matIconPrint as MatIcon,
  matIconPriorityHigh as MatIcon,
  matIconPrivacyTip as MatIcon,
  matIconPrivateConnectivity as MatIcon,
  matIconProductionQuantityLimits as MatIcon,
  matIconPropaneTank as MatIcon,
  matIconPropane as MatIcon,
  matIconPsychologyAlt as MatIcon,
  matIconPsychology as MatIcon,
  matIconPublicOff as MatIcon,
  matIconPublic as MatIcon,
  matIconPublish as MatIcon,
  matIconPublishedWithChanges as MatIcon,
  matIconPunchClock as MatIcon,
  matIconPushPin as MatIcon,
  matIconQrCode2 as MatIcon,
  matIconQrCodeScanner as MatIcon,
  matIconQrCode as MatIcon,
  matIconQueryBuilder as MatIcon,
  matIconQueryStats as MatIcon,
  matIconQuestionAnswer as MatIcon,
  matIconQuestionMark as MatIcon,
  matIconQueueMusic as MatIcon,
  matIconQueuePlayNext as MatIcon,
  matIconQueue as MatIcon,
  matIconQuickreply as MatIcon,
  matIconQuiz as MatIcon,
  matIconRMobiledata as MatIcon,
  matIconRadar as MatIcon,
  matIconRadioButtonChecked as MatIcon,
  matIconRadioButtonUnchecked as MatIcon,
  matIconRadio as MatIcon,
  matIconRailwayAlert as MatIcon,
  matIconRamenDining as MatIcon,
  matIconRampLeft as MatIcon,
  matIconRampRight as MatIcon,
  matIconRateReview as MatIcon,
  matIconRawOff as MatIcon,
  matIconRawOn as MatIcon,
  matIconReadMore as MatIcon,
  matIconRealEstateAgent as MatIcon,
  matIconReceiptLong as MatIcon,
  matIconReceipt as MatIcon,
  matIconRecentActors as MatIcon,
  matIconRecommend as MatIcon,
  matIconRecordVoiceOver as MatIcon,
  matIconRectangle as MatIcon,
  matIconRecycling as MatIcon,
  matIconRedeem as MatIcon,
  matIconRedo as MatIcon,
  matIconReduceCapacity as MatIcon,
  matIconRefresh as MatIcon,
  matIconRememberMe as MatIcon,
  matIconRemoveCircleOutline as MatIcon,
  matIconRemoveCircle as MatIcon,
  matIconRemoveDone as MatIcon,
  matIconRemoveFromQueue as MatIcon,
  matIconRemoveModerator as MatIcon,
  matIconRemoveRedEye as MatIcon,
  matIconRemoveRoad as MatIcon,
  matIconRemoveShoppingCart as MatIcon,
  matIconRemove as MatIcon,
  matIconReorder as MatIcon,
  matIconRepartition as MatIcon,
  matIconRepeatOn as MatIcon,
  matIconRepeatOneOn as MatIcon,
  matIconRepeatOne as MatIcon,
  matIconRepeat as MatIcon,
  matIconReplay10 as MatIcon,
  matIconReplay30 as MatIcon,
  matIconReplay5 as MatIcon,
  matIconReplayCircleFilled as MatIcon,
  matIconReplay as MatIcon,
  matIconReplyAll as MatIcon,
  matIconReply as MatIcon,
  matIconReportGmailerrorred as MatIcon,
  matIconReportOff as MatIcon,
  matIconReportProblem as MatIcon,
  matIconReport as MatIcon,
  matIconRequestPage as MatIcon,
  matIconRequestQuote as MatIcon,
  matIconResetTv as MatIcon,
  matIconRestartAlt as MatIcon,
  matIconRestaurantMenu as MatIcon,
  matIconRestaurant as MatIcon,
  matIconRestoreFromTrash as MatIcon,
  matIconRestorePage as MatIcon,
  matIconRestore as MatIcon,
  matIconReviews as MatIcon,
  matIconRiceBowl as MatIcon,
  matIconRingVolume as MatIcon,
  matIconRocketLaunch as MatIcon,
  matIconRocket as MatIcon,
  matIconRollerShadesClosed as MatIcon,
  matIconRollerShades as MatIcon,
  matIconRollerSkating as MatIcon,
  matIconRoofing as MatIcon,
  matIconRoomPreferences as MatIcon,
  matIconRoomService as MatIcon,
  matIconRoom as MatIcon,
  matIconRotate90DegreesCcw as MatIcon,
  matIconRotate90DegreesCw as MatIcon,
  matIconRotateLeft as MatIcon,
  matIconRotateRight as MatIcon,
  matIconRoundaboutLeft as MatIcon,
  matIconRoundaboutRight as MatIcon,
  matIconRoundedCorner as MatIcon,
  matIconRoute as MatIcon,
  matIconRouter as MatIcon,
  matIconRowing as MatIcon,
  matIconRssFeed as MatIcon,
  matIconRsvp as MatIcon,
  matIconRtt as MatIcon,
  matIconRuleFolder as MatIcon,
  matIconRule as MatIcon,
  matIconRunCircle as MatIcon,
  matIconRunningWithErrors as MatIcon,
  matIconRvHookup as MatIcon,
  matIconSafetyCheck as MatIcon,
  matIconSafetyDivider as MatIcon,
  matIconSailing as MatIcon,
  matIconSanitizer as MatIcon,
  matIconSatelliteAlt as MatIcon,
  matIconSatellite as MatIcon,
  matIconSaveAlt as MatIcon,
  matIconSaveAs as MatIcon,
  matIconSave as MatIcon,
  matIconSavedSearch as MatIcon,
  matIconSavings as MatIcon,
  matIconScale as MatIcon,
  matIconScanner as MatIcon,
  matIconScatterPlot as MatIcon,
  matIconScheduleSend as MatIcon,
  matIconSchedule as MatIcon,
  matIconSchema as MatIcon,
  matIconSchool as MatIcon,
  matIconScience as MatIcon,
  matIconScore as MatIcon,
  matIconScoreboard as MatIcon,
  matIconScreenLockLandscape as MatIcon,
  matIconScreenLockPortrait as MatIcon,
  matIconScreenLockRotation as MatIcon,
  matIconScreenRotationAlt as MatIcon,
  matIconScreenRotation as MatIcon,
  matIconScreenSearchDesktop as MatIcon,
  matIconScreenShare as MatIcon,
  matIconScreenshotMonitor as MatIcon,
  matIconScreenshot as MatIcon,
  matIconScubaDiving as MatIcon,
  matIconSdCardAlert as MatIcon,
  matIconSdCard as MatIcon,
  matIconSdStorage as MatIcon,
  matIconSd as MatIcon,
  matIconSearchOff as MatIcon,
  matIconSearch as MatIcon,
  matIconSecurityUpdateGood as MatIcon,
  matIconSecurityUpdateWarning as MatIcon,
  matIconSecurityUpdate as MatIcon,
  matIconSecurity as MatIcon,
  matIconSegment as MatIcon,
  matIconSelectAll as MatIcon,
  matIconSelfImprovement as MatIcon,
  matIconSell as MatIcon,
  matIconSendAndArchive as MatIcon,
  matIconSendTimeExtension as MatIcon,
  matIconSendToMobile as MatIcon,
  matIconSend as MatIcon,
  matIconSensorDoor as MatIcon,
  matIconSensorOccupied as MatIcon,
  matIconSensorWindow as MatIcon,
  matIconSensorsOff as MatIcon,
  matIconSensors as MatIcon,
  matIconSentimentDissatisfied as MatIcon,
  matIconSentimentNeutral as MatIcon,
  matIconSentimentSatisfiedAlt as MatIcon,
  matIconSentimentSatisfied as MatIcon,
  matIconSentimentVeryDissatisfied as MatIcon,
  matIconSentimentVerySatisfied as MatIcon,
  matIconSetMeal as MatIcon,
  matIconSettingsAccessibility as MatIcon,
  matIconSettingsApplications as MatIcon,
  matIconSettingsBackupRestore as MatIcon,
  matIconSettingsBluetooth as MatIcon,
  matIconSettingsBrightness as MatIcon,
  matIconSettingsCell as MatIcon,
  matIconSettingsEthernet as MatIcon,
  matIconSettingsInputAntenna as MatIcon,
  matIconSettingsInputComponent as MatIcon,
  matIconSettingsInputComposite as MatIcon,
  matIconSettingsInputHdmi as MatIcon,
  matIconSettingsInputSvideo as MatIcon,
  matIconSettingsOverscan as MatIcon,
  matIconSettingsPhone as MatIcon,
  matIconSettingsPower as MatIcon,
  matIconSettingsRemote as MatIcon,
  matIconSettingsSuggest as MatIcon,
  matIconSettingsSystemDaydream as MatIcon,
  matIconSettingsVoice as MatIcon,
  matIconSettings as MatIcon,
  matIconSevereCold as MatIcon,
  matIconShapeLine as MatIcon,
  matIconShareLocation as MatIcon,
  matIconShare as MatIcon,
  matIconShieldMoon as MatIcon,
  matIconShield as MatIcon,
  matIconShop2 as MatIcon,
  matIconShopTwo as MatIcon,
  matIconShop as MatIcon,
  matIconShoppingBag as MatIcon,
  matIconShoppingBasket as MatIcon,
  matIconShoppingCartCheckout as MatIcon,
  matIconShoppingCart as MatIcon,
  matIconShortText as MatIcon,
  matIconShortcut as MatIcon,
  matIconShowChart as MatIcon,
  matIconShower as MatIcon,
  matIconShuffleOn as MatIcon,
  matIconShuffle as MatIcon,
  matIconShutterSpeed as MatIcon,
  matIconSick as MatIcon,
  matIconSignLanguage as MatIcon,
  matIconSignalCellular0Bar as MatIcon,
  matIconSignalCellular4Bar as MatIcon,
  matIconSignalCellularAlt1Bar as MatIcon,
  matIconSignalCellularAlt2Bar as MatIcon,
  matIconSignalCellularAlt as MatIcon,
  matIconSignalCellularConnectedNoInternet0Bar as MatIcon,
  matIconSignalCellularConnectedNoInternet4Bar as MatIcon,
  matIconSignalCellularNoSim as MatIcon,
  matIconSignalCellularNodata as MatIcon,
  matIconSignalCellularNull as MatIcon,
  matIconSignalCellularOff as MatIcon,
  matIconSignalWifi0Bar as MatIcon,
  matIconSignalWifi4BarLock as MatIcon,
  matIconSignalWifi4Bar as MatIcon,
  matIconSignalWifiBad as MatIcon,
  matIconSignalWifiConnectedNoInternet4 as MatIcon,
  matIconSignalWifiOff as MatIcon,
  matIconSignalWifiStatusbar4Bar as MatIcon,
  matIconSignalWifiStatusbarConnectedNoInternet4 as MatIcon,
  matIconSignalWifiStatusbarNull as MatIcon,
  matIconSignpost as MatIcon,
  matIconSimCardAlert as MatIcon,
  matIconSimCardDownload as MatIcon,
  matIconSimCard as MatIcon,
  matIconSingleBed as MatIcon,
  matIconSip as MatIcon,
  matIconSkateboarding as MatIcon,
  matIconSkipNext as MatIcon,
  matIconSkipPrevious as MatIcon,
  matIconSledding as MatIcon,
  matIconSlideshow as MatIcon,
  matIconSlowMotionVideo as MatIcon,
  matIconSmartButton as MatIcon,
  matIconSmartDisplay as MatIcon,
  matIconSmartScreen as MatIcon,
  matIconSmartToy as MatIcon,
  matIconSmartphone as MatIcon,
  matIconSmokeFree as MatIcon,
  matIconSmokingRooms as MatIcon,
  matIconSmsFailed as MatIcon,
  matIconSms as MatIcon,
  matIconSnippetFolder as MatIcon,
  matIconSnooze as MatIcon,
  matIconSnowboarding as MatIcon,
  matIconSnowmobile as MatIcon,
  matIconSnowshoeing as MatIcon,
  matIconSoap as MatIcon,
  matIconSocialDistance as MatIcon,
  matIconSolarPower as MatIcon,
  matIconSortByAlpha as MatIcon,
  matIconSort as MatIcon,
  matIconSos as MatIcon,
  matIconSoupKitchen as MatIcon,
  matIconSource as MatIcon,
  matIconSouthAmerica as MatIcon,
  matIconSouthEast as MatIcon,
  matIconSouthWest as MatIcon,
  matIconSouth as MatIcon,
  matIconSpa as MatIcon,
  matIconSpaceBar as MatIcon,
  matIconSpaceDashboard as MatIcon,
  matIconSpatialAudioOff as MatIcon,
  matIconSpatialAudio as MatIcon,
  matIconSpatialTracking as MatIcon,
  matIconSpeakerGroup as MatIcon,
  matIconSpeakerNotesOff as MatIcon,
  matIconSpeakerNotes as MatIcon,
  matIconSpeakerPhone as MatIcon,
  matIconSpeaker as MatIcon,
  matIconSpeed as MatIcon,
  matIconSpellcheck as MatIcon,
  matIconSplitscreen as MatIcon,
  matIconSpoke as MatIcon,
  matIconSportsBar as MatIcon,
  matIconSportsBaseball as MatIcon,
  matIconSportsBasketball as MatIcon,
  matIconSportsCricket as MatIcon,
  matIconSportsEsports as MatIcon,
  matIconSportsFootball as MatIcon,
  matIconSportsGolf as MatIcon,
  matIconSportsGymnastics as MatIcon,
  matIconSportsHandball as MatIcon,
  matIconSportsHockey as MatIcon,
  matIconSportsKabaddi as MatIcon,
  matIconSportsMartialArts as MatIcon,
  matIconSportsMma as MatIcon,
  matIconSportsMotorsports as MatIcon,
  matIconSportsRugby as MatIcon,
  matIconSportsScore as MatIcon,
  matIconSportsSoccer as MatIcon,
  matIconSportsTennis as MatIcon,
  matIconSportsVolleyball as MatIcon,
  matIconSports as MatIcon,
  matIconSquareFoot as MatIcon,
  matIconSquare as MatIcon,
  matIconSsidChart as MatIcon,
  matIconStackedBarChart as MatIcon,
  matIconStackedLineChart as MatIcon,
  matIconStadium as MatIcon,
  matIconStairs as MatIcon,
  matIconStarBorderPurple500 as MatIcon,
  matIconStarBorder as MatIcon,
  matIconStarHalf as MatIcon,
  matIconStarOutline as MatIcon,
  matIconStarPurple500 as MatIcon,
  matIconStarRate as MatIcon,
  matIconStar as MatIcon,
  matIconStars as MatIcon,
  matIconStart as MatIcon,
  matIconStayCurrentLandscape as MatIcon,
  matIconStayCurrentPortrait as MatIcon,
  matIconStayPrimaryLandscape as MatIcon,
  matIconStayPrimaryPortrait as MatIcon,
  matIconStickyNote2 as MatIcon,
  matIconStopCircle as MatIcon,
  matIconStopScreenShare as MatIcon,
  matIconStop as MatIcon,
  matIconStorage as MatIcon,
  matIconStoreMallDirectory as MatIcon,
  matIconStore as MatIcon,
  matIconStorefront as MatIcon,
  matIconStorm as MatIcon,
  matIconStraight as MatIcon,
  matIconStraighten as MatIcon,
  matIconStream as MatIcon,
  matIconStreetview as MatIcon,
  matIconStrikethroughS as MatIcon,
  matIconStroller as MatIcon,
  matIconStyle as MatIcon,
  matIconSubdirectoryArrowLeft as MatIcon,
  matIconSubdirectoryArrowRight as MatIcon,
  matIconSubject as MatIcon,
  matIconSubscript as MatIcon,
  matIconSubscriptions as MatIcon,
  matIconSubtitlesOff as MatIcon,
  matIconSubtitles as MatIcon,
  matIconSubway as MatIcon,
  matIconSummarize as MatIcon,
  matIconSuperscript as MatIcon,
  matIconSupervisedUserCircle as MatIcon,
  matIconSupervisorAccount as MatIcon,
  matIconSupportAgent as MatIcon,
  matIconSupport as MatIcon,
  matIconSurfing as MatIcon,
  matIconSurroundSound as MatIcon,
  matIconSwapCalls as MatIcon,
  matIconSwapHoriz as MatIcon,
  matIconSwapHorizontalCircle as MatIcon,
  matIconSwapVert as MatIcon,
  matIconSwapVerticalCircle as MatIcon,
  matIconSwipeDownAlt as MatIcon,
  matIconSwipeDown as MatIcon,
  matIconSwipeLeftAlt as MatIcon,
  matIconSwipeLeft as MatIcon,
  matIconSwipeRightAlt as MatIcon,
  matIconSwipeRight as MatIcon,
  matIconSwipeUpAlt as MatIcon,
  matIconSwipeUp as MatIcon,
  matIconSwipeVertical as MatIcon,
  matIconSwipe as MatIcon,
  matIconSwitchAccessShortcutAdd as MatIcon,
  matIconSwitchAccessShortcut as MatIcon,
  matIconSwitchAccount as MatIcon,
  matIconSwitchCamera as MatIcon,
  matIconSwitchLeft as MatIcon,
  matIconSwitchRight as MatIcon,
  matIconSwitchVideo as MatIcon,
  matIconSynagogue as MatIcon,
  matIconSyncAlt as MatIcon,
  matIconSyncDisabled as MatIcon,
  matIconSyncLock as MatIcon,
  matIconSyncProblem as MatIcon,
  matIconSync as MatIcon,
  matIconSystemSecurityUpdateGood as MatIcon,
  matIconSystemSecurityUpdateWarning as MatIcon,
  matIconSystemSecurityUpdate as MatIcon,
  matIconSystemUpdateAlt as MatIcon,
  matIconSystemUpdate as MatIcon,
  matIconTabUnselected as MatIcon,
  matIconTab as MatIcon,
  matIconTableBar as MatIcon,
  matIconTableChart as MatIcon,
  matIconTableRestaurant as MatIcon,
  matIconTableRows as MatIcon,
  matIconTableView as MatIcon,
  matIconTabletAndroid as MatIcon,
  matIconTabletMac as MatIcon,
  matIconTablet as MatIcon,
  matIconTagFaces as MatIcon,
  matIconTag as MatIcon,
  matIconTakeoutDining as MatIcon,
  matIconTapAndPlay as MatIcon,
  matIconTapas as MatIcon,
  matIconTaskAlt as MatIcon,
  matIconTask as MatIcon,
  matIconTaxiAlert as MatIcon,
  matIconTempleBuddhist as MatIcon,
  matIconTempleHindu as MatIcon,
  matIconTerminal as MatIcon,
  matIconTerrain as MatIcon,
  matIconTextDecrease as MatIcon,
  matIconTextFields as MatIcon,
  matIconTextFormat as MatIcon,
  matIconTextIncrease as MatIcon,
  matIconTextRotateUp as MatIcon,
  matIconTextRotateVertical as MatIcon,
  matIconTextRotationAngledown as MatIcon,
  matIconTextRotationAngleup as MatIcon,
  matIconTextRotationDown as MatIcon,
  matIconTextRotationNone as MatIcon,
  matIconTextSnippet as MatIcon,
  matIconTextsms as MatIcon,
  matIconTexture as MatIcon,
  matIconTheaterComedy as MatIcon,
  matIconTheaters as MatIcon,
  matIconThermostatAuto as MatIcon,
  matIconThermostat as MatIcon,
  matIconThumbDownAlt as MatIcon,
  matIconThumbDownOffAlt as MatIcon,
  matIconThumbDown as MatIcon,
  matIconThumbUpAlt as MatIcon,
  matIconThumbUpOffAlt as MatIcon,
  matIconThumbUp as MatIcon,
  matIconThumbsUpDown as MatIcon,
  matIconThunderstorm as MatIcon,
  matIconTimeToLeave as MatIcon,
  matIconTimelapse as MatIcon,
  matIconTimeline as MatIcon,
  matIconTimer10Select as MatIcon,
  matIconTimer10 as MatIcon,
  matIconTimer3Select as MatIcon,
  matIconTimer3 as MatIcon,
  matIconTimerOff as MatIcon,
  matIconTimer as MatIcon,
  matIconTipsAndUpdates as MatIcon,
  matIconTireRepair as MatIcon,
  matIconTitle as MatIcon,
  matIconToc as MatIcon,
  matIconToday as MatIcon,
  matIconToggleOff as MatIcon,
  matIconToggleOn as MatIcon,
  matIconToken as MatIcon,
  matIconToll as MatIcon,
  matIconTonality as MatIcon,
  matIconTopic as MatIcon,
  matIconTornado as MatIcon,
  matIconTouchApp as MatIcon,
  matIconTour as MatIcon,
  matIconToys as MatIcon,
  matIconTrackChanges as MatIcon,
  matIconTraffic as MatIcon,
  matIconTrain as MatIcon,
  matIconTram as MatIcon,
  matIconTranscribe as MatIcon,
  matIconTransferWithinAStation as MatIcon,
  matIconTransform as MatIcon,
  matIconTransgender as MatIcon,
  matIconTransitEnterexit as MatIcon,
  matIconTranslate as MatIcon,
  matIconTravelExplore as MatIcon,
  matIconTrendingDown as MatIcon,
  matIconTrendingFlat as MatIcon,
  matIconTrendingUp as MatIcon,
  matIconTripOrigin as MatIcon,
  matIconTroubleshoot as MatIcon,
  matIconTry as MatIcon,
  matIconTsunami as MatIcon,
  matIconTty as MatIcon,
  matIconTune as MatIcon,
  matIconTungsten as MatIcon,
  matIconTurnLeft as MatIcon,
  matIconTurnRight as MatIcon,
  matIconTurnSharpLeft as MatIcon,
  matIconTurnSharpRight as MatIcon,
  matIconTurnSlightLeft as MatIcon,
  matIconTurnSlightRight as MatIcon,
  matIconTurnedInNot as MatIcon,
  matIconTurnedIn as MatIcon,
  matIconTvOff as MatIcon,
  matIconTv as MatIcon,
  matIconTwoWheeler as MatIcon,
  matIconTypeSpecimen as MatIcon,
  matIconUTurnLeft as MatIcon,
  matIconUTurnRight as MatIcon,
  matIconUmbrella as MatIcon,
  matIconUnarchive as MatIcon,
  matIconUndo as MatIcon,
  matIconUnfoldLessDouble as MatIcon,
  matIconUnfoldLess as MatIcon,
  matIconUnfoldMoreDouble as MatIcon,
  matIconUnfoldMore as MatIcon,
  matIconUnpublished as MatIcon,
  matIconUnsubscribe as MatIcon,
  matIconUpcoming as MatIcon,
  matIconUpdateDisabled as MatIcon,
  matIconUpdate as MatIcon,
  matIconUpgrade as MatIcon,
  matIconUploadFile as MatIcon,
  matIconUpload as MatIcon,
  matIconUsbOff as MatIcon,
  matIconUsb as MatIcon,
  matIconVaccines as MatIcon,
  matIconVapeFree as MatIcon,
  matIconVapingRooms as MatIcon,
  matIconVerifiedUser as MatIcon,
  matIconVerified as MatIcon,
  matIconVerticalAlignBottom as MatIcon,
  matIconVerticalAlignCenter as MatIcon,
  matIconVerticalAlignTop as MatIcon,
  matIconVerticalDistribute as MatIcon,
  matIconVerticalShadesClosed as MatIcon,
  matIconVerticalShades as MatIcon,
  matIconVerticalSplit as MatIcon,
  matIconVibration as MatIcon,
  matIconVideoCall as MatIcon,
  matIconVideoCameraBack as MatIcon,
  matIconVideoCameraFront as MatIcon,
  matIconVideoChat as MatIcon,
  matIconVideoFile as MatIcon,
  matIconVideoLabel as MatIcon,
  matIconVideoLibrary as MatIcon,
  matIconVideoSettings as MatIcon,
  matIconVideoStable as MatIcon,
  matIconVideocamOff as MatIcon,
  matIconVideocam as MatIcon,
  matIconVideogameAssetOff as MatIcon,
  matIconVideogameAsset as MatIcon,
  matIconViewAgenda as MatIcon,
  matIconViewArray as MatIcon,
  matIconViewCarousel as MatIcon,
  matIconViewColumn as MatIcon,
  matIconViewComfyAlt as MatIcon,
  matIconViewComfy as MatIcon,
  matIconViewCompactAlt as MatIcon,
  matIconViewCompact as MatIcon,
  matIconViewCozy as MatIcon,
  matIconViewDay as MatIcon,
  matIconViewHeadline as MatIcon,
  matIconViewInAr as MatIcon,
  matIconViewKanban as MatIcon,
  matIconViewList as MatIcon,
  matIconViewModule as MatIcon,
  matIconViewQuilt as MatIcon,
  matIconViewSidebar as MatIcon,
  matIconViewStream as MatIcon,
  matIconViewTimeline as MatIcon,
  matIconViewWeek as MatIcon,
  matIconVignette as MatIcon,
  matIconVilla as MatIcon,
  matIconVisibilityOff as MatIcon,
  matIconVisibility as MatIcon,
  matIconVoiceChat as MatIcon,
  matIconVoiceOverOff as MatIcon,
  matIconVoicemail as MatIcon,
  matIconVolcano as MatIcon,
  matIconVolumeDown as MatIcon,
  matIconVolumeMute as MatIcon,
  matIconVolumeOff as MatIcon,
  matIconVolumeUp as MatIcon,
  matIconVolunteerActivism as MatIcon,
  matIconVpnKeyOff as MatIcon,
  matIconVpnKey as MatIcon,
  matIconVpnLock as MatIcon,
  matIconVrpano as MatIcon,
  matIconWallet as MatIcon,
  matIconWallpaper as MatIcon,
  matIconWarehouse as MatIcon,
  matIconWarningAmber as MatIcon,
  matIconWarning as MatIcon,
  matIconWash as MatIcon,
  matIconWatchLater as MatIcon,
  matIconWatchOff as MatIcon,
  matIconWatch as MatIcon,
  matIconWaterDamage as MatIcon,
  matIconWaterDrop as MatIcon,
  matIconWater as MatIcon,
  matIconWaterfallChart as MatIcon,
  matIconWaves as MatIcon,
  matIconWavingHand as MatIcon,
  matIconWbAuto as MatIcon,
  matIconWbCloudy as MatIcon,
  matIconWbIncandescent as MatIcon,
  matIconWbIridescent as MatIcon,
  matIconWbShade as MatIcon,
  matIconWbSunny as MatIcon,
  matIconWbTwilight as MatIcon,
  matIconWc as MatIcon,
  matIconWebAssetOff as MatIcon,
  matIconWebAsset as MatIcon,
  matIconWebStories as MatIcon,
  matIconWeb as MatIcon,
  matIconWebhook as MatIcon,
  matIconWeekend as MatIcon,
  matIconWest as MatIcon,
  matIconWhatshot as MatIcon,
  matIconWheelchairPickup as MatIcon,
  matIconWhereToVote as MatIcon,
  matIconWidgets as MatIcon,
  matIconWidthFull as MatIcon,
  matIconWidthNormal as MatIcon,
  matIconWidthWide as MatIcon,
  matIconWifi1Bar as MatIcon,
  matIconWifi2Bar as MatIcon,
  matIconWifiCalling3 as MatIcon,
  matIconWifiCalling as MatIcon,
  matIconWifiChannel as MatIcon,
  matIconWifiFind as MatIcon,
  matIconWifiLock as MatIcon,
  matIconWifiOff as MatIcon,
  matIconWifiPassword as MatIcon,
  matIconWifiProtectedSetup as MatIcon,
  matIconWifiTetheringError as MatIcon,
  matIconWifiTetheringOff as MatIcon,
  matIconWifiTethering as MatIcon,
  matIconWifi as MatIcon,
  matIconWindPower as MatIcon,
  matIconWindow as MatIcon,
  matIconWineBar as MatIcon,
  matIconWoman2 as MatIcon,
  matIconWoman as MatIcon,
  matIconWorkHistory as MatIcon,
  matIconWorkOff as MatIcon,
  matIconWorkOutline as MatIcon,
  matIconWork as MatIcon,
  matIconWorkspacePremium as MatIcon,
  matIconWorkspaces as MatIcon,
  matIconWrapText as MatIcon,
  matIconWrongLocation as MatIcon,
  matIconWysiwyg as MatIcon,
  matIconYard as MatIcon,
  matIconYoutubeSearchedFor as MatIcon,
  matIconZoomInMap as MatIcon,
  matIconZoomIn as MatIcon,
  matIconZoomOutMap as MatIcon,
  matIconZoomOut as MatIcon,
  matIconEyeglasses as MatIcon,
];
